/* eslint-disable */
/* prettier-ignore */

/**
 * This file is auto-generated with openapi2ts (@mittwald/openapi-to-typescript)
 */

import { OperationDescriptor, RequestFunction } from "@mittwald/api-client/dist/OperationDescriptor.js";
import { Client } from "@mittwald/api-client/dist/http/Client.js";
import { KyClient } from "@mittwald/api-client/dist/http/KyClient.js";

/**
 * ====================================
 * Types
 * ====================================
 */
export declare module MittwaldApi {
  namespace Paths {
    namespace V2_Contracts_ContractId {
      namespace Get {
        namespace Parameters {
          interface Path {
            contractId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Contract;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contracts_ContractId_Items_ContractItemId_Termination {
      namespace Delete {
        namespace Parameters {
          interface Path {
            contractId: string;
            contractItemId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                contractId?: string;
                contractItemId?: string;
                isCancelled?: boolean;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            contractId: string;
            contractItemId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            reason?: string;
            terminationTargetDate?: string;
          };
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = {
                contractId?: string;
                contractItemId?: string;
                reason?: string;
                terminationTargetDate?: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contracts_ContractId_Termination {
      namespace Delete {
        namespace Parameters {
          interface Path {
            contractId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                contractId?: string;
                isCancelled?: boolean;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            contractId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            reason?: string;
            terminationTargetDate?: string;
          };
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = {
                contractId?: string;
                itemsScheduledForTermination?: string[];
                reason?: string;
                terminationTargetDate?: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contracts_ContractId_Items_ContractItemId {
      namespace Get {
        namespace Parameters {
          interface Path {
            contractId: string;
            contractItemId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_ContractItem;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Contracts {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Contract[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Cronjobs {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobRequest;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_Cronjob[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Cronjobs_CronjobId_Executions {
      namespace Post {
        namespace Parameters {
          interface Path {
            cronjobId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            cronjobId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
            since?: string;
            until?: string;
            status?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobExecution[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Cronjobs_CronjobId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            cronjobId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            cronjobId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_Cronjob;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            cronjobId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            active?: boolean;
            description?: string;
            destination?:
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobUrl
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobCommand;
            email?: string;
            interval?: string;
            timeout?: number;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Cronjobs_CronjobId_Executions_ExecutionId {
      namespace Get {
        namespace Parameters {
          interface Path {
            executionId: string;
            cronjobId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobExecution;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Avatar {
      namespace Delete {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $401 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                refId: string;
                rules: {
                  maxSizeInKB: number;
                  mimeTypes: string[];
                  properties?: {
                    imageDimensions?: {
                      max?: {
                        height?: number;
                        width?: number;
                      };
                      min?: {
                        height?: number;
                        width?: number;
                      };
                    };
                  };
                };
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $401 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              interface Application_Json {}
            }
          }
        }
      }
    }

    namespace V2_Customers {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            name: string;
            owner?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Contact;
            vatId?: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                customerId: string;
                customerNumber: string;
                name: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Query {
            role?: string;
            search?: string;
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Customer[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerId?: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Customer;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            customerId: string;
            name: string;
            owner?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Contact;
            vatId?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerId: string;
                customerNumber: string;
                name: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Charsets {
      namespace Get {
        namespace Parameters {
          interface Query {
            version?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlCharacterSettings[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ingresses_IngressId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            ingressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            ingressId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Ingress;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ingresses {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            hostname: string;
            paths: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Path[];
            projectId: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
                ownership: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Ownership;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Query {
            projectId?: string;
            certificateId?: string;
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Ingress[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ingresses_IngressId_Paths {
      namespace Patch {
        namespace Parameters {
          interface Path {
            ingressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Path[];
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ingresses_IngressId_Tls {
      namespace Patch {
        namespace Parameters {
          interface Path {
            ingressId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            | {
                acme: boolean;
                isCreated?: boolean;
                requestDeadline?: string;
              }
            | {
                certificateId: string;
              };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Invoices {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            invoiceTypes?: (
              | "REGULAR"
              | "REISSUE"
              | "CORRECTION"
              | "CANCELLATION"
            )[];
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Invoice[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Jwt {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_FsApiJwt;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects {
      namespace Get {
        namespace Parameters {
          interface Query {
            customerId?: string;
            serverId?: string;
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json = {
                backupStorageUsageInBytes: number;
                backupStorageUsageInBytesSetAt: string;
                createdAt: string;
                customerId: string;
                customerMeta: {
                  id: string;
                };
                description: string;
                disableReason?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_DisableReason;
                disabledAt?: string;
                enabled: boolean;
                id: string;
                imageRefId?: string;
                isReady: boolean;
                projectHostingId?: string;
                readiness: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_DeprecatedProjectReadinessStatus;
                serverId?: string;
                shortId: string;
                status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_ProjectStatus;
                statusSetAt: string;
                webStorageUsageInBytes: number;
                webStorageUsageInBytesSetAt: string;
              }[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Orders {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
            includesStatus?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus[];
            excludesStatus?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus[];
            templateNames?: string[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_CustomerOrder[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Apps_AppId {
      namespace Get {
        namespace Parameters {
          interface Path {
            appId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_App;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Apps {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_App[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            categoryId?: string;
            mainUserId?: string;
            relatedTo?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_AggregateReference;
            sharedWith?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_ShareableAggregateReference;
            title?: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                conversationId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Conversation[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId_Messages {
      namespace Post {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            fileIds?: string[];
            messageContent?: string;
          };
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                conversationId: string;
                messageId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = (
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Message
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_StatusUpdate
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_ServiceRequest
              )[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId {
      namespace Get {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Conversation;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            categoryId?: string;
            relatedTo?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_AggregateReference;
            title?: string;
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                conversationId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId_Messages_MessageId {
      namespace Patch {
        namespace Parameters {
          interface Path {
            conversationId: string;
            messageId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            messageContent?: string;
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                messageId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_Project;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Articles_ArticleId {
      namespace Get {
        namespace Parameters {
          interface Path {
            articleId: string;
          }

          interface Query {
            customerId?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ReadableArticle;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Articles {
      namespace Get {
        namespace Parameters {
          interface Query {
            customerId?: string;
            tags?: string[];
            templateNames?: string[];
            articleIds?: string[];
            orderable?: (
              | "forbidden"
              | "internal"
              | "beta_testing"
              | "full"
              | "deprecated"
            )[];
            name?: string;
            limit?: number;
            skip?: number;
            page?: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ReadableArticle[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Avatar {
      namespace Delete {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                refId: string;
                rules: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_AvatarRules;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Legally_Competent {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                isLegallyCompetent?: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversation_Categories {
      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Category[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversation_Categories_CategoryId {
      namespace Get {
        namespace Parameters {
          interface Path {
            categoryId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Category;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change {
      namespace Delete {
        namespace Parameters {
          interface Path {
            contractId: string;
            contractItemId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                contractId?: string;
                contractItemId?: string;
                isCancelled?: boolean;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId_Status {
      namespace Put {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            status: "open" | "answered" | "closed";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                conversationId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Notifications {
      namespace Get {
        namespace Parameters {
          interface Query {
            status?: "unread" | "read";
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Messaging_Notification[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Orders_OrderId {
      namespace Get {
        namespace Parameters {
          interface Path {
            orderId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_CustomerOrder;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains {
      namespace Get {
        namespace Parameters {
          interface Query {
            projectId?: string;
            page?: number;
            limit?: number;
            domainSearchName?: string;
            contactHash?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_Domain[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Nameservers {
      namespace Patch {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            nameservers?: string[];
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Query {
            transit?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                isAsync?: boolean;
                transactionId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_Domain;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId_Files {
      namespace Post {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                conversationId: string;
                rules: {
                  maxSizeInKB: number;
                  mimeTypes: string[];
                  properties?: {
                    imageDimensions?: {
                      max?: {
                        height?: number;
                        width?: number;
                      };
                      min?: {
                        height?: number;
                        width?: number;
                      };
                    };
                  };
                };
                uploadToken: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Actions_Resend_Email {
      namespace Post {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Relocation {
      namespace Post {
        namespace Parameters {
          type Header = {};

          interface RequestBody {
            additionalServices: {
              dataCompare: "default" | "additionalCompare";
            };
            allDomains?: boolean;
            allowPasswordChange: boolean;
            articleType:
              | "cms-hosting"
              | "cms-hosting-express"
              | "onlineshop"
              | "onlineshop-express";
            contact: {
              email: string;
              firstName: string;
              lastName: string;
              phoneNumber?: string;
            };
            domains?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Directus_Domain[];
            notes?: string;
            prices: {
              positions: {
                name: string;
                price: number;
              }[];
              total: number;
            };
            provider: {
              loginUrl: string;
              name: string | "1und1" | "strato";
              password: string;
              sourceAccount: string;
              userName: string;
            };
            target: {
              organisation: string;
              product: string;
              projectName: string;
              system: "kc" | "mstudio";
            };
            userId?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Orders {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
            includesStatus?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus[];
            excludesStatus?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus[];
            templateNames?: string[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_CustomerOrder[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Invoice_Settings {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_InvoiceSettings;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            additionalEmailRecipients?: string[];
            invoicePeriod: number;
            paymentSettings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_PaymentSettings;
            printedInvoices?: boolean;
            recipient?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Recipient;
            recipientSameAsOwner?: boolean;
            targetDay?: number;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_InvoiceSettings;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Files {
      namespace Post {
        namespace Parameters {
          interface Header {
            Token: string;
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_File_FileMeta;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $406 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Backups {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            description?: string;
            expirationTime: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackup;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackup[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Backup_Schedules {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            description?: string;
            schedule: string;
            ttl: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackupSchedule;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackupSchedule[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Backups_ProjectBackupId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            projectBackupId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectBackupId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackup;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Backups_ProjectBackupId_Export {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectBackupId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            format: "tar" | "zip";
            password?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            projectBackupId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Backup_Schedules_ProjectBackupScheduleId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            projectBackupScheduleId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectBackupScheduleId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackupSchedule;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            projectBackupScheduleId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            description?: string;
            schedule?: string;
            ttl?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Backups_ProjectBackupId_Description {
      namespace Patch {
        namespace Parameters {
          interface Path {
            projectBackupId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            description?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Cronjobs_CronjobId_App_Id {
      namespace Patch {
        namespace Parameters {
          interface Path {
            cronjobId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            appId: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contracts_ContractId_Base_Items {
      namespace Get {
        namespace Parameters {
          interface Path {
            contractId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_ContractItem;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates {
      namespace Get {
        namespace Parameters {
          interface Path {
            contractId: string;
            contractItemId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                contractItemId: string;
                nextTerminationDate: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId_Avatar {
      namespace Delete {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                refId: string;
                rules: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_AvatarRules;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers {
      namespace Get {
        namespace Parameters {
          interface Query {
            customerId?: string;
            limit?: number;
            page?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_Server[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId {
      namespace Get {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_Server;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId_Projects {
      namespace Post {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            description: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId_Description {
      namespace Patch {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            description: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Mysql_Databases {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            database: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_CreateMySqlDatabase;
            user: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_CreateMySqlUserWithDatabase;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
                userId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlDatabase[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Redis_Databases {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            configuration?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_RedisDatabaseConfiguration;
            description: string;
            version: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_RedisDatabase[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Versions {
      namespace Get {
        namespace Parameters {
          interface Query {
            projectId?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlVersion[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Redis_Versions {
      namespace Get {
        namespace Parameters {
          interface Query {
            projectId?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_RedisVersion[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Token_Invite {
      namespace Get {
        namespace Parameters {
          interface Header {
            token: string;
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerInvite;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Invites {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            mailAddress: string;
            membershipExpiresAt?: string;
            message?: string;
            role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerRoles;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerInvite;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerInvite[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Memberships {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerMembership[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Token_Invite {
      namespace Get {
        namespace Parameters {
          interface Header {
            token: string;
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectInvite;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Invites {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            mailAddress: string;
            membershipExpiresAt?: string;
            message?: string;
            role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectRoles;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectInvite;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectInvite[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Invites {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerInvite[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Memberships {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerMembership[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Memberships {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectMembership[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Invites {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectInvite[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Memberships {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectMembership[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Categories {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Category;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                customerId?: string;
                isPublic?: boolean;
                name?: string;
                useAgencyDomainPrices?: boolean;
                useAgencySslPrices?: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                categories?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Category[];
              };
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Categories_CategoryId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            categoryId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            categoryId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Category;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            categoryId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Category;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerId?: string;
                isPublic?: boolean;
                name?: string;
                useAgencyDomainPrices?: boolean;
                useAgencySslPrices?: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Apps_AppId_Versions_AppVersionId {
      namespace Get {
        namespace Parameters {
          interface Path {
            appId: string;
            appVersionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppVersion;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Apps_AppId_Versions {
      namespace Get {
        namespace Parameters {
          interface Path {
            appId: string;
          }

          interface Query {
            recommended?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppVersion[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Sftp_Users_SftpUserId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            sftpUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            sftpUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_SftpUser;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            sftpUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            accessLevel?: "read" | "full";
            active?: boolean;
            description?: string;
            directories?: string[];
            expiresAt?: string;
            password?: string;
            publicKeys?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_PublicKey[];
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ssh_Users_SshUserId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            sshUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            sshUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_SshUser;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            sshUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            active?: boolean;
            description?: string;
            expiresAt?: string;
            password?: string;
            publicKeys?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_PublicKey[];
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Sftp_Users {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            accessLevel?: "read" | "full";
            authentication: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_Authentication;
            description: string;
            directories: string[];
            expiresAt?: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_SftpUser;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_SftpUser[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Ssh_Users {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            authentication: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_Authentication;
            description: string;
            expiresAt?: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_SshUser;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_SshUser[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Memberships_Self {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectMembership;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Orders {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            orderData?:
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ProjectHostingOrder
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ServerOrder
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_DomainOrder
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ExternalCertificateOrder;
            orderType?:
              | "domain"
              | "projectHosting"
              | "server"
              | "externalCertificate";
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = {
                orderId: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
            includesStatus?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus[];
            excludesStatus?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus[];
            templateNames?: string[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_CustomerOrder[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Tariff_Changes {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            tariffChangeData?:
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ProjectHostingTariffChange
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ServerTariffChange;
            tariffChangeType?: "projectHosting" | "server";
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = {
                orderId: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Order_Previews {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            orderData?:
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ProjectHostingOrderPreview
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ServerOrderPreview
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_DomainOrderPreview
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ExternalCertificateOrderPreview;
            orderType?:
              | "domain"
              | "projectHosting"
              | "server"
              | "externalCertificate";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_HostingOrderPreviewResponse
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_DomainOrderPreviewResponse
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ExternalCertificateOrderPreviewResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json = {
                error?: {};
              };
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Tariff_Change_Previews {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            tariffChangeData?:
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ProjectHostingTariffChange
              | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_ServerTariffChange;
            tariffChangeType?: "projectHosting" | "server";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                machineTypePrice: number;
                storagePrice: number;
                totalPrice: number;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json = {
                error?: {};
              };
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Legacy_Tariff_Change {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            pAccount: string;
            targetTariff: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                messageId: string;
              }
            }
          }

          namespace $403 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Contract {
      namespace Get {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Contract;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Contract {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Contract;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId_Contract {
      namespace Get {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Contract;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates {
      namespace Get {
        namespace Parameters {
          interface Path {
            appId: string;
            baseAppVersionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppVersion[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Authenticate_Mfa {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            email?: string;
            multiFactorCode: string;
            password?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expires: string;
                refreshToken: string;
                token: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $408 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_DomainError & {
                  name?: "FirstAuthenticationFactorExpired";
                };
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Authenticate {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            email: string;
            password: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expires: string;
                refreshToken: string;
                token: string;
              }
            }
          }

          namespace $202 {
            namespace Content {
              interface Application_Json {
                name?: "SecondFactorRequired";
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Email {
      namespace Put {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            email: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                email: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Password {
      namespace Put {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            multiFactorCode?: string;
            newPassword: string;
            oldPassword: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expires: string;
                token: string;
              }
            }
          }

          namespace $202 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_DomainError & {
                  name?: "SecondFactorRequired";
                };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Token {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                id: string;
                publicToken: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Mfa {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            multiFactorCode: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                recoveryCodesList: string[];
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            multiFactorCode: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                confirmed: boolean;
                initialized: boolean;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            multiFactorCode: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                recoveryCodesList: string[];
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Password_Confirm_Reset {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            password: string;
            token: string;
            userId: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Api_Tokens {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            description: string;
            expiresAt?: string;
            roles: ("api_read" | "api_write")[];
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                token: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_ApiToken[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Ssh_Keys {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            expiresAt?: string;
            publicKey: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                sshKeys?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_SshKey[];
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Api_Tokens_ApiTokenId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            apiTokenId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            apiTokenId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            description: string;
            expiresAt?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            apiTokenId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_ApiToken;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Ssh_Keys_SshKeyId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            sshKeyId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            sshKeyId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            comment: string;
            expiresAt?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            sshKeyId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                sshKey: MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_SshKey;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self {
      namespace Delete {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            multiFactorCode?: string;
            password: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $202 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_DomainError & {
                  name?: "SecondFactorRequired";
                };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $409 {
            namespace Content {
              interface Application_Json {
                info?: {};
                message: string;
                name: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Personal_Information {
      namespace Put {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            person: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Person;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Password_Updated_At {
      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                passwordUpdatedAt: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Sessions_TokenId {
      namespace Get {
        namespace Parameters {
          interface Path {
            tokenId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_UserSession;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            tokenId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Init_Mfa {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                barcode: string;
                url: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Actions_Init_Password_Reset {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            email: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Sessions {
      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_UserSession[];
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            refreshToken: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expiresAt: string;
                refreshToken: string;
                token: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Logout {
      namespace Put {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Register {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            email: string;
            password: string;
            person: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Person;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                userId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Email_Actions_Resend_Email {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            email: string;
            userId: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Support_Code {
      namespace Get {
        namespace Parameters {
          interface Query {
            forceRecreate?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expiresAt: string;
                supportCode: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Credentials_Email_Actions_Verify_Email {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            email: string;
            token?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Verify_Registration {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            email: string;
            token: string;
            userId: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_UserId_Phone {
      namespace Post {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            phoneNumber: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_Self_Feedback {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            message?: string;
            origin?: string;
            subject: string;
            type?: "feedback" | "bug";
            vote?: number;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_UserId_Settings {
      namespace Get {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                settingsString?: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            settingsString: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_UserId {
      namespace Get {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_User_User;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            person: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Person;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_UserId_Feedback {
      namespace Get {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Query {
            subject?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_User_UserFeedback[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_UserId_Avatar {
      namespace Delete {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                refId: string;
                rules: {
                  maxSizeInKB: number;
                  mimeTypes: string[];
                  properties?: {
                    imageDimensions?: {
                      max?: {
                        height?: number;
                        width?: number;
                      };
                      min?: {
                        height?: number;
                        width?: number;
                      };
                    };
                  };
                };
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance {
      namespace Post {
        namespace Parameters {
          interface Path {
            ingressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Newsletter_Subscriptions_Self {
      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                active: boolean;
                email: string;
                registered: boolean;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Newsletter_Subscriptions {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            firstName?: string;
            lastName?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                active: boolean;
                email: string;
                registered: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domain_Registrable {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = {
            domain: string;
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                isPremium: boolean;
                registrable: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domain_Tlds_Tld_Contact_Schemas {
      namespace Get {
        namespace Parameters {
          interface Path {
            tld: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                jsonSchemaAdminC?: {};
                jsonSchemaOwnerC: {};
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Dns_Zones {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            name: string;
            parentZoneId: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Dns_Zones_DnsZoneId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            dnsZoneId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            dnsZoneId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_Zone;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Dns_Zones {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_Zone[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed {
      namespace Post {
        namespace Parameters {
          interface Path {
            dnsZoneId: string;
            recordSet: "a" | "mx";
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $204 {
            namespace Content {
              interface Application_Json {
                ingressId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet {
      namespace Put {
        namespace Parameters {
          interface Path {
            dnsZoneId: string;
            recordSet: "a" | "mx" | "txt" | "srv" | "cname" | "caa";
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody =
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_CombinedACustom
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordMxCustom
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordTxtComponent
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSrvComponent
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCnameComponent
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCaaComponent;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Declaration {
      namespace Delete {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Actions_Auth_Code {
      namespace Post {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                authCode: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domain_Tlds {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_TopLevel[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Auth_Code {
      namespace Patch {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            authCode: string;
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                isAsync?: boolean;
                transactionId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Contacts_Contact {
      namespace Patch {
        namespace Parameters {
          interface Path {
            domainId: string;
            contact: "owner";
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody = {
            contact: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleField[];
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                isAsync?: boolean;
                transactionId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Project_Id {
      namespace Patch {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            projectId?: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Delivery_Boxes {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            description: string;
            password: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_Deliverybox[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Mail_Addresses {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_CreateForwardAddress
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_CreateMailAddress;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_MailAddress[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Delivery_Boxes_DeliveryBoxId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            deliveryBoxId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            deliveryBoxId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_Deliverybox;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Mail_MailAddress;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Mail_Settings {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                blacklist: string[];
                projectId: string;
                whitelist: string[];
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Delivery_Boxes_DeliveryBoxId_Description {
      namespace Patch {
        namespace Parameters {
          interface Path {
            deliveryBoxId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            description: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Delivery_Boxes_DeliveryBoxId_Password {
      namespace Patch {
        namespace Parameters {
          interface Path {
            deliveryBoxId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            password: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Address {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            address: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Autoresponder {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            autoResponder: {
              active: boolean;
              expiresAt?: string;
              message: string;
              startsAt?: string;
            };
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Catch_All {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            active: boolean;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Forward_Addresses {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            forwardAddresses: string[];
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Password {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            password: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Quota {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            quotaInBytes: number;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mail_Addresses_MailAddressId_Spam_Protection {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mailAddressId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            spamProtection: {
              active: boolean;
              autoDeleteSpam: boolean;
              folder: "inbox" | "spam";
              relocationMinSpamScore: number;
            };
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Actions_Action {
      namespace Post {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
            action: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_Action;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId {
      namespace Get {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppInstallation;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            appVersionId?: string;
            customDocumentRoot?: string;
            description?: string;
            systemSoftware?: {
              [a: string]: any;
            };
            updatePolicy?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppUpdatePolicy;
            userInputs?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SavedUserInput[];
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Missing_Dependencies {
      namespace Get {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Query {
            targetAppVersionID: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                missingSystemSoftwareDependencies?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftwareDependency[];
                missingUserInputs?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_UserInput[];
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_System_Softwares_SystemSoftwareId {
      namespace Get {
        namespace Parameters {
          interface Path {
            systemSoftwareId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftware;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId {
      namespace Get {
        namespace Parameters {
          interface Path {
            systemSoftwareId: string;
            systemSoftwareVersionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftwareVersion;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Database {
      namespace Patch {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            databaseId: string;
            databaseUserIds?: {
              [a: string]: any;
            };
            purpose: "primary" | "cache" | "custom";
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_App_Installations {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppInstallation[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            appVersionId: string;
            description: string;
            updatePolicy: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppUpdatePolicy;
            userInputs: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SavedUserInput[];
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_System_Softwares {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftware[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_System_Software_SystemSoftwareId_Versions {
      namespace Get {
        namespace Parameters {
          interface Path {
            systemSoftwareId: string;
          }

          interface Query {
            versionRange?: string;
            recommended?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftwareVersion[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Status {
      namespace Get {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppInstallationStatus;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Databases_DatabaseId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
            databaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Databases_MysqlDatabaseId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            mysqlDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            mysqlDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlDatabase;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Users_MysqlUserId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlUser;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            accessIpMask?: string;
            accessLevel: "full" | "readonly";
            description: string;
            externalAccess?: boolean;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Redis_Databases_RedisDatabaseId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            redisDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            redisDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_RedisDatabase;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Users_MysqlUserId_Actions_Disable {
      namespace Post {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Users_MysqlUserId_Actions_Enable {
      namespace Post {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url {
      namespace Get {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_PhpMyAdminUrl;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Databases_MysqlDatabaseId_Default_Charset {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mysqlDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            characterSettings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_CharacterSettings;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Databases_MysqlDatabaseId_Description {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mysqlDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            description: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Users_MysqlUserId_Password {
      namespace Patch {
        namespace Parameters {
          interface Path {
            mysqlUserId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            password: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Redis_Databases_RedisDatabaseId_Configuration {
      namespace Patch {
        namespace Parameters {
          interface Path {
            redisDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            configuration?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_RedisDatabaseConfiguration;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Redis_Databases_RedisDatabaseId_Description {
      namespace Patch {
        namespace Parameters {
          interface Path {
            redisDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            description: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Files_FileId_Meta {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileId: string;
          }

          interface Header {
            Token?: string;
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface Query {
            token?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_File_FileMeta;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Files_FileId {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileId: string;
          }

          interface Header {
            Accept?: "application/octet-stream" | "text/plain;base64";
            "Content-Disposition"?: "inline" | "attachment";
            Token?: string;
            "x-access-token"?: string;
          }

          interface Query {
            accept?: "application/octet-stream" | "text/plain;base64";
            "content-disposition"?: "inline" | "attachment";
            token?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Octet_Stream = string;

              type Text_Plain_Base64 = string;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Page_Insights {
      namespace Get {
        namespace Parameters {
          interface Query {
            domain: string;
            path: string;
            date?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                createdAt?: string;
                domain: string;
                metrics?: {
                  createdAt: string;
                  name: string;
                  score?: number;
                  value: number;
                }[];
                moreDataAvailable?: string[];
                path: string;
                performanceScore: number;
                screenshot?: {
                  createdAt: string;
                  fileRef: string;
                };
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Page_Insights {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            domain?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                domain: string;
                paths: {
                  createdAt: string;
                  path: string;
                  performanceScore: number;
                  screenshotFileRef?: string;
                }[];
              }[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Filesystem_Directories {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            directory?: string;
            name?: string;
            max_depth?: number;
            type?: string[];
            executable?: boolean;
            hidden?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_FilesystemDirectoryListing;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Filesystem_Disk_Usage {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            directory?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_FilesystemUsagesDisk;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Filesystem_File_Content {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            file?: string;
            inline?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "text/plain";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Text_Plain = string;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Filesystem_Files {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            file?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_FilesystemDirectoryListing;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Description {
      namespace Patch {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            description: string;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_File_Upload_Tokens_FileUploadToken_Rules {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileUploadToken: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_File_FileUploadRules;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_File_Upload_Types_FileUploadType_Rules {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileUploadType: "avatar" | "conversation";
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_File_FileUploadRules;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId_Members {
      namespace Get {
        namespace Parameters {
          interface Path {
            conversationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_ConversationMembers;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Conversations_ConversationId_Files_FileId_Access_Token {
      namespace Get {
        namespace Parameters {
          interface Path {
            conversationId: string;
            fileId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                accessToken: string;
                expiresAt: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
            invoiceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                accessToken: string;
                expiresAt: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Straces_StraceId {
      namespace Get {
        namespace Parameters {
          interface Path {
            straceId: string;
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                executedAt: string;
                id: string;
                result:
                  | MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Error
                  | MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Data;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Straces {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            url: string;
          }
        }

        namespace Responses {
          namespace $202 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Authenticate_Token_Retrieval_Key {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            accessTokenRetrievalKey: string;
            userId: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expiresAt: string;
                refreshToken: string;
                token: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Mysql_Databases_MysqlDatabaseId_Users {
      namespace Post {
        namespace Parameters {
          interface Path {
            mysqlDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_CreateMySqlUser;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            mysqlDatabaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlUser[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Ingresses_IngressId_Actions_Verify_Ownership {
      namespace Post {
        namespace Parameters {
          interface Path {
            ingressId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Mail_Settings_MailSetting {
      namespace Patch {
        namespace Parameters {
          interface Path {
            projectId: string;
            mailSetting: "blacklist" | "whitelist";
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody =
            | {
                blacklist: string[];
              }
            | {
                whitelist: string[];
              };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Invites_CustomerInviteId_Actions_Accept {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            invitationToken?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Invites_CustomerInviteId_Actions_Decline {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Invites_CustomerInviteId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            customerInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            customerInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerInvite;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Memberships_CustomerMembershipId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            customerMembershipId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            customerMembershipId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerMembership;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            customerMembershipId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            expiresAt?: string;
            role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerRoles;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customer_Invites_CustomerInviteId_Actions_Resend {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Invites_ProjectInviteId_Actions_Accept {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            invitationToken?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Invites_ProjectInviteId_Actions_Decline {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Invites_ProjectInviteId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            projectInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectInvite;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Memberships_ProjectMembershipId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            projectMembershipId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectMembershipId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectMembership;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            projectMembershipId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            expiresAt?: string;
            role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectRoles;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Project_Invites_ProjectInviteId_Actions_Resend {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectInviteId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_SystemSoftware {
      namespace Get {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Query {
            tagFilter?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftware[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Invoices_InvoiceId {
      namespace Get {
        namespace Parameters {
          interface Path {
            invoiceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Invoice;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Actions_Copy {
      namespace Post {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            description: string;
            targetProjectId?: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users {
      namespace Put {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
            databaseId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            databaseUserIds: {
              [a: string]: any;
            };
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Tokens {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            extensionInstanceSecret: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                expiry: string;
                publicToken: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Scopes {
      namespace Patch {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            consentedScopes: string[];
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            consentedScopes: string[];
            context: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
            contextId: string;
            extensionId: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = {
                id: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Query {
            context?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
            contextId?: string;
            extensionId?: string;
            limit?: number;
            skip?: number;
            page?: number;
            sort?: ("createdAt" | "exensionId")[];
            order?: ("asc" | "desc")[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionInstance[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {
              type Application_Json = any;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionInstance;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Actions_Disable {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {
              type Application_Json = any;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Actions_Enable {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {
              type Application_Json = any;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Contributor
                | MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_OwnContributor;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extensions_ExtensionId {
      namespace Get {
        namespace Parameters {
          interface Path {
            extensionId: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Extension;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Contributor[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extensions {
      namespace Get {
        namespace Parameters {
          interface Query {
            context?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
            limit?: number;
            skip?: number;
            page?: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Extension[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Oauth2_Authorize {
      namespace Get {
        namespace Parameters {
          interface Cookie {
            "x-access-token"?: string;
          }

          interface Query {
            grant_consent?: boolean;
            grant_type?: "authorization_code";
            response_type: "code";
            client_id: string;
            redirect_uri?: string;
            scope?: string;
            state?: string;
            code_challenge?: string;
            code_challenge_method?: "S256";
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $302 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              interface Application_Json {
                error: "invalid_request";
                error_description?: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Oauth2_Token {
      namespace Post {
        namespace Parameters {
          interface Header {
            Authorization?: string;
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                access_token: string;
                expires_in: number;
                refresh_token: string;
                scope?: string;
                token_type: "bearer";
              }
            }
          }

          namespace $400 {
            namespace Content {
              interface Application_Json {
                error:
                  | "invalid_request"
                  | "invalid_client"
                  | "invalid_grant"
                  | "unauthorized_client"
                  | "unsupported_grant_type"
                  | "invalid_scope";
                error_description?: string;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Users_UserId_Actions_Verify_Phone {
      namespace Post {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            code: string;
            phoneNumber: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Notification_Unread_Counts {
      namespace Get {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                error: number;
                info: number;
                success: number;
                total: number;
                warning: number;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Files_FileId_FileName {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileId: string;
            fileName: string;
          }

          interface Header {
            Accept?: "application/octet-stream" | "text/plain;base64";
            "Content-Disposition"?: "inline" | "attachment";
            Token?: string;
            "x-access-token"?: string;
          }

          interface Query {
            accept?: "application/octet-stream" | "text/plain;base64";
            "content-disposition"?: "inline" | "attachment";
            token?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Octet_Stream = string;

              type Text_Plain_Base64 = string;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domain_Transferable {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = {
            authCode?: string;
            domain: string;
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                reasons: {
                  domainAgeTooSmall: boolean;
                  domainDoesNotExist: boolean;
                  transferLock: boolean;
                  wrongAuthCode: boolean;
                };
                transferable: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppInstallation[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domains_DomainId_Latest_Screenshot {
      namespace Get {
        namespace Parameters {
          interface Path {
            domainId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            domainName: string;
            path: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                reference?: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Webhook_Public_Keys_Serial {
      namespace Get {
        namespace Parameters {
          interface Path {
            serial: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_PublicKey;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Notifications_Actions_Read_All {
      namespace Post {
        namespace Parameters {
          interface Query {
            severities?: ("success" | "info" | "warning" | "error")[];
            referenceId?: string;
            referenceAggregate?: string;
            referenceDomain?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Messaging_NotificationStatus;
                updatedCount: number;
              }
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Notifications_NotificationId_Status {
      namespace Put {
        namespace Parameters {
          interface Path {
            notificationId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Messaging_NotificationStatus;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Messaging_NotificationStatus;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Poll_Settings_UserId {
      namespace Get {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Poll_UserPollSettings;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            userId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            status: "completed" | "muted" | "ignored";
            userId: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Poll_UserPollSettings;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Actions_Validate_Container_Registry_Uri {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            registryUri: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                valid: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Registries_RegistryId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            registryId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            registryId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_Registry;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            registryId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_UpdateRegistry;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Container_Image_Config {
      namespace Get {
        namespace Parameters {
          interface Query {
            imageReference: string;
            useCredentialsForProjectId?: string;
            useCredentialsForRegistryId?: string;
            generateAiData?: boolean;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ContainerImageConfig;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Registries {
      namespace Post {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_CreateRegistry;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_Registry;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Query {
            hasCredentials?: boolean;
            limit?: number;
            skip?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_Registry[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Registries_RegistryId_Actions_Validate_Credentials {
      namespace Post {
        namespace Parameters {
          interface Path {
            registryId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                valid: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Volumes_VolumeId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            stackId: string;
            volumeId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            stackId: string;
            volumeId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_VolumeResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId_Logs {
      namespace Get {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "text/plain";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Text_Plain = string;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $503 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId {
      namespace Get {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ServiceResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Services {
      namespace Get {
        namespace Parameters {
          interface Query {
            stackId?: string;
          }

          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ServiceResponse[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Stacks {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_StackResponse[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Volumes {
      namespace Get {
        namespace Parameters {
          interface Query {
            stackId?: string;
          }

          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_VolumeResponse[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId {
      namespace Put {
        namespace Parameters {
          interface Path {
            stackId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            services?: {
              [a: string]: any;
            };
            volumes?: {
              [a: string]: any;
            };
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_StackResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            stackId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_StackResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            stackId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            services?: {
              [a: string]: any;
            };
            volumes?: {
              [a: string]: any;
            };
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_StackResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId_Actions_Recreate {
      namespace Post {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId_Actions_Restart {
      namespace Post {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId_Actions_Start {
      namespace Post {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId_Actions_Stop {
      namespace Post {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                accessTokenRetrievalKey: string;
                userId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret {
      namespace Put {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            allowWebhookFailure?: boolean;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                secret: string;
                webhookResult: {
                  failure: boolean;
                  statusCode?: string;
                };
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Domain_Suggestions {
      namespace Get {
        namespace Parameters {
          interface Query {
            prompt: string;
            domainCount?: number;
            tlds?: string[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_SuggestedDomains;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_App_Installations_AppInstallationId_Database_Replace {
      namespace Patch {
        namespace Parameters {
          interface Path {
            appInstallationId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            databaseUserIds?: {
              [a: string]: any;
            };
            newDatabaseId: string;
            oldDatabaseId: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificates_CertificateId_Contract {
      namespace Get {
        namespace Parameters {
          interface Path {
            certificateId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Contract;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Actions_List_Ingresses_Compatible_With_Certificate {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            certificate: string;
            projectId: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Ingress[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificates_CertificateId_Actions_Check_Replace_Certificate {
      namespace Post {
        namespace Parameters {
          interface Path {
            certificateId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            certificate: string;
            privateKey?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceCertificateResponse;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificate_Requests {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateRequestCreateRequest
            | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateRequestCreateWithCsrRequest;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateRequestCreateResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateError;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Query {
            projectId?: string;
            ingressId?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateRequest[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificate_Request_CertificateRequestId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            certificateRequestId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificate_CertificateId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            certificateId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificate_Requests_CertificateRequestId {
      namespace Get {
        namespace Parameters {
          interface Path {
            certificateRequestId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateRequest;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificates_CertificateId {
      namespace Get {
        namespace Parameters {
          interface Path {
            certificateId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_Certificate;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            certificateId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            certificate: string;
            privateKey?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateError;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificates {
      namespace Get {
        namespace Parameters {
          interface Query {
            projectId?: string;
            ingressId?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_Certificate[];
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Certificate_Requests_CertificateRequestId_Certificate {
      namespace Patch {
        namespace Parameters {
          interface Path {
            certificateRequestId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            certificate: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateError;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind {
      namespace Post {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
            extensionInstanceId: string;
            webhookKind: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookKind;
          }

          interface Query {
            contextId?: string;
            scopes?: string[];
            instanceDisabled?: boolean;
            createdAt?: string;
            secret?: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                errorMessage?: string;
                responseBody?: string;
                responseCode?: number;
                responseHeaders?: string;
                routeCalled: string;
                successful: boolean;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Storage_Space_Notification_Threshold {
      namespace Put {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            notificationThresholdInBytes?: number;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Storage_Space_Statistics {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_Statistics;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId_Storage_Space_Statistics {
      namespace Get {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_Statistics;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Servers_ServerId_Storage_Space_Notification_Threshold {
      namespace Put {
        namespace Parameters {
          interface Path {
            serverId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = {
            notificationThresholdInBytes?: number;
          };
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort {
      namespace Post {
        namespace Parameters {
          interface Path {
            cronjobId: string;
            executionId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          type RequestBody = any;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Extensions_ExtensionId {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionInstance;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Extensions_ExtensionId {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionInstance;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_OwnExtension[];
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            context?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
            description?: string;
            detailedDescriptions?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_DetailedDescriptions;
            externalFrontend?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
            externalFrontends?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
            frontendFragments?: {
              [a: string]: any;
            };
            name: string;
            scopes?: string[];
            subTitle?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SubTitle;
            support?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SupportMeta;
            tags?: string[];
            webhookURLs?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrls;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                id: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }

          interface RequestBody {
            reason?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_OwnExtension;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            deprecation?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionDeprecation;
            description?: string;
            detailedDescriptions?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_DetailedDescriptions;
            externalFrontends?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
            frontendFragments?: {
              [a: string]: any;
            };
            name?: string;
            scopes?: string[];
            subTitle?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SubTitle;
            support?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SupportMeta;
            tags?: string[];
            webhookUrls?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrls;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_OwnExtension;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Leads_LeadId {
      namespace Get {
        namespace Parameters {
          interface Path {
            leadId: string;
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Lead;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Unlocked_Leads_LeadId {
      namespace Get {
        namespace Parameters {
          interface Path {
            leadId: string;
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_UnlockedLead;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            leadId: string;
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                leadId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Leads {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            potentialRangeMin?: number;
            potentialRangeMax?: number;
            employeeCountMin?: number;
            employeeCountMax?: number;
            salesVolumeMin?: number;
            salesVolumeMax?: number;
            technologies?: string[];
            "basic:timeToFirstByteMs:min"?: number;
            "basic:timeToFirstByteMs:max"?: number;
            "basic:desktop:performance:min"?: number;
            "basic:desktop:performance:max"?: number;
            "basic:mobile:performance:min"?: number;
            "basic:mobile:performance:max"?: number;
            limit?: number;
            skip?: number;
            page?: number;
            sort?: (
              | "potential"
              | "company.salesVolume"
              | "company.employeeCount"
              | "basic:desktop:performance"
              | "basic:mobile:performance"
              | "basic:desktop:seo"
              | "basic:mobile:seo"
            )[];
            order?: ("asc" | "desc")[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              interface Application_Json {
                leads: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Lead[];
                limit: number;
                skip: number;
                totalCount: number;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Unlocked_Leads {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Query {
            potentialRangeMin?: number;
            potentialRangeMax?: number;
            employeeCountMin?: number;
            employeeCountMax?: number;
            salesVolumeMin?: number;
            salesVolumeMax?: number;
            technologies?: string[];
            "basic:timeToFirstByteMs:min"?: number;
            "basic:timeToFirstByteMs:max"?: number;
            "basic:desktop:performance:min"?: number;
            "basic:desktop:performance:max"?: number;
            "basic:mobile:performance:min"?: number;
            "basic:mobile:performance:max"?: number;
            reserved?: boolean;
            limit?: number;
            skip?: number;
            page?: number;
            sort?: (
              | "potential"
              | "company.salesVolume"
              | "company.employeeCount"
              | "basic:desktop:performance"
              | "basic:mobile:performance"
              | "basic:desktop:seo"
              | "basic:mobile:seo"
            )[];
            order?: ("asc" | "desc")[];
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              interface Application_Json {
                leads: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_UnlockedLead[];
                limit: number;
                skip: number;
                totalCount: number;
              }
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
            sessionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                sessionToken: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Recommendation_Suggestions {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            suggestion: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                customerId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Wallet {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerId: string;
                points: number;
                recommendationCode?: string;
                walletId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Stacks_StackId_Services_ServiceId_Actions_Pull {
      namespace Post {
        namespace Parameters {
          interface Path {
            stackId: string;
            serviceId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation {
      namespace Delete {
        namespace Parameters {
          interface Path {
            leadId: string;
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                leadId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            leadId: string;
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                leadId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extensions_ExtensionId_Checkout {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            consentedScopes: string[];
            customerId: string;
            projectId?: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                checkoutUrl?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Termination {
      namespace Delete {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                extensionInstanceId: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            instantTermination?: boolean;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = {
                extensionInstanceId: string;
              };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Billing_Information {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                contributorId?: string;
                onboardingStatus?: "NOT_STARTED" | "STARTED" | "SUCCESSFUL";
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Dashboard {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                url?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Invoices_Incoming {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                currency: string;
                customerId: string;
                customerName: string;
                customerNumber: string;
                date: string;
                id: string;
                invoiceNumber: string;
                pdfId: string;
                recipient: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Recipient;
                totalGross: number;
                totalNet: number;
              }[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Invoices_Outgoing {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                invoiceDate: string;
                invoiceId: string;
                invoiceNumber: string;
                pdfLink: string;
                totalGross: number;
                totalNet: number;
                webLink: string;
              }[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token {
      namespace Get {
        namespace Parameters {
          interface Path {
            contributorId: string;
            contributorReceiptId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                accessToken: string;
                expiresAt: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Context {
      namespace Put {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            context: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                cleaningUpInstances: boolean;
                currentContext: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
                id: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Onboarding_Process {
      namespace Post {
        namespace Parameters {
          interface Path {
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            shippingCountryRestriction: "onlyDomestic";
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                contributorId?: string;
                onboardingLink?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Assets_AssetRefId {
      namespace Delete {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
            assetRefId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Logo {
      namespace Delete {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                logoRefId: string;
                rules: {
                  extensions: string[];
                  fileTypes: {
                    extensions: string[];
                    mimeType: string;
                  }[];
                  maxSizeInBytes: number;
                  mimeTypes: string[];
                  properties?: {
                    imageDimensions?: {
                      max: {
                        height?: number;
                        width?: number;
                      };
                      min: {
                        height?: number;
                        width?: number;
                      };
                    };
                  };
                };
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Assets {
      namespace Post {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            assetType: "image" | "video";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                assetRefId: string;
                rules: {
                  extensions: string[];
                  fileTypes: {
                    extensions: string[];
                    mimeType: string;
                  }[];
                  maxSizeInBytes: number;
                  mimeTypes: string[];
                  properties?: {
                    imageDimensions?: {
                      max: {
                        height?: number;
                        width?: number;
                      };
                      min: {
                        height?: number;
                        width?: number;
                      };
                    };
                  };
                };
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $412 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process {
      namespace Post {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extensions_ExtensionId_Published {
      namespace Put {
        namespace Parameters {
          interface Path {
            contributorId: string;
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            published: boolean;
            reason?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                id: string;
                published: boolean;
              }
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extension_Instances_ExtensionInstanceId_Contract {
      namespace Get {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Extension_ExtensionInstanceContract;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            extensionInstanceId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Contributors_ContributorId_Extension_ExtensionId_Pricing {
      namespace Put {
        namespace Parameters {
          interface Path {
            extensionId: string;
            contributorId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            priceInCents?: number;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                extensionId?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Billing_Portal {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                url?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Payment_Method {
      namespace Put {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            customReturnUrl?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                url?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                cardDetails?: {
                  brand: string;
                  last4: string;
                };
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Extensions_ExtensionId_Order {
      namespace Post {
        namespace Parameters {
          interface Path {
            extensionId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          type RequestBody =
            | {
                consentedScopes: string[];
                customerId: string;
              }
            | {
                consentedScopes: string[];
                projectId: string;
              };
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Lead_Fyndr_Profile_Request {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_ProfileRequest;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            domain: string;
          }
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              interface Application_Json {
                profileId: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Lead_Fyndr_Profile {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Profile & {
                  tariff: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_TariffOptions;
                };
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_TariffOptions;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Customers_CustomerId_Extension_Orders {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                extensionId?: string;
              }[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace V2_Projects_ProjectId_Extension_Orders {
      namespace Get {
        namespace Parameters {
          interface Path {
            projectId: string;
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = {
                extensionId?: string;
              }[];
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }

          namespace $429 {
            namespace Content {
              interface Application_Json {
                message?: string;
                type?: string;
              }
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }
  }

  namespace Components {
    namespace Schemas {
      interface De_Mittwald_V1_Article_ArticleAddons {
        hidden?: boolean;
        key: string;
        type?: string;
        value: string;
        valueMergeType?: "add" | "set";
      }

      interface De_Mittwald_V1_Article_ArticleAttributes {
        customerEditable?: boolean;
        key: string;
        mergeType?: "add" | "set";
        readonly?: boolean;
        required?: boolean;
        unit?: string;
        value?: string;
      }

      interface De_Mittwald_V1_Article_ArticleTag {
        description?: string;
        hexColor?: string;
        id: string;
        name?: string;
      }

      interface De_Mittwald_V1_Article_ArticleTemplate {
        additionalArticles?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ReadableBookableArticleOptions[];
        addons?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ArticleAddons[];
        attributes?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ArticleAttributes[];
        description?: string;
        id?: string;
        isManagedByDomain: boolean;
        isRecurring: boolean;
        modifierArticles?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ReadableModifierArticleOptions[];
        name: string;
        type:
          | "miscellaneous"
          | "base"
          | "additional"
          | "modifier"
          | "setup_fee";
      }

      interface De_Mittwald_V1_Article_ReadableArticle {
        addons?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ArticleAddons[];
        articleId: string;
        attributes?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ArticleAttributes[];
        balanceAddonKey?: string;
        contractDurationInMonth: number;
        description?: string;
        forcedInvoicingPeriodInMonth?: number;
        hasIndependentContractPeriod?: boolean;
        hideOnInvoice?: boolean;
        machineType?: {
          cpu: string;
          memory: string;
          name: string;
        };
        modifierArticles?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ReadableModifierArticleOptions[];
        name: string;
        orderable:
          | "forbidden"
          | "internal"
          | "beta_testing"
          | "full"
          | "deprecated";
        possibleArticleChanges?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ReadableChangeArticleOptions[];
        price?: number;
        tags?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ArticleTag[];
        template: MittwaldApi.Components.Schemas.De_Mittwald_V1_Article_ArticleTemplate;
      }

      interface De_Mittwald_V1_Contract_AggregateReference {
        aggregate: string;
        domain: string;
        id: string;
      }

      interface De_Mittwald_V1_Contract_Article {
        amount: number;
        articleTemplateId: string;
        description?: string;
        id: string;
        name: string;
        unitPrice: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Price;
      }

      interface De_Mittwald_V1_Contract_Contact {
        address: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Address;
        company?: string;
        emailAddress?: string;
        firstName?: string;
        lastName?: string;
        phoneNumbers?: string[];
        salutation: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Salutation;
        title?: string;
        useFormalTerm?: boolean;
      }

      interface De_Mittwald_V1_Contract_ContractItem {
        activationDate?: string;
        aggregateReference?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_AggregateReference;
        articles: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Article[];
        contractPeriod: number;
        description: string;
        freeTrialDays?: number;
        groupByProjectId?: string;
        invoiceStop?: string;
        invoicingPeriod?: number;
        isActivated: boolean;
        isBaseItem: boolean;
        isInFreeTrial?: boolean;
        isInclusive?: boolean;
        itemId: string;
        nextPossibleDowngradeDate?: string;
        nextPossibleTerminationDate?: string;
        nextPossibleUpgradeDate?: string;
        orderDate?: string;
        orderId?: string;
        replacedByItem?: string;
        tariffChange?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_TariffChange;
        termination?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Termination;
        totalPrice: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Price;
      }

      interface De_Mittwald_V1_Contract_Contract {
        additionalItems?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_ContractItem[];
        baseItem: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_ContractItem;
        contractId: string;
        contractNumber: string;
        customerId: string;
        termination?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Termination;
      }

      interface De_Mittwald_V1_Contract_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_Contract_Price {
        currency: "EUR";
        value: number;
      }

      interface De_Mittwald_V1_Contract_Termination {
        cancellationForbidden?: boolean;
        reason?: string;
        scheduledAtDate: string;
        scheduledByUserId?: string;
        targetDate: string;
      }

      interface De_Mittwald_V1_Cronjob_Cronjob {
        active: boolean;
        appId: string;
        createdAt: string;
        description: string;
        destination:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobUrl
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobCommand;
        email?: string;
        id: string;
        interval: string;
        latestExecution?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobExecution;
        nextExecutionTime?: string;
        projectId?: string;
        shortId: string;
        timeout: number;
        updatedAt: string;
      }

      interface De_Mittwald_V1_Cronjob_CronjobCommand {
        interpreter: string;
        parameters?: string;
        path: string;
      }

      interface De_Mittwald_V1_Cronjob_CronjobExecution {
        abortedBy?: {
          id?: string;
        };
        durationInMilliseconds?: number;
        end?: string;
        executionEnd?: string;
        executionStart?: string;
        id: string;
        logPath?: string;
        start?: string;
        status:
          | "Complete"
          | "Failed"
          | "AbortedBySystem"
          | "Pending"
          | "Running"
          | "AbortedByUser"
          | "TimedOut";
        successful: boolean;
        triggeredBy?: {
          id?: string;
        };
      }

      interface De_Mittwald_V1_Cronjob_CronjobRequest {
        active: boolean;
        appId: string;
        description: string;
        destination:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobUrl
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Cronjob_CronjobCommand;
        email?: string;
        interval: string;
        timeout: number;
      }

      interface De_Mittwald_V1_Cronjob_CronjobUrl {
        url: string;
      }

      interface De_Mittwald_V1_Customer_Category {
        id: string;
        isPublic: boolean;
        name: string;
        useAgencyDomainPrices: boolean;
        useAgencySslPrices: boolean;
      }

      interface De_Mittwald_V1_Customer_Contact {
        address: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Address;
        company?: string;
        emailAddress?: string;
        firstName?: string;
        lastName?: string;
        phoneNumbers?: string[];
        salutation: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Salutation;
        title?: string;
        useFormalTerm?: boolean;
      }

      interface De_Mittwald_V1_Customer_CustomerMeta {
        avatarRefId?: string;
        customerId: string;
        name: string;
      }

      type De_Mittwald_V1_Customer_Role = "owner" | "member" | "accountant";

      interface De_Mittwald_V1_Customer_Customer {
        activeSuspension?: {
          createdAt: string;
        };
        avatarRefId?: string;
        categoryId?: string;
        creationDate: string;
        customerId: string;
        customerNumber: string;
        executingUserRoles?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Role[];
        flags?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_CustomerFlag[];
        isBanned?: boolean;
        isInDefaultOfPayment?: boolean;
        levelOfUndeliverableDunningNotice?: "first" | "second";
        memberCount: number;
        name: string;
        owner?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Customer_Contact;
        projectCount: number;
        vatId?: string;
        vatIdValidationState?: "valid" | "invalid" | "pending" | "unspecified";
      }

      interface De_Mittwald_V1_Database_CharacterSettings {
        characterSet: string;
        collation: string;
      }

      interface De_Mittwald_V1_Database_MySqlDatabase {
        characterSettings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_CharacterSettings;
        createdAt: string;
        description: string;
        externalHostname: string;
        finalizers?: string[];
        hostname: string;
        id: string;
        isReady: boolean;
        isShared: boolean;
        mainUser?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_MySqlUser;
        name: string;
        projectId: string;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_DatabaseStatus;
        statusSetAt: string;
        storageUsageInBytes: number;
        storageUsageInBytesSetAt: string;
        updatedAt: string;
        version: string;
      }

      interface De_Mittwald_V1_Database_MySqlUser {
        accessIpMask?: string;
        accessLevel: "full" | "readonly";
        createdAt: string;
        databaseId: string;
        description?: string;
        disabled: boolean;
        externalAccess: boolean;
        id: string;
        mainUser: boolean;
        name: string;
        passwordUpdatedAt: string;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_DatabaseUserStatus;
        statusSetAt: string;
        updatedAt: string;
      }

      interface De_Mittwald_V1_Database_PhpMyAdminUrl {
        url: string;
      }

      interface De_Mittwald_V1_Database_MySqlVersion {
        disabled: boolean;
        id: string;
        name: string;
        number: string;
      }

      interface De_Mittwald_V1_Ingress_Ingress {
        dnsValidationErrors: (
          | "ERROR_UNSPECIFIED"
          | "ERROR_QUAD_A"
          | "ERROR_NO_A_RECORD"
          | "ERROR_ACME_CERTIFICATE_REQUEST_DEADLINE_EXCEEDED"
        )[];
        hostname: string;
        id: string;
        ips: {
          v4: string[];
        };
        isDefault: boolean;
        isDomain?: boolean;
        isEnabled: boolean;
        ownership: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Ownership;
        paths: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Path[];
        projectId: string;
        tls:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TlsAcme
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TlsCertificate;
      }

      interface De_Mittwald_V1_Ingress_Path {
        path: string;
        target:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TargetDirectory
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TargetUrl
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TargetInstallation
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TargetUseDefaultPage
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TargetContainer;
      }

      interface De_Mittwald_V1_Ingress_TargetDirectory {
        directory: string;
      }

      interface De_Mittwald_V1_Ingress_TargetInstallation {
        installationId: string;
      }

      interface De_Mittwald_V1_Ingress_TargetUrl {
        url: string;
      }

      interface De_Mittwald_V1_Ingress_TlsAcme {
        acme: boolean;
        isCreated: boolean;
        requestDeadline?: string;
      }

      interface De_Mittwald_V1_Ingress_TlsCertificate {
        certificateId: string;
      }

      interface De_Mittwald_V1_Invoice_ContractInvoiceDefinition {
        contractId: string;
        items: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_ContractItemInvoiceDefinition[];
      }

      interface De_Mittwald_V1_Invoice_ContractItemInvoiceDefinition {
        contractItemId: string;
        isDue?: boolean;
        serviceDate?: string;
        servicePeriod: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_DatePeriod;
        vatRate: number;
      }

      interface De_Mittwald_V1_Invoice_CorrectionDefinition {
        contractItemId: string;
        creditPeriod: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_DatePeriod;
      }

      interface De_Mittwald_V1_Invoice_DatePeriod {
        end: string;
        start: string;
      }

      interface De_Mittwald_V1_Invoice_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_Invoice_InvoiceItem {
        additionalDescription?: string;
        contractItemId: string;
        description: string;
        itemCancelledOrCorrectedBy?: {
          sourceInvoiceId?: string;
          sourceInvoiceItemId?: string;
        }[];
        itemId: string;
        price: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Price;
        reference?: {
          sourceInvoiceId: string;
          sourceInvoiceItemId: string;
        };
        serviceDate?: string;
        servicePeriod?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_DatePeriod;
        vatRate: number;
      }

      interface De_Mittwald_V1_Invoice_Invoice {
        amountPaid: number;
        cancellation?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Cancellation;
        cancellationOf?: string;
        currency: string;
        customerId: string;
        date: string;
        groups: {
          contractId?: string;
          description?: string;
          items: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_InvoiceItem[];
        }[];
        id: string;
        invoiceNumber: string;
        invoiceType: "REGULAR" | "REISSUE" | "CORRECTION" | "CANCELLATION";
        paymentSettings?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_PaymentSettings;
        pdfId: string;
        recipient: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Recipient;
        status:
          | "NEW"
          | "CONFIRMED"
          | "DENIED"
          | "PAID"
          | "PARTIALLY_PAID"
          | "OVERPAID";
        totalGross: number;
        totalNet: number;
        vatId?: string;
      }

      interface De_Mittwald_V1_Invoice_InvoiceSettings {
        additionalEmailRecipients?: string[];
        debitPaymentStopUntil?: string;
        id: string;
        invoicePeriod?: number;
        lastBankingInformation?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_BankingInformation;
        paymentSettings?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_PaymentSettings;
        printedInvoices?: boolean;
        recipient?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_Recipient;
        recipientSameAsOwner?: boolean;
        status?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_InvoiceSettingsStatus[];
        targetDay?: number;
      }

      interface De_Mittwald_V1_Invoice_PaymentSettingsDebit {
        accountHolder: string;
        bic?: string;
        iban: string;
        method: "debit";
      }

      interface De_Mittwald_V1_Invoice_PaymentSettingsInvoice {
        method: "invoice";
      }

      type De_Mittwald_V1_Invoice_PaymentSettings =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_PaymentSettingsDebit
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Invoice_PaymentSettingsInvoice;

      interface De_Mittwald_V1_Invoice_Price {
        currency: "EUR";
        value: number;
      }

      interface De_Mittwald_V1_Invoice_Recipient {
        address: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Address;
        company?: string;
        emailAddress?: string;
        firstName?: string;
        lastName?: string;
        phoneNumbers?: string[];
        salutation: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Salutation;
        title?: string;
        useFormalTerm?: boolean;
      }

      interface De_Mittwald_V1_Mail_CreateMailAddress {
        address: string;
        isCatchAll: boolean;
        mailbox: {
          enableSpamProtection: boolean;
          password: string;
          quotaInBytes: number;
        };
      }

      interface De_Mittwald_V1_Mail_Deliverybox {
        authenticationEnabled: boolean;
        description: string;
        id: string;
        name: string;
        passwordUpdatedAt: string;
        projectId: string;
        sendingEnabled: boolean;
        updatedAt: string;
      }

      interface De_Mittwald_V1_Mail_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_Mail_CreateForwardAddress {
        address: string;
        forwardAddresses: string[];
      }

      type De_Mittwald_V1_Membership_CustomerInheritedRoles =
        | "notset"
        | "owner"
        | "member"
        | "accountant";

      interface De_Mittwald_V1_Membership_CustomerInvite {
        avatarRefId?: string;
        customerId: string;
        customerName: string;
        id: string;
        information: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_InviteInformation;
        mailAddress: string;
        membershipExpiresAt?: string;
        message?: string;
        role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerRoles;
      }

      interface De_Mittwald_V1_Membership_CustomerMembership {
        customerId: string;
        email: string;
        expiresAt?: string;
        id: string;
        inviteId?: string;
        memberSince?: string;
        mfa: boolean;
        role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_CustomerRoles;
        userId: string;
      }

      type De_Mittwald_V1_Membership_CustomerRoles =
        | "notset"
        | "owner"
        | "member"
        | "accountant";

      interface De_Mittwald_V1_Membership_InviteInformation {
        invitationToken?: string;
        invitedBy: string;
        userId?: string;
      }

      interface De_Mittwald_V1_Membership_ProjectInvite {
        avatarRefId?: string;
        id: string;
        information: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_InviteInformation;
        mailAddress: string;
        membershipExpiresAt?: string;
        message?: string;
        projectDescription: string;
        projectId: string;
        role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectRoles;
      }

      interface De_Mittwald_V1_Membership_ProjectMembership {
        email: string;
        expiresAt?: string;
        id: string;
        inherited: boolean;
        inviteId?: string;
        memberSince?: string;
        mfa: boolean;
        projectId: string;
        role: MittwaldApi.Components.Schemas.De_Mittwald_V1_Membership_ProjectRoles;
        userId: string;
      }

      type De_Mittwald_V1_Membership_ProjectRoles =
        | "notset"
        | "owner"
        | "emailadmin"
        | "external";

      interface De_Mittwald_V1_Order_ArticleAddons {
        hidden?: boolean;
        key: string;
        type?: string;
        value: string;
        valueMergeType?: "add" | "set";
      }

      interface De_Mittwald_V1_Order_CustomerOrder {
        contractChangeContractId?: string;
        customerId: string;
        dueDate?: string;
        invoicingPeriod: number;
        items: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderItem[];
        orderDate?: string;
        orderId: string;
        orderNumber: string;
        profile?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_Profile;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderStatus;
        summary: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderSummary;
        type: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_OrderType;
      }

      interface De_Mittwald_V1_Order_Addons {
        hidden?: boolean;
        key: string;
        value: string;
      }

      interface De_Mittwald_V1_Order_AttributeConfiguration {
        key: string;
        value?: string;
      }

      interface De_Mittwald_V1_Order_OrderItem {
        addons?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_Addons[];
        articleId: string;
        articleName?: string;
        articleTemplateName?: string;
        attributeConfiguration?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_AttributeConfiguration[];
        isInclusive: boolean;
        orderItemId: string;
        predefinedDomainAggregateId?: string;
        price: number;
        reference?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_Reference;
      }

      interface De_Mittwald_V1_Order_Reference {
        contractItemId?: string;
        offerItemId?: string;
        orderItemId?: string;
      }

      interface De_Mittwald_V1_Order_Profile {
        email: string;
        first_name?: string;
        last_name?: string;
        title?: "other" | "mr" | "ms";
        userId: string;
      }

      interface De_Mittwald_V1_Project_Project {
        backupStorageUsageInBytes: number;
        backupStorageUsageInBytesSetAt: string;
        clusterDomain?: string;
        clusterID?: string;
        clusterId?: string;
        createdAt: string;
        customerId: string;
        description: string;
        directories: {
          [a: string]: any;
        };
        disableReason?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_DisableReason;
        disabledAt?: string;
        enabled: boolean;
        id: string;
        imageRefId?: string;
        isReady: boolean;
        projectHostingId?: string;
        readiness: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_DeprecatedProjectReadinessStatus;
        serverId?: string;
        serverShortId?: string;
        shortId: string;
        spec?:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_VisitorSpec
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_HardwareSpec;
        statisticsBaseDomain?: string;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_ProjectStatus;
        statusSetAt: string;
        webStorageUsageInBytes: number;
        webStorageUsageInBytesSetAt: string;
      }

      interface De_Mittwald_V1_Project_FsApiJwt {
        jwt: string;
      }

      interface De_Mittwald_V1_Project_FilesystemDirectoryListing {
        absolutePath: string;
        isDirectory?: boolean;
        isExecutable?: boolean;
        isFile?: boolean;
        isSymlink?: boolean;
        items?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_FilesystemDirectoryListing[];
        name: string;
        size: number;
        target?: string;
      }

      interface De_Mittwald_V1_Project_FilesystemUsagesDisk {
        path?: string;
        totalBytes?: number;
        usedBytes?: number;
      }

      interface De_Mittwald_V1_Project_HardwareSpec {
        cpu?: string;
        mem?: string;
        memory?: string;
        storage: string;
      }

      interface De_Mittwald_V1_Project_VisitorSpec {
        storage: string;
        visitors: number;
      }

      interface De_Mittwald_V1_Signup_ApiToken {
        apiTokenId: string;
        createdAt: string;
        description: string;
        expiresAt?: string;
        roles: ("api_read" | "api_write")[];
      }

      interface De_Mittwald_V1_Signup_DeviceInfo {
        browser?: string;
        model?: string;
        os?: string;
        type?: string;
      }

      interface De_Mittwald_V1_Signup_DomainError {
        info?: {};
        message: string;
        name: string;
      }

      interface De_Mittwald_V1_Signup_Location {
        city?: string;
        country?: string;
        ipAddress?: string;
      }

      interface De_Mittwald_V1_Signup_Profile {
        email?: string;
        mfaDetails?: {
          mfaConfirmed?: boolean;
          mfaInitialized?: boolean;
        };
        passwordUpdatedAt?: string;
        person?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Person;
        userId?: string;
      }

      interface De_Mittwald_V1_Signup_SshKey {
        algorithm: string;
        comment: string;
        createdAt: string;
        expiresAt?: string;
        fingerprint: string;
        key: string;
        sshKeyId: string;
      }

      interface De_Mittwald_V1_Signup_UserSession {
        created: string;
        device: MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_DeviceInfo;
        lastAccess?: string;
        location?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Signup_Location;
        tokenId: string;
      }

      type De_Mittwald_V1_Sshuser_AccessLevel = "full" | "read" | "unspecified";

      type De_Mittwald_V1_Sshuser_AuthType = "password" | "publicKey";

      type De_Mittwald_V1_Sshuser_Authentication =
        | {
            password: string;
          }
        | {
            publicKeys: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_PublicKey[];
          };

      interface De_Mittwald_V1_Sshuser_PublicKey {
        comment: string;
        key: string;
      }

      interface De_Mittwald_V1_Sshuser_SftpUser {
        accessLevel: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_AccessLevel;
        active?: boolean;
        authUpdatedAt: string;
        createdAt: string;
        description: string;
        directories?: string[];
        expiresAt?: string;
        hasPassword: boolean;
        id: string;
        projectId: string;
        publicKeys?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_PublicKey[];
        updatedAt?: string;
        userName: string;
      }

      interface De_Mittwald_V1_Sshuser_SshUser {
        active?: boolean;
        authUpdatedAt: string;
        createdAt: string;
        description: string;
        expiresAt?: string;
        hasPassword: boolean;
        id: string;
        projectId: string;
        publicKeys?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Sshuser_PublicKey[];
        updatedAt?: string;
        userName: string;
      }

      interface De_Mittwald_V1_User_UserFeedback {
        id: string;
        message: string;
        origin: string;
        subject: string;
        vote: number;
      }

      interface De_Mittwald_V1_User_User {
        avatarRef?: string;
        email?: string;
        employeeInformation?: {
          department: string;
        };
        person: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Person;
        phoneNumber?: string;
        registeredAt?: string;
        userId: string;
      }

      interface De_Mittwald_V1_Commons_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_Commons_ValidationErrorSchema {
        message: string;
        path: string;
        type: string;
        context?: {
          [a: string]: any;
        };
      }

      interface De_Mittwald_V1_Commons_ValidationErrors {
        type: "ValidationError";
        message?: string;
        validationErrors: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrorSchema[];
      }

      interface De_Mittwald_V1_Domain_Domain {
        authCode?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_AuthCode;
        authCode2?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_AuthCode2;
        connected: boolean;
        contactHash?: string;
        deleted: boolean;
        domain: string;
        domainId: string;
        handles: {
          adminC?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleReadable;
          ownerC: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleReadable;
        };
        nameservers: string[];
        processes?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_Process[];
        projectId: string;
        transferInAuthCode?: string;
        usesDefaultNameserver: boolean;
      }

      interface De_Mittwald_V1_Dns_Zone {
        domain: string;
        id: string;
        recordSet: {
          caa: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCaa;
          cname: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCname;
          combinedARecords: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCombinedA;
          mx: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordMx;
          srv: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSrv;
          txt: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordTxt;
        };
      }

      type De_Mittwald_V1_Dns_RecordCname =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCnameComponent;

      type De_Mittwald_V1_Dns_RecordMx =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordMxManaged
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordMxCustom;

      type De_Mittwald_V1_Dns_RecordTxt =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordTxtComponent;

      interface De_Mittwald_V1_Dns_TtlSeconds {
        seconds: number;
      }

      interface De_Mittwald_V1_Dns_TtlAuto {
        auto: boolean;
      }

      interface De_Mittwald_V1_App_App {
        actionCapabilities?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_ActionCapabilities;
        id: string;
        name: string;
        tags: string[];
      }

      interface De_Mittwald_V1_App_AppInstallation {
        appId: string;
        appVersion: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_VersionStatus;
        customDocumentRoot?: string;
        description: string;
        disabled: boolean;
        id: string;
        installationPath: string;
        linkedDatabases?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_LinkedDatabase[];
        processes?: string[];
        projectId?: string;
        screenshotId?: string;
        screenshotRef?: string;
        shortId: string;
        systemSoftware?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_InstalledSystemSoftware[];
        updatePolicy?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppUpdatePolicy;
        userInputs?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SavedUserInput[];
      }

      type De_Mittwald_V1_App_AppInstallationLifecycle =
        | "installation"
        | "update"
        | "reconfigure";

      interface De_Mittwald_V1_App_AppVersion {
        appId: string;
        breakingNote?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_BreakingNote;
        databases?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_DatabaseDependency[];
        docRoot: string;
        docRootUserEditable: boolean;
        externalVersion: string;
        id: string;
        internalVersion: string;
        recommended?: boolean;
        requestHandler?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_RequestHandlerRequirement;
        systemSoftwareDependencies?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftwareDependency[];
        userInputs?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_UserInput[];
      }

      interface De_Mittwald_V1_App_BreakingNote {
        faqLink: string;
      }

      interface De_Mittwald_V1_App_DatabaseDependency {
        description: string;
        kind: "mysql";
        parameters?: {
          [a: string]: any;
        };
        version: string;
      }

      interface De_Mittwald_V1_App_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_App_LinkedDatabase {
        databaseId: string;
        databaseUserIds?: {
          [a: string]: any;
        };
        kind: "mysql" | "redis";
        purpose: "primary" | "cache" | "custom";
      }

      interface De_Mittwald_V1_App_SavedUserInput {
        name: string;
        value: string;
      }

      interface De_Mittwald_V1_App_SystemSoftwareDependency {
        systemSoftwareId: string;
        versionRange: string;
      }

      interface De_Mittwald_V1_App_SystemSoftware {
        id: string;
        meta?: {
          [a: string]: any;
        };
        name: string;
        tags: string[];
      }

      interface De_Mittwald_V1_App_SystemSoftwareVersion {
        expiryDate?: string;
        externalVersion: string;
        fee?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Fee_FeeStrategy;
        id: string;
        internalVersion: string;
        recommended?: boolean;
        systemSoftwareDependencies?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftwareDependency[];
        userInputs?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_UserInput[];
      }

      interface De_Mittwald_V1_App_UserInput {
        dataSource?: string;
        dataType: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_UserInputDataType;
        defaultValue?: string;
        format?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_UserInputFormat;
        lifecycleConstraint: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppInstallationLifecycle;
        name: string;
        positionMeta?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_UserInputPositionMeta;
        required: boolean;
        validationSchema: string;
      }

      type De_Mittwald_V1_App_UserInputDataType =
        | "text"
        | "number"
        | "boolean"
        | "select";

      type De_Mittwald_V1_App_UserInputFormat =
        | "email"
        | "password"
        | "url"
        | "uri";

      interface De_Mittwald_V1_App_UserInputPositionMeta {
        index?: number;
        section?: string;
        step?: string;
      }

      interface De_Mittwald_V1_App_VersionStatus {
        current?: string;
        desired: string;
      }

      interface De_Mittwald_V1_Conversation_AggregateReference {
        aggregate: string;
        domain: string;
        id: string;
      }

      interface De_Mittwald_V1_Conversation_Category {
        categoryId: string;
        name: string;
        referenceType: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_CategoryReferenceType;
      }

      interface De_Mittwald_V1_Conversation_Conversation {
        category?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Category;
        conversationId: string;
        createdAt: string;
        createdBy?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_User;
        lastMessageAt?: string;
        lastMessageBy?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_User;
        mainUser: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_User;
        relatedTo?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_AggregateReference;
        relations?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_AggregateReference[];
        sharedWith?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_AggregateReference;
        shortId: string;
        status: "open" | "closed" | "answered" | "inProgress";
        title: string;
        visibility: "shared" | "private";
      }

      interface De_Mittwald_V1_Conversation_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_Conversation_Message {
        conversationId: string;
        createdAt: string;
        createdBy?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_User;
        files?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_File[];
        internal?: boolean;
        messageContent?: string;
        messageId: string;
        type: "MESSAGE";
      }

      interface De_Mittwald_V1_Conversation_User {
        active?: boolean;
        avatarRefId?: string;
        clearName?: string;
        department?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_Department;
        userId: string;
      }

      interface De_Mittwald_V1_App_InstalledSystemSoftware {
        systemSoftwareId: string;
        systemSoftwareVersion: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_VersionStatus;
        updatePolicy: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SystemSoftwareUpdatePolicy;
      }

      interface De_Mittwald_V1_Article_ReadableBookableArticleOptions {
        articleId: string;
        info?: {
          articleName?: string;
          articleTemplateName?: string;
          fromArticleTemplate?: boolean;
        };
        maxArticleCount?: number;
      }

      interface De_Mittwald_V1_Article_ReadableChangeArticleOptions {
        articleId: string;
        info?: {
          articleName?: string;
          articleTemplateName?: string;
          fromArticleTemplate?: boolean;
        };
      }

      interface De_Mittwald_V1_Article_ReadableModifierArticleOptions {
        articleId: string;
        info?: {
          articleName?: string;
          articleTemplateName?: string;
          fromArticleTemplate?: boolean;
        };
        maxArticleCount: number;
      }

      interface De_Mittwald_V1_Order_OrderSummary {
        nonRecurring: number;
        recurring: number;
        summary: number;
      }

      type De_Mittwald_V1_Order_OrderStatus =
        | "NEW"
        | "CONFIRMED"
        | "REJECTED"
        | "ABORTED"
        | "EXECUTED";

      type De_Mittwald_V1_Order_OrderType = "NEW_ORDER" | "CONTRACT_CHANGE";

      interface De_Mittwald_V1_Screenshot_Task {
        executedAt?: string;
        fileReference?: string;
        id: string;
        priority: number;
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Screenshot_ScreenshotSettings;
        target: MittwaldApi.Components.Schemas.De_Mittwald_V1_Screenshot_Target;
        taskState?:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Screenshot_LifecycleState
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
      }

      type De_Mittwald_V1_Screenshot_LifecycleState = string;

      interface De_Mittwald_V1_Screenshot_ScreenshotSettings {
        dataType: "jpeg" | "png" | "webp";
        delay: number;
        height: number;
        quality: number;
        width: number;
      }

      interface De_Mittwald_V1_Contract_TariffChange {
        newArticles: MittwaldApi.Components.Schemas.De_Mittwald_V1_Contract_Article[];
        scheduledAtDate: string;
        scheduledByUserId?: string;
        targetDate: string;
      }

      interface De_Mittwald_V1_Project_MachineType {
        cpu: string;
        memory: string;
        name: string;
      }

      interface De_Mittwald_V1_Conversation_GetConversationIdResponse {
        conversationId: string;
        shortId: string;
      }

      interface De_Mittwald_V1_Backup_BackupTemplate {
        expirationTime: string;
        ignoredSources?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_IgnoredSources;
      }

      interface De_Mittwald_V1_Backup_DatabaseReference {
        kind: string;
        name: string;
      }

      interface De_Mittwald_V1_Backup_IgnoredSources {
        databases?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_DatabaseReference[];
        files: boolean;
      }

      interface De_Mittwald_V1_Backup_ProjectBackup {
        createdAt?: string;
        deletable: boolean;
        description?: string;
        expiresAt?: string;
        export?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackupExport;
        id: string;
        parentId?: string;
        projectId: string;
        requestedAt: string;
        status: string;
      }

      interface De_Mittwald_V1_Conversation_StatusUpdate {
        conversationId: string;
        createdAt: string;
        internal?: boolean;
        messageContent: string;
        meta?: {
          user?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_User;
        };
        type: "STATUS_UPDATE";
      }

      type De_Mittwald_V1_Policy_Policy = string;

      interface De_Mittwald_V1_Messaging_Notification {
        createdAt: string;
        id: string;
        read: boolean;
        reference: MittwaldApi.Components.Schemas.De_Mittwald_V1_Messaging_AggregateReference;
        severity: "success" | "info" | "warning" | "error";
        type: string;
      }

      interface De_Mittwald_V1_Messaging_AggregateReference {
        aggregate: string;
        domain: string;
        id: string;
        parents?: {
          aggregate: string;
          domain: string;
          id: string;
        }[];
      }

      type De_Mittwald_V1_Messaging_NotificationStatus = "read";

      interface De_Mittwald_V1_Mail_MailAddress {
        address: string;
        autoResponder: {
          active: boolean;
          expiresAt?: string;
          message?: string;
          startsAt?: string;
        };
        forwardAddresses: string[];
        id: string;
        isArchived: boolean;
        isCatchAll: boolean;
        mailbox?: {
          name: string;
          passwordUpdatedAt: string;
          sendingEnabled: boolean;
          spamProtection: {
            active: boolean;
            autoDeleteSpam: boolean;
            folder: "spam" | "inbox";
            relocationMinSpamScore: number;
          };
          storageInBytes: {
            current: {
              updatedAt: string;
              value: number;
            };
            limit: number;
          };
        };
        projectId: string;
        receivingDisabled: boolean;
        updatedAt: string;
      }

      interface De_Mittwald_V1_Domain_AuthCode2 {
        expires: string;
      }

      interface De_Mittwald_V1_Domain_CreateDomainHandleData {
        adminC?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleField[];
        ownerC: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleField[];
      }

      interface De_Mittwald_V1_Domain_HandleData {
        handleFields?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleField[];
        handleRef?: string;
      }

      interface De_Mittwald_V1_Domain_HandleField {
        name: string;
        value: string;
      }

      interface De_Mittwald_V1_Domain_HandleReadable {
        current: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleData;
        desired?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_HandleData;
      }

      interface De_Mittwald_V1_Domain_Process {
        error?: string;
        lastUpdate: string;
        processType: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_ProcessType;
        state: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_ProcessState;
        status?: string;
        statusCode?: string;
        transactionId: string;
      }

      type De_Mittwald_V1_Domain_ProcessState =
        | "UNSPECIFIED"
        | "REQUESTED"
        | "FAILED";

      type De_Mittwald_V1_Domain_ProcessType =
        | "UNSPECIFIED"
        | "REGISTER"
        | "TRANSFER"
        | "DELETE"
        | "TRANSIT"
        | "RESTORE"
        | "UPDATE"
        | "TRANSFER_OUT"
        | "OWNER_CHANGE"
        | "DECLARE_REQUESTED";

      type De_Mittwald_V1_Domain_Registrar = "INTERNETX" | "DENIC" | "HEXONET";

      interface De_Mittwald_V1_Domain_TopLevel {
        irtp: boolean;
        rgpDays: number;
        tld: string;
        transferAuthCodeRequired: boolean;
        transferAuthentication: MittwaldApi.Components.Schemas.De_Mittwald_V1_Domain_TransferAuthentication;
      }

      type De_Mittwald_V1_App_AppUpdatePolicy = "none" | "patchLevel" | "all";

      type De_Mittwald_V1_App_SystemSoftwareUpdatePolicy =
        | "none"
        | "inheritedFromApp"
        | "patchLevel"
        | "all";

      type De_Mittwald_V1_Conversation_Department =
        | "development"
        | "mail"
        | "infra"
        | "marketing"
        | "network"
        | "dataCenter"
        | "accounting"
        | "customerService"
        | "cloudHosting"
        | "software"
        | "generic"
        | "security";

      interface De_Mittwald_V1_File_FileMeta {
        friendlyURL: string;
        friendlyUrl: string;
        id: string;
        mimeType: string;
        name: string;
        sizeInBytes: number;
        type: string;
      }

      interface De_Mittwald_V1_File_FileUploadRules {
        extensions: string[];
        fileTypes: MittwaldApi.Components.Schemas.De_Mittwald_V1_File_FileType[];
        maxSizeInBytes: number;
        maxSizeInKB: number;
        maxSizeInKb: number;
        mimeTypes: string[];
        properties?: {
          imageDimensions?: {
            max?: {
              height?: number;
              width?: number;
            };
            min?: {
              height?: number;
              width?: number;
            };
          };
        };
      }

      interface De_Mittwald_V1_Order_DomainHandleField {
        name: string;
        value: string;
      }

      interface De_Mittwald_V1_Database_RedisDatabase {
        configuration?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_RedisDatabaseConfiguration;
        createdAt: string;
        description: string;
        finalizers?: string[];
        hostname: string;
        id: string;
        name: string;
        port: number;
        projectId: string;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_DatabaseStatus;
        statusSetAt: string;
        storageUsageInBytes: number;
        storageUsageInBytesSetAt: string;
        updatedAt: string;
        version: string;
      }

      interface De_Mittwald_V1_Database_RedisVersion {
        disabled: boolean;
        id: string;
        name: string;
        number: string;
      }

      interface De_Mittwald_V1_Database_RedisDatabaseConfiguration {
        additionalFlags?: string[];
        maxMemory?: string;
        maxMemoryPolicy?: string;
        persistent?: boolean;
      }

      type De_Mittwald_V1_Dns_RecordCombinedA =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_CombinedACustom
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_CombinedAManaged;

      type De_Mittwald_V1_Dns_CombinedAManagedAaaaRecord = string;

      type De_Mittwald_V1_Dns_CombinedAManagedARecord = string;

      interface De_Mittwald_V1_Dns_CombinedACustom {
        a: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_CombinedAManagedARecord[];
        aaaa: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_CombinedAManagedAaaaRecord[];
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSettings;
      }

      interface De_Mittwald_V1_Dns_CombinedAManaged {
        managedBy: {
          ingressId: string;
        };
      }

      interface De_Mittwald_V1_Dns_RecordMxCustom {
        records: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordMxRecord[];
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSettings;
      }

      interface De_Mittwald_V1_Dns_RecordMxManaged {
        managed: boolean;
      }

      interface De_Mittwald_V1_Dns_RecordMxRecord {
        fqdn: string;
        priority: number;
      }

      interface De_Mittwald_V1_Dns_RecordSettings {
        ttl?:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_TtlSeconds
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_TtlAuto;
      }

      interface De_Mittwald_V1_Conversation_RequestedFile {
        id: string;
        status: "requested";
      }

      type De_Mittwald_V1_Conversation_File =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_RequestedFile
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_UploadedFile;

      interface De_Mittwald_V1_Conversation_UploadedFile {
        id: string;
        name: string;
        status: "uploaded";
        type: string;
      }

      interface De_Mittwald_V1_Dns_RecordCnameComponent {
        fqdn: string;
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSettings;
      }

      interface De_Mittwald_V1_Dns_RecordTxtComponent {
        entries: string[];
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSettings;
      }

      interface De_Mittwald_V1_Dns_RecordUnset {}

      interface De_Mittwald_V1_Order_HardwareSpec {
        ram?: number;
        vcpu?: number;
      }

      interface De_Mittwald_V1_Order_MachineTypeSpec {
        machineType?: string;
      }

      interface De_Mittwald_V1_App_RequestHandlerRequirement {
        exampleValues?: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_SavedUserInput[];
        name: string;
        namespace: string;
        parametersTemplate: string;
      }

      interface De_Mittwald_V1_Directus_Domain {
        authCode?: string;
        domainOwnerData?: string;
        name: string;
      }

      type De_Mittwald_V1_App_Action = "start" | "stop" | "restart";

      type De_Mittwald_V1_App_ActionCapabilities =
        MittwaldApi.Components.Schemas.De_Mittwald_V1_App_Action[];

      interface De_Mittwald_V1_App_AppInstallationStatus {
        lastExitCode?: number;
        logFileLocation: string;
        state: "running" | "stopped" | "exited";
        uptimeSeconds?: number;
      }

      interface De_Mittwald_V1_Project_AvatarRules {
        maxSizeInKB: number;
        mimeTypes: string[];
        properties?: {
          imageDimensions?: {
            max?: {
              height?: number;
              width?: number;
            };
            min?: {
              height?: number;
              width?: number;
            };
          };
        };
      }

      interface De_Mittwald_V1_Invoice_Cancellation {
        cancellationId: string;
        cancelledAt: string;
        correctionNumber: string;
        pdfId: string;
        reason?: string;
      }

      interface De_Mittwald_V1_Backup_ProjectBackupExport {
        downloadURL?: string;
        expiresAt?: string;
        format: string;
        phase?:
          | ""
          | "Pending"
          | "Exporting"
          | "Failed"
          | "Completed"
          | "Expired";
        withPassword: boolean;
      }

      interface De_Mittwald_V1_Backup_ProjectBackupSchedule {
        createdAt?: string;
        description?: string;
        id: string;
        isSystemBackup: boolean;
        projectId: string;
        schedule: string;
        ttl?: string;
        updatedAt?: string;
      }

      interface De_Mittwald_V1_Commons_Address {
        street: string;
        houseNumber: string;
        city: string;
        zip: string;
        countryCode: string;
        addressPrefix?: string;
      }

      type De_Mittwald_V1_Project_DisableReason =
        | "maliciousCode"
        | "illegalContent"
        | "maliciousConduct"
        | "suspended";

      interface De_Mittwald_V1_Project_Server {
        clusterName: string;
        createdAt: string;
        customerId: string;
        description: string;
        disabledReason?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_ServerDisableReason;
        id: string;
        imageRefId?: string;
        isReady: boolean;
        machineType: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_MachineType;
        readiness: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_DeprecatedServerReadinessStatus;
        shortId: string;
        statisticsBaseDomain?: string;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Project_ServerStatus;
        storage: string;
      }

      interface De_Mittwald_V1_Database_MySqlCharacterSettings {
        collations: string[];
        name: string;
        versionId: string;
      }

      interface De_Mittwald_V1_Commons_Person {
        firstName: string;
        lastName: string;
        title?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Salutation;
      }

      type De_Mittwald_V1_Commons_Salutation = "mr" | "ms" | "other";

      type De_Mittwald_V1_Sshuser_EntityTypes = "ssh" | "sftp";

      interface De_Mittwald_V1_Order_DomainOrderPreview {
        authCode?: string;
        domain: string;
        projectId: string;
      }

      interface De_Mittwald_V1_Order_DomainOrder {
        authCode?: string;
        domain: string;
        handleData: {
          adminC?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_DomainHandleField[];
          ownerC: MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_DomainHandleField[];
        };
        projectId: string;
      }

      interface De_Mittwald_V1_Order_DomainOrderPreviewResponse {
        domainContractDuration: number;
        domainPrice: number;
        feePrice: number;
        totalPrice: number;
      }

      interface De_Mittwald_V1_Order_HostingOrderPreviewResponse {
        machineTypePrice: number;
        storagePrice: number;
        totalPrice: number;
      }

      interface De_Mittwald_V1_Order_ProjectHostingOrderPreview {
        customerId?: string;
        description?: string;
        diskspaceInGiB: number;
        spec:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_MachineTypeSpec
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_HardwareSpec;
      }

      interface De_Mittwald_V1_Order_ProjectHostingOrder {
        customerId: string;
        description: string;
        diskspaceInGiB: number;
        promotionCode?: string;
        recommendationCode?: string;
        spec:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_MachineTypeSpec
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_HardwareSpec;
        useFreeTrial?: boolean;
      }

      interface De_Mittwald_V1_Order_ProjectHostingTariffChange {
        contractId: string;
        diskspaceInGiB: number;
        spec:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_MachineTypeSpec
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Order_HardwareSpec;
      }

      interface De_Mittwald_V1_Order_ServerOrderPreview {
        customerId?: string;
        description?: string;
        diskspaceInGiB: number;
        machineType: string;
      }

      interface De_Mittwald_V1_Order_ServerOrder {
        customerId: string;
        description: string;
        diskspaceInGiB: number;
        machineType: string;
        promotionCode?: string;
        recommendationCode?: string;
        useFreeTrial?: boolean;
      }

      interface De_Mittwald_V1_Order_ServerTariffChange {
        contractId: string;
        diskspaceInGiB: number;
        machineType: string;
      }

      interface De_Mittwald_V1_Invoice_BankingInformation {
        accountHolder: string;
        bic?: string;
        iban: string;
      }

      interface De_Mittwald_V1_Database_CreateMySqlDatabase {
        characterSettings?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Database_CharacterSettings;
        description: string;
        projectId: string;
        version: string;
      }

      interface De_Mittwald_V1_Database_CreateMySqlUser {
        accessIpMask?: string;
        accessLevel: "full" | "readonly";
        databaseId: string;
        description: string;
        externalAccess?: boolean;
        password: string;
      }

      interface De_Mittwald_V1_Database_CreateMySqlUserWithDatabase {
        accessIpMask?: string;
        accessLevel: "full" | "readonly";
        externalAccess?: boolean;
        password: string;
      }

      type De_Mittwald_V1_Project_ServerDisableReason = "suspended";

      interface De_Mittwald_V1_Signup_Account {
        email?: string;
        mfaDetails?: {
          mfaConfirmed?: boolean;
          mfaInitialized?: boolean;
        };
        passwordUpdatedAt?: string;
        person?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Person;
        userId?: string;
      }

      interface De_Mittwald_V1_App_AppJobImage {
        imageTemplate: string;
      }

      interface De_Mittwald_V1_App_AppJobImages {
        reconfigureImage: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppJobImage;
        setupImage: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppJobImage;
        uninstallImage: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppJobImage;
        upgradeImage: MittwaldApi.Components.Schemas.De_Mittwald_V1_App_AppJobImage;
      }

      type De_Mittwald_V1_Dns_RecordSrv =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSrvComponent;

      interface De_Mittwald_V1_Dns_RecordSrvComponent {
        records: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSrvRecord[];
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSettings;
      }

      interface De_Mittwald_V1_Dns_RecordSrvRecord {
        fqdn: string;
        port: number;
        priority?: number;
        weight?: number;
      }

      interface De_Mittwald_V1_Invoice_InvoiceSettingsStatus {
        message: string;
        severity: "success" | "info" | "warning" | "error";
        type:
          | "returnDebitNote"
          | "returnDebitNoteWaitingForPayment"
          | "debtWrittenOff"
          | "bankrupt";
      }

      type De_Mittwald_V1_Conversation_CategoryReferenceType = (
        | "unspecified"
        | "server"
        | "project"
        | "organisation"
      )[];

      interface De_Mittwald_V1_Ingress_TargetUseDefaultPage {
        useDefaultPage: boolean;
      }

      interface De_Mittwald_V1_Domain_AuthCode {
        expires?: string;
        value: string;
      }

      type De_Mittwald_V1_Conversation_ConversationMembers =
        (MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_User & {
          active: boolean;
        })[];

      interface De_Mittwald_V1_Poll_UserPollSettings {
        completedAt?: string;
        dontShowUntil?: string;
        ignoredAt?: string;
        shouldShow: boolean;
        status: "completed" | "muted" | "ignored" | "new";
        userId: string;
      }

      interface De_Mittwald_V1_Strace_Data {
        actualUrl: string;
        dbQueries: {
          query: string;
          stats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
          warnLevel: "NO" | "WARN" | "SEVERE";
        }[];
        dbStats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
        fileOps: {
          filename?: string;
          filepath?: string;
          stats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
          warnLevel: "NO" | "WARN" | "SEVERE";
        }[];
        fileOpsStats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
        miscStats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
        networkingOps: {
          connectionType: "UNKNOWN" | "PRIVATE" | "EXTERNAL";
          description: string;
          ip: string;
          port: number;
          stats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
          warnLevel: "NO" | "WARN" | "SEVERE";
        }[];
        networkingStats: MittwaldApi.Components.Schemas.De_Mittwald_V1_Strace_Statistics;
        slowdownFactor: number;
        ttfbMs: number;
      }

      interface De_Mittwald_V1_Strace_Error {
        errorMessage: string;
      }

      interface De_Mittwald_V1_Strace_Statistics {
        kernelMs: number;
        occurrences: number;
        syscallCount: number;
        userspaceMs: number;
      }

      type De_Mittwald_V1_Project_DeprecatedProjectReadinessStatus =
        | "creating"
        | "ready"
        | "unready";

      type De_Mittwald_V1_Project_ProjectStatus =
        | "pending"
        | "ready"
        | "preparingForVolumeMigration"
        | "migratingVolume"
        | "error"
        | "disabled";

      interface De_Mittwald_V1_Ingress_Ownership {
        txtRecord?: string;
        verified: boolean;
      }

      type De_Mittwald_V1_Project_DeprecatedServerReadinessStatus =
        | "creating"
        | "ready"
        | "unready";

      type De_Mittwald_V1_Project_ServerStatus =
        | "pending"
        | "ready"
        | "unready";

      interface De_Mittwald_V1_Marketplace_Contributor {
        customerId: string;
        description?: string;
        descriptions?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_LocalizedDescription;
        email?: string;
        id: string;
        imprint?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ContributorImprint;
        logoRefId?: string;
        name: string;
        phone?: string;
        state: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ContributorState;
        supportInformation: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SupportMeta;
        url?: string;
      }

      type De_Mittwald_V1_Marketplace_ContributorState = "enabled" | "disabled";

      interface De_Mittwald_V1_Marketplace_Extension {
        assets: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionAsset[];
        blocked: boolean;
        context: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
        contributorId: string;
        deprecation?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionDeprecation;
        description: string;
        detailedDescriptions?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_DetailedDescriptions;
        disabled: boolean;
        externalFrontends?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
        frontendComponents?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
        frontendFragments?: {
          [a: string]: any;
        };
        id: string;
        logoRefId: string;
        name: string;
        pricing?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_MonthlyPricingStrategy;
        published: boolean;
        scopes: string[];
        state: "enabled" | "blocked" | "disabled";
        statistics: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionStatistics;
        subTitle: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SubTitle;
        support: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SupportMeta;
        tags: string[];
      }

      type De_Mittwald_V1_Marketplace_Context = "project" | "customer";

      interface De_Mittwald_V1_Marketplace_ExtensionInstance {
        aggregateReference: {
          aggregate: string;
          domain: string;
          id: string;
        };
        chargeability?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionInstanceChargeability;
        consentedScopes: string[];
        createdAt?: string;
        disabled: boolean;
        extensionId: string;
        id: string;
        pendingInstallation: boolean;
        pendingRemoval: boolean;
      }

      interface De_Mittwald_V1_Marketplace_SupportMeta {
        email?: string;
        phone?: string;
      }

      interface De_Mittwald_V1_Mail_MailsystemSettings {
        imapClusterId: string;
        mailDirectory: string;
        rateLimitId: string;
      }

      interface De_Mittwald_V1_Mailmigration_AutoResponder {
        active: boolean;
        expiresAt?: any;
        message: string;
        startsAt?: any;
      }

      interface De_Mittwald_V1_Mailmigration_MailSystemSettings {
        imapClusterId: string;
        mailDirectory: string;
        rateLimitId: string;
      }

      interface De_Mittwald_V1_Mailmigration_Mailbox {
        mailsystem: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MailSystemSettings;
        name: string;
        quotaInBytes: number;
        spamProtection?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_SpamProtection;
      }

      interface De_Mittwald_V1_Mailmigration_Migration {
        aborted: boolean;
        addresses: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailAddress[];
        finalizers: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationFinalizeJob;
        finished: boolean;
        id: string;
        mailboxes: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailbox[];
        sourceCoabProjectId: string;
        targetNexusProjectId: string;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationFinalizeJob {
        disableLegacyEntities?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationFinalizeJobDisableLegacyEntities;
        projectSettingMigrations?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationFinalizeJobProjectSetting;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationFinalizeJobProjectSetting {
        blacklistEntries: string[];
        whitelistEntries: string[];
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailAddress {
        address: string;
        finished: boolean;
        id: string;
        migrationJobs: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailAddressMigrationJob;
        preMigrationJobs: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailAddressPreMigrationJob;
      }

      interface De_Mittwald_V1_Mailmigration_MigrateMailAddressCommandRequirements {
        address?: string;
        autoResponder?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_AutoResponder;
        forwardAddresses?: string[];
        isCatchAll?: boolean;
        mailbox?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_Mailbox;
        projectId: string;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailAddressMigrationJob {
        migrate: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailAddressMigrationJobMigrate;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailAddressMigrationJobMigrate {
        finished: boolean;
        requirements: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrateMailAddressCommandRequirements;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailAddressPreMigrationJob {
        aliasSet: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailAddressPreMigrationJobAliasSet[];
        deliveryMigrations: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailAddressPreMigrationJobDeliveryMigration[];
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailAddressPreMigrationJobAliasSet {
        finished: boolean;
        sourceCoabMailboxName: string;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailAddressPreMigrationJobDeliveryMigration {
        finished: boolean;
        sourceCoabDeliveryMailbox: string;
        sourceCoabDeliveryUid: number;
        targetDeliveryAddress: string;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailbox {
        description?: string;
        finished: boolean;
        id: string;
        migrationJobs: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailboxJob;
        name: string;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailboxJob {
        migrate: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrationMailboxJobMigrate;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationMailboxJobMigrate {
        requirements: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_MigrateMailboxCommandRequirements;
      }

      interface De_Mittwald_V1_Mailmigration_PossibleCheckErrors {
        alreadyExistingMailAddress: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorAlreadyExistingMailAddress[];
        ambiguousMailAddressDelivery: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorAmbiguousMailAddressDelivery[];
        ambiguousMailboxDelivery: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorAmbiguousMailboxDelivery[];
        catchAllMissingAddress: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorCatchAllMissingAddress[];
        catchAllTargetWithoutAlias: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorCatchAllTargetWithoutAlias[];
        missingVerifiedIngress: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorMissingVerifiedIngress[];
      }

      interface De_Mittwald_V1_Mailmigration_SpamProtection {
        active: boolean;
        deleteSensitivity?: number;
        folder: 0 | 1;
        keepDays: number;
        relocateSensitivity?: number;
      }

      interface De_Mittwald_V1_File_FileType {
        extensions: string[];
        mimeType: string;
      }

      interface De_Mittwald_V1_Ingress_TargetContainer {
        container: {
          id: string;
          portProtocol: string;
        };
      }

      interface De_Mittwald_V1_Marketplace_PublicKey {
        algorithm: string;
        key: string;
        serial: string;
      }

      interface De_Mittwald_V1_Marketplace_ExternalComponent {
        name: string;
        url: string;
      }

      interface De_Mittwald_V1_Ingress_TlsAcmeDeprecated {
        acme: boolean;
      }

      type De_Mittwald_V1_Fee_FeeStrategy =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Fee_OneTimePaymentFeeStrategy
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Fee_PeriodBasedFeeStrategy;

      interface De_Mittwald_V1_Fee_OneTimePaymentFeeStrategy {
        price: number;
      }

      interface De_Mittwald_V1_Fee_PeriodBasedFeeStrategy {
        periods: {
          feeValidFrom?: string;
          feeValidUntil?: string;
          monthlyPrice: number;
        }[];
      }

      interface De_Mittwald_V1_Fee_ResourceFee {
        feeStrategy?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Fee_FeeStrategy;
        id: string;
      }

      type De_Mittwald_V1_Database_DatabaseStatus =
        | "pending"
        | "ready"
        | "migrating"
        | "importing"
        | "error";

      type De_Mittwald_V1_Domain_TransferAuthentication =
        | "unspecified"
        | "code"
        | "email"
        | "push";

      type De_Mittwald_V1_Conversation_ShareableAggregateReference =
        | {
            aggregate: "user";
            domain: "user";
            id: string;
          }
        | {
            aggregate: "customer";
            domain: "customer";
            id: string;
          }
        | {
            aggregate: "project";
            domain: "project";
            id: string;
          }
        | {
            aggregate: "placementgroup";
            domain: "project";
            id: string;
          };

      interface De_Mittwald_V1_Ingress_IngressDeprecated {
        dnsValidationErrors: (
          | "ERROR_UNSPECIFIED"
          | "ERROR_QUAD_A"
          | "ERROR_NO_A_RECORD"
          | "ERROR_ACME_CERTIFICATE_REQUEST_DEADLINE_EXCEEDED"
        )[];
        hostname: string;
        id: string;
        ips: {
          v4: string[];
        };
        isDefault: boolean;
        isDomain?: boolean;
        isEnabled: boolean;
        ownership: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Ownership;
        paths: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_Path[];
        projectId: string;
        tls:
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TlsAcmeDeprecated
          | MittwaldApi.Components.Schemas.De_Mittwald_V1_Ingress_TlsCertificate;
      }

      interface De_Mittwald_V1_Mailmigration_MigrationFinalizeJobDisableLegacyEntities {
        addresses: string[];
        mailboxNames: string[];
      }

      interface De_Mittwald_V1_Mailmigration_MigrateMailboxCommandRequirements {
        mailbox?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_Mailbox;
        projectId: string;
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorAlreadyExistingMailAddress {
        address: string;
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorAmbiguousMailAddressDelivery {
        addresses: string[];
        mailboxName: string;
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorAmbiguousMailboxDelivery {
        address: string;
        mailboxes: string[];
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorCatchAllMissingAddress {
        address: string;
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorCatchAllTargetWithoutAlias {
        address: string;
        mailboxName: string;
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorMissingVerifiedIngress {
        hostname: string;
      }

      interface De_Mittwald_V1_Mailmigration_CheckMigrationIsPossibleErrorResponse {
        errors?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Mailmigration_PossibleCheckErrors;
      }

      interface De_Mittwald_V1_Screenshot_Target {
        domain: string;
        path?: string;
        scheme: "http" | "https";
      }

      interface De_Mittwald_V1_Container_VolumeDeclareRequest {
        name: string;
      }

      interface De_Mittwald_V1_Container_VolumeRequest {
        name?: string;
      }

      interface De_Mittwald_V1_Container_VolumeResponse {
        id: string;
        name: string;
        orphaned: boolean;
        stackId: string;
        storageUsageInBytes: number;
        storageUsageInBytesSetAt: string;
      }

      interface De_Mittwald_V1_Container_ContainerImageConfig {
        command?: string[];
        entrypoint?: string[];
        env?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ContainerImageConfigEnv[];
        exposedPorts?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ContainerImageConfigExposedPort[];
        hasAiGeneratedData: boolean;
        isAiAvailable: boolean;
        isUserRoot: boolean;
        overwritingUser?: number;
        user: string;
        userId: number;
        volumes?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ContainerImageConfigVolume[];
      }

      interface De_Mittwald_V1_Container_ContainerImageConfigEnv {
        key: string;
        value?: string;
        description?: string;
        isSensitive?: boolean;
        isAiGenerated: boolean;
      }

      interface De_Mittwald_V1_Container_ContainerImageConfigExposedPort {
        port: string;
        description?: string;
        isAiGenerated: boolean;
      }

      interface De_Mittwald_V1_Container_ContainerImageConfigVolume {
        volume: string;
        description?: string;
        isAiGenerated: boolean;
      }

      interface De_Mittwald_V1_Container_CreateRegistry {
        uri: string;
        description: string;
        credentials?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_SetRegistryCredentials;
      }

      interface De_Mittwald_V1_Container_RegistryCredentials {
        username: string;
        valid: boolean;
      }

      interface De_Mittwald_V1_Container_Registry {
        id: string;
        projectId: string;
        uri: string;
        description: string;
        credentials?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_RegistryCredentials;
      }

      interface De_Mittwald_V1_Container_SetRegistryCredentials {
        username: string;
        password: string;
      }

      interface De_Mittwald_V1_Container_UpdateRegistry {
        uri?: string;
        description?: string;
        credentials?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_SetRegistryCredentials;
      }

      interface De_Mittwald_V1_Container_ServiceDeclareRequest {
        command?: string[];
        description: string;
        entrypoint?: string[];
        envs?: {
          [a: string]: any;
        };
        image: string;
        ports: string[];
        volumes?: string[];
      }

      interface De_Mittwald_V1_Container_ServiceRequest {
        command?: string[];
        description?: string;
        entrypoint?: string[];
        envs?: {
          [a: string]: any;
        };
        image?: string;
        ports?: string[];
        volumes?: string[];
      }

      interface De_Mittwald_V1_Container_ServiceResponse {
        deployedState: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ServiceState;
        description: string;
        id: string;
        message?: string;
        pendingState: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ServiceState;
        projectId: string;
        serviceName: string;
        shortId: string;
        stackId: string;
        status: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ServiceStatus;
      }

      interface De_Mittwald_V1_Container_ServiceState {
        command?: string[];
        entrypoint?: string[];
        envs?: {
          [a: string]: any;
        };
        image: string;
        imageDigest?: string;
        ports?: string[];
        volumes?: string[];
      }

      type De_Mittwald_V1_Container_ServiceStatus =
        | "running"
        | "stopped"
        | "restarting"
        | "error"
        | "creating"
        | "starting";

      interface De_Mittwald_V1_Container_StackResponse {
        id: string;
        projectId: string;
        description: string;
        services?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_ServiceResponse[];
        volumes?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Container_VolumeResponse[];
        disabled: boolean;
        prefix: string;
      }

      interface De_Mittwald_V1_Marketplace_DetailedDescriptions {
        de: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_DescriptionFormats;
        en?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_DescriptionFormats;
      }

      interface De_Mittwald_V1_Ssl_Certificate {
        caBundle?: string;
        certificate: string;
        certificateOrderId?: string;
        certificateRequestId: string;
        certificateType: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateType;
        commonName?: string;
        contact?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_Contact;
        dnsNames?: string[];
        id: string;
        isExpired: boolean;
        issuer?: string;
        lastExpirationThresholdHit: number;
        projectId: string;
        validFrom: string;
        validTo: string;
      }

      interface De_Mittwald_V1_Ssl_CertificateData {
        caBundle?: string;
        certificate?: string;
        signingRequest?: string;
      }

      interface De_Mittwald_V1_Ssl_CertificateRequest {
        certificateData: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateData;
        certificateType: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateType;
        commonName?: string;
        contact?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_Contact;
        createdAt: string;
        dnsNames?: string[];
        id: string;
        isCompleted: boolean;
        issuer?: string;
        projectId: string;
        validFrom?: string;
        validTo?: string;
      }

      type De_Mittwald_V1_Ssl_CertificateType = 0 | 1 | 2;

      interface De_Mittwald_V1_Ssl_Contact {
        city?: string;
        company?: string;
        country?: string;
        organizationalUnit?: string;
        state?: string;
      }

      interface De_Mittwald_V1_Marketplace_AggregateReferenceFilter {
        aggregate?: "project" | "customer";
        domain?: "project" | "customer";
        id?: string;
      }

      interface De_Mittwald_V1_Marketplace_AggregateReference {
        aggregate: "project" | "customer";
        domain: "project" | "customer";
        id: string;
      }

      interface De_Mittwald_V1_Marketplace_DescriptionFormats {
        markdown: string;
        plain?: string;
      }

      interface De_Mittwald_V1_Domain_SuggestedDomains {
        domains: string[];
      }

      interface De_Mittwald_V1_Order_ExternalCertificateOrderPreview {
        certificateRequestId: string;
        projectId: string;
      }

      interface De_Mittwald_V1_Order_ExternalCertificateOrder {
        certificateRequestId: string;
        projectId: string;
      }

      interface De_Mittwald_V1_Order_ExternalCertificateOrderPreviewResponse {
        feePrice: number;
        recurringPrice: number;
        totalPrice: number;
      }

      interface De_Mittwald_V1_Ssl_CertificateRequestCreateRequest {
        certificate: string;
        privateKey: string;
        projectId: string;
      }

      interface De_Mittwald_V1_Ssl_CertificateRequestCreateResponse {
        commonName?: string;
        contact: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_Contact;
        dnsNames?: string[];
        id: string;
        issuer?: string;
        signingRequest?: string;
        validFrom?: string;
        validTo?: string;
      }

      interface De_Mittwald_V1_Ssl_CertificateRequestCreateWithCsrRequest {
        commonName: string;
        contact: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_Contact;
        projectId: string;
      }

      interface De_Mittwald_V1_Ssl_CheckReplaceChanges {
        commonName?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceFieldChange;
        dnsNames?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceSliceChange;
        issuer?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceFieldChange;
        validFrom?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceDateChange;
        validTo?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceDateChange;
      }

      interface De_Mittwald_V1_Ssl_CheckReplaceDateChange {
        newValue: string;
        oldValue: string;
      }

      interface De_Mittwald_V1_Ssl_CheckReplaceFieldChange {
        newValue: string;
        oldValue: string;
      }

      interface De_Mittwald_V1_Ssl_CheckReplaceCertificateResponse {
        changes?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CheckReplaceChanges;
        errors?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Ssl_CertificateError[];
        isReplaceable: boolean;
      }

      interface De_Mittwald_V1_Ssl_CheckReplaceSliceChange {
        addedValues: string[];
        removedValues: string[];
        values: string[];
      }

      interface De_Mittwald_V1_Ssl_CertificateError {
        message:
          | "certificate_read_failed"
          | "certificate_decode_failed"
          | "certificate_parsing_failed"
          | "certificate_self_signed"
          | "certificate_not_authorized_to_sign"
          | "certificate_expired"
          | "ca_not_authorized_for_this_name"
          | "too_many_intermediates"
          | "incompatible_usage"
          | "unknown_authority"
          | "private_key_read_failed"
          | "private_key_decode_failed"
          | "private_key_parse_failed"
          | "private_key_encrypted"
          | "private_key_not_rsa"
          | "private_key_mismatch"
          | "unknown_cloudflare_error"
          | "unknown";
      }

      interface De_Mittwald_V1_Marketplace_BackendComponent {
        url: string;
      }

      interface De_Mittwald_V1_Marketplace_BackendComponents {
        extensionAddedToContext?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_BackendComponent;
        extensionInstanceRemovedFromContext?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_BackendComponent;
        extensionInstanceSecretRotated?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_BackendComponent;
        extensionInstanceUpdated?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_BackendComponent;
      }

      type De_Mittwald_V1_Marketplace_FrontendFragment = {
        additionalProperties?: {
          [a: string]: any;
        };
      } & MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_UrlFrontendFragment;

      interface De_Mittwald_V1_Marketplace_UrlFrontendFragment {
        url: string;
      }

      type De_Mittwald_V1_Marketplace_WebhookKind =
        | "extension-added-to-context"
        | "extension-instance-updated"
        | "extension-instance-secret-rotated"
        | "extension-instance-removed-from-context";

      type De_Mittwald_V1_Storagespace_StatisticsCategoryKind =
        | "webspace"
        | "projectBackup"
        | "mailAddress"
        | "mysqlDatabase"
        | "redisDatabase"
        | "containerVolume";

      interface De_Mittwald_V1_Storagespace_StatisticsMeta {
        isExceeding?: boolean;
        limitInBytes?: number;
        notificationThresholdUsedAsLimit?: boolean;
        totalExceedanceInBytes?: number;
        totalExceedanceInBytesSetAt?: string;
        totalFreeInBytes?: number;
        totalFreeInPercentage?: number;
        totalUsageInBytes: number;
        totalUsageInPercentage?: number;
      }

      interface De_Mittwald_V1_Storagespace_StatisticsResource {
        description?: string;
        id: string;
        name: string;
        usageInBytes: number;
        usageInBytesSetAt: string;
      }

      interface De_Mittwald_V1_Storagespace_Statistics {
        childStatistics?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_Statistics[];
        description?: string;
        id: string;
        kind: MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_StatisticsKind;
        meta: MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_StatisticsMeta;
        name: string;
        notificationThresholdInBytes?: number;
        statisticCategories?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_StatisticsCategory[];
      }

      type De_Mittwald_V1_Storagespace_StatisticsKind = "server" | "project";

      interface De_Mittwald_V1_Storagespace_StatisticsCategory {
        kind: MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_StatisticsCategoryKind;
        resources?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Storagespace_StatisticsResource[];
        totalUsageInBytes: number;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionHealth {
        extensionInstances: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionInstanceHealth[];
        functional: boolean;
        id: string;
        inoperableReason?: string;
        published: boolean;
        withdrawalReason?: string;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionInstanceHealth {
        aggregateReference: {
          aggregate: string;
          domain: string;
          id: string;
        };
        id: string;
        instantiationIsPending: boolean;
        pendingWebhooksCount: number;
        removalIsPending: boolean;
        webhooksAreHalted: boolean;
      }

      interface De_Mittwald_V1_Conversation_ServiceRequestRelocationPayload {
        contact: {
          email: string;
          firstname: string;
          lastname: string;
          phone?: string;
        };
        domain?: {
          allDomains?: boolean;
          domains?: {
            authCode?: string;
            domainName?: string;
          }[];
        };
        notes?: string;
        preferredRelocationDate?: string;
        redirectusKey: number;
        source: {
          providerName: string;
          providerPassword: string;
          providerUrl: string;
          providerUsername: string;
          sourceAccount: string;
        };
        target: {
          accountShortId: string;
          application?: string;
          organisation: string;
          prices?: {
            name?: string;
            price?: number;
          }[];
          product: string;
          articleType?: string;
          withDataCompare?: boolean;
        };
        userId: string;
      }

      interface De_Mittwald_V1_Conversation_ServiceRequest {
        conversationId: string;
        createdAt: string;
        files?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_File[];
        internal: boolean;
        messageContent: "relocation" | "call";
        messageId: string;
        meta: MittwaldApi.Components.Schemas.De_Mittwald_V1_Conversation_ServiceRequestRelocationPayload;
        type: "SERVICE_REQUEST";
      }

      interface De_Mittwald_V1_User_CustomerMembership {
        expiresAt?: string;
        memberSince: string;
        role: "owner" | "member" | "accountant";
      }

      interface De_Mittwald_V1_User_ProjectMembership {
        expiresAt?: string;
        inherited: boolean;
        memberSince: string;
        role: "owner" | "emailadmin" | "external";
      }

      type De_Mittwald_V1_Database_DatabaseUserStatus =
        | "pending"
        | "ready"
        | "error"
        | "terminating"
        | "disabled";

      type De_Mittwald_V1_Dns_RecordCaa =
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordUnset
        | MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCaaComponent;

      interface De_Mittwald_V1_Dns_RecordCaaComponent {
        records: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordCaaRecord[];
        settings: MittwaldApi.Components.Schemas.De_Mittwald_V1_Dns_RecordSettings;
      }

      interface De_Mittwald_V1_Dns_RecordCaaRecord {
        flags: number;
        tag: "issue" | "issuewild" | "iodef";
        value: string;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionDeprecation {
        deprecatedAt: string;
        note?: string;
        successorId?: string;
      }

      interface De_Mittwald_V1_Marketplace_OwnExtension {
        assets: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionAsset[];
        backendComponents?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_BackendComponents;
        blocked?: boolean;
        context?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
        contributorId: string;
        deprecation?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionDeprecation;
        description?: string;
        detailedDescriptions?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_DetailedDescriptions;
        disabled?: boolean;
        externalFrontends?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
        frontendComponents?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExternalComponent[];
        frontendFragments?: {
          [a: string]: any;
        };
        functional: boolean;
        id: string;
        logoRefId?: string;
        name: string;
        pricing?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_MonthlyPricingStrategy;
        published: boolean;
        requestedChanges?: {
          context?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_Context;
          scopes?: string[];
          webhookUrls?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrls;
        };
        scopes?: string[];
        secrets: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionSecret[];
        state?: "enabled" | "blocked" | "disabled";
        statistics: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ExtensionStatistics;
        subTitle?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SubTitle;
        support?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SupportMeta;
        tags?: string[];
        verificationRequested: boolean;
        verified: boolean;
        webhookUrls?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrls;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionAsset {
        assetType: "image" | "video";
        fileName?: string;
        id: string;
        index: number;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionStatistics {
        amountOfInstances?: number;
      }

      interface De_Mittwald_V1_Marketplace_WebhookUrl {
        url: string;
      }

      interface De_Mittwald_V1_Marketplace_WebhookUrls {
        extensionAddedToContext: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrl;
        extensionInstanceRemovedFromContext: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrl;
        extensionInstanceSecretRotated: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrl;
        extensionInstanceUpdated: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_WebhookUrl;
      }

      interface De_Mittwald_V1_Marketplace_SubTitle {
        de: string;
        en?: string;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionSecret {
        secretId: string;
        usableUntil?: string;
      }

      type De_Mittwald_V1_Customer_CustomerFlag = "agency" | "employee";

      interface De_Mittwald_V1_Marketplace_MonthlyPricingStrategy {
        netPrice: number;
      }

      interface De_Mittwald_V1_Marketplace_OwnContributor {
        contactPersonUserId: string;
        contractOwner: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Contact;
        contributorNumber: string;
        customerId: string;
        description?: string;
        email?: string;
        id: string;
        imprint?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ContributorImprint;
        logoRefId?: string;
        name: string;
        phone?: string;
        state: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_ContributorState;
        supportInformation: MittwaldApi.Components.Schemas.De_Mittwald_V1_Marketplace_SupportMeta;
        url?: string;
      }

      type De_Mittwald_V1_Extension_ExtensionInstanceContract =
        MittwaldApi.Components.Schemas.De_Mittwald_V1_Extension_SubscriptionBasedContract;

      interface De_Mittwald_V1_Extension_SubscriptionBasedContract {
        interactionDeadline?: string;
        interactionRequired: boolean;
        status: "notStarted" | "active" | "terminationPending";
        terminationTargetDate?: string;
      }

      type De_Mittwald_V1_Marketplace_ContributorImprint =
        | {
            text: string;
          }
        | {
            url: string;
          };

      interface De_Mittwald_V1_Commons_Contact {
        firstName?: string;
        lastName?: string;
        title?: string;
        salutation: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Salutation;
        company?: string;
        address: MittwaldApi.Components.Schemas.De_Mittwald_V1_Commons_Address;
        emailAddress?: string;
        phoneNumbers?: string[];
        useFormalTerm?: boolean;
      }

      interface De_Mittwald_V1_Marketplace_LocalizedDescription {
        de: string;
        en?: string;
      }

      interface De_Mittwald_V1_Marketplace_ExtensionInstanceChargeability {
        isChargeable: boolean;
        reasons: {
          isOwnExtension: boolean;
        };
      }

      interface De_Mittwald_V1_Order_LeadFyndrTariffChange {
        contractId: string;
        reservationLimit: number;
        unlockLimit: number;
      }

      interface De_Mittwald_V1_Leadfyndr_BasicCompany {
        city: string;
        employeeCount?: number;
        foundingYear?: number;
        salesVolume?: number;
      }

      interface De_Mittwald_V1_Leadfyndr_BasicMetrics {
        co2?: number;
        contentLoaded?: number;
        desktop: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Lighthouse;
        mobile: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Lighthouse;
        timeToFirstByteMs?: number;
      }

      interface De_Mittwald_V1_Leadfyndr_Contact {
        address?: {
          address_prefix?: string;
          city?: string;
          country_code?: string;
          house_number?: string;
          street?: string;
          zip?: string;
        };
      }

      interface De_Mittwald_V1_Leadfyndr_DetailMetrics {
        additionalMetrics?: {
          [a: string]: any;
        };
        basic: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_BasicMetrics;
      }

      type De_Mittwald_V1_Leadfyndr_DetailCompany =
        MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_BasicCompany & {
          coreProduct: string[];
          name?: string;
          targetGroup: string[];
        };

      interface De_Mittwald_V1_Leadfyndr_Hoster {
        mailServer: string[];
        nameServer: string[];
        server: string[];
      }

      interface De_Mittwald_V1_Leadfyndr_Lead {
        businessFields: string[];
        company: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_BasicCompany;
        description: string;
        globalUnlockedCount: number;
        hoster: {
          server: string[];
        };
        leadId: string;
        mainTechnology?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Technology;
        metrics: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_BasicMetrics;
        potential: number;
        scannedAt?: string;
        screenshot: string;
        technologies: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Technology[];
      }

      interface De_Mittwald_V1_Leadfyndr_Lighthouse {
        accessibility?: number;
        bestPractice?: number;
        cumulativeLayoutShift?: number;
        firstContentfulPaint?: number;
        largestContentfulPaint?: number;
        performance?: number;
        seo?: number;
        totalBlockingTime?: number;
      }

      interface De_Mittwald_V1_Leadfyndr_Metric {
        category: string;
        name: string;
        score?: number;
        unit?: string;
        value?: number;
      }

      interface De_Mittwald_V1_Leadfyndr_Profile {
        approvedOn: string;
        customerId: string;
        disabledOn?: string;
        domain: string;
      }

      interface De_Mittwald_V1_Leadfyndr_ProfileRequest {
        createdOn: string;
        customerId: string;
        domain: string;
        profileId: string;
        requestedBy: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_User;
        resultOn?: string;
        status:
          | "AUTOTEST_INIT"
          | "MANUAL_VERIFICATION"
          | "REJECTED"
          | "APPROVED";
      }

      interface De_Mittwald_V1_Leadfyndr_TariffOptions {
        reservation: {
          available: number;
          tariffLimit: number;
          used: number;
        };
        unlocked: {
          available: number;
          tariffLimit: number;
          used: number;
        };
      }

      interface De_Mittwald_V1_Leadfyndr_SocialMedia {
        network: string;
        url: string;
      }

      interface De_Mittwald_V1_Leadfyndr_Technology {
        categories?: {
          name: string;
          parentCategories?: string[];
          priority: number;
        }[];
        categoryPriority: number;
        name: string;
        version?: string;
      }

      interface De_Mittwald_V1_Leadfyndr_User {
        userId: string;
      }

      interface De_Mittwald_V1_Leadfyndr_UnlockedLead {
        businessFields: string[];
        company: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_DetailCompany;
        contact: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Contact;
        description: string;
        domain: string;
        globalUnlockedCount: number;
        hoster: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Hoster;
        leadId: string;
        mainTechnology?: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Technology;
        metrics: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_DetailMetrics;
        potential: number;
        reservedAt?: string;
        scannedAt?: string;
        screenshot: string;
        socialMedia: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_SocialMedia[];
        technologies: MittwaldApi.Components.Schemas.De_Mittwald_V1_Leadfyndr_Technology[];
        unlockedAt: string;
      }
    }

    namespace Parameters {}

    namespace Responses {
      type De_Mittwald_V1_Addon_BenefitSuccessResponse = any;

      type De_Mittwald_V1_Addon_GenericResponse = any;

      type De_Mittwald_V1_Article_GenericResponse = any;

      type De_Mittwald_V1_Contract_GenericResponse = any;

      type De_Mittwald_V1_Customer_GenericResponse = any;

      type De_Mittwald_V1_Customer_FailedPreconditionError = any;

      type De_Mittwald_V1_Hermes_GenericResponse = any;

      type De_Mittwald_V1_Hypnos_GenericResponse = any;

      type De_Mittwald_V1_Invoice_DefaultError = any;

      type De_Mittwald_V1_Invoice_GenericResponse = any;

      type De_Mittwald_V1_Invoice_EmptyResponse = any;

      type De_Mittwald_V1_Invoice_NotFoundError = any;

      type De_Mittwald_V1_Invoice_ValidationError = any;

      type De_Mittwald_V1_Mail_DefaultError = any;

      type De_Mittwald_V1_Mail_GenericResponse = any;

      type De_Mittwald_V1_Mail_EmptyResponse = any;

      type De_Mittwald_V1_Mail_NotFoundError = any;

      type De_Mittwald_V1_Mail_ValidationError = any;

      type De_Mittwald_V1_Order_GenericResponse = any;

      type De_Mittwald_V1_Domain_DefaultError = any;

      type De_Mittwald_V1_Domain_GenericResponse = any;

      type De_Mittwald_V1_Domain_EmptyResponse = any;

      type De_Mittwald_V1_Domain_NotFoundError = any;

      type De_Mittwald_V1_Domain_ValidationError = any;

      type De_Mittwald_V1_Signup_InternalServerError = any;

      type De_Mittwald_V1_Signup_NoValidAccessTokenError = any;

      type De_Mittwald_V1_Common_RateLimitError = any;

      type De_Mittwald_V1_Signup_RemovingLastOwnerNotAllowedError = any;

      type De_Mittwald_V1_Signup_SecondFactorRequiredError = any;

      type De_Mittwald_V1_Commons_DefaultError = any;

      type De_Mittwald_V1_Commons_NotFoundError = any;

      type De_Mittwald_V1_Commons_ValidationError = any;
    }

    namespace RequestBodies {}
  }

  namespace Definitions {}
}

/**
 * ====================================
 * Descriptors
 * ====================================
 */

export const contractGetDetailOfContract: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}",
  method: "get",
  operationId: "contractGetDetailOfContract",
};

export const contractCancelContractItemTermination: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/items/{contractItemId}/termination",
  method: "delete",
  operationId: "contractCancelContractItemTermination",
};

export const contractTerminateContractItem: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Termination.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/items/{contractItemId}/termination",
  method: "post",
  operationId: "contractTerminateContractItem",
};

export const contractCancelContractTermination: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/termination",
  method: "delete",
  operationId: "contractCancelContractTermination",
};

export const contractTerminateContract: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Termination.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/termination",
  method: "post",
  operationId: "contractTerminateContract",
};

export const contractGetDetailOfContractItem: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/items/{contractItemId}",
  method: "get",
  operationId: "contractGetDetailOfContractItem",
};

export const contractListContracts: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Responses.$200.Headers;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Contracts.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/contracts",
  method: "get",
  operationId: "contractListContracts",
};

export const cronjobCreateCronjob: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/cronjobs",
  method: "post",
  operationId: "cronjobCreateCronjob",
};

export const cronjobListCronjobs: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Cronjobs.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/cronjobs",
  method: "get",
  operationId: "cronjobListCronjobs",
};

export const cronjobCreateExecution: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}/executions",
  method: "post",
  operationId: "cronjobCreateExecution",
};

export const cronjobListExecutions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}/executions",
  method: "get",
  operationId: "cronjobListExecutions",
};

export const cronjobDeleteCronjob: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}",
  method: "delete",
  operationId: "cronjobDeleteCronjob",
};

export const cronjobGetCronjob: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}",
  method: "get",
  operationId: "cronjobGetCronjob",
};

export const cronjobUpdateCronjob: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}",
  method: "patch",
  operationId: "cronjobUpdateCronjob",
};

export const cronjobGetExecution: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}/executions/{executionId}",
  method: "get",
  operationId: "cronjobGetExecution",
};

export const customerRemoveAvatar: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Delete.Responses.$401.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Delete.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/avatar",
  method: "delete",
  operationId: "customerRemoveAvatar",
};

export const customerRequestAvatarUpload: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Responses.$401.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Avatar.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/avatar",
  method: "post",
  operationId: "customerRequestAvatarUpload",
};

export const customerCreateCustomer: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers",
  method: "post",
  operationId: "customerCreateCustomer",
};

export const customerListCustomers: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Customers.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customers.Get.Responses.$200.Headers;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers",
  method: "get",
  operationId: "customerListCustomers",
};

export const customerDeleteCustomer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}",
  method: "delete",
  operationId: "customerDeleteCustomer",
};

export const customerGetCustomer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Responses.$401.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}",
  method: "get",
  operationId: "customerGetCustomer",
};

export const customerUpdateCustomer: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}",
  method: "put",
  operationId: "customerUpdateCustomer",
};

export const databaseListMysqlCharsets: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Charsets.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-charsets",
  method: "get",
  operationId: "databaseListMysqlCharsets",
};

export const ingressDeleteIngress: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ingresses_IngressId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ingresses_IngressId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses/{ingressId}",
  method: "delete",
  operationId: "ingressDeleteIngress",
};

export const ingressGetIngress: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ingresses_IngressId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ingresses_IngressId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses/{ingressId}",
  method: "get",
  operationId: "ingressGetIngress",
};

export const ingressCreateIngress: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Ingresses.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Ingresses.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses",
  method: "post",
  operationId: "ingressCreateIngress",
};

export const ingressListIngresses: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ingresses.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Ingresses.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Ingresses.Get.Responses.$200.Headers;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses",
  method: "get",
  operationId: "ingressListIngresses",
};

export const ingressUpdateIngressPaths: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Ingresses_IngressId_Paths.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Ingresses_IngressId_Paths.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ingresses_IngressId_Paths.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Paths.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Paths.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Paths.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses/{ingressId}/paths",
  method: "patch",
  operationId: "ingressUpdateIngressPaths",
};

export const ingressUpdateIngressTls: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Tls.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses/{ingressId}/tls",
  method: "patch",
  operationId: "ingressUpdateIngressTls",
};

export const invoiceListCustomerInvoices: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/invoices",
  method: "get",
  operationId: "invoiceListCustomerInvoices",
};

export const projectFileSystemGetJwt: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Jwt.Get.Responses.$503.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/jwt",
  method: "get",
  operationId: "projectFileSystemGetJwt",
};

export const projectListProjects: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Projects.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects.Get.Responses.$200.Headers;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects",
  method: "get",
  operationId: "projectListProjects",
};

export const orderListCustomerOrders: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Orders.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Orders.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Orders.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Orders.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Orders.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Orders.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/orders",
  method: "get",
  operationId: "orderListCustomerOrders",
};

export const appGetApp: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Apps_AppId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Apps_AppId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/apps/{appId}",
  method: "get",
  operationId: "appGetApp",
};

export const appListApps: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Apps.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Apps.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Apps.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/apps",
  method: "get",
  operationId: "appListApps",
};

export const conversationCreateConversation: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Conversations.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Conversations.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations",
  method: "post",
  operationId: "conversationCreateConversation",
};

export const conversationListConversations: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversations.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations",
  method: "get",
  operationId: "conversationListConversations",
};

export const conversationCreateMessage: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/messages",
  method: "post",
  operationId: "conversationCreateMessage",
};

export const conversationListMessagesByConversation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/messages",
  method: "get",
  operationId: "conversationListMessagesByConversation",
};

export const conversationGetConversation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}",
  method: "get",
  operationId: "conversationGetConversation",
};

export const conversationUpdateConversation: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}",
  method: "put",
  operationId: "conversationUpdateConversation",
};

export const conversationUpdateMessage: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Messages_MessageId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/messages/{messageId}",
  method: "patch",
  operationId: "conversationUpdateMessage",
};

export const projectDeleteProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}",
  method: "delete",
  operationId: "projectDeleteProject",
};

export const projectGetProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}",
  method: "get",
  operationId: "projectGetProject",
};

export const articleGetArticle: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles_ArticleId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/articles/{articleId}",
  method: "get",
  operationId: "articleGetArticle",
};

export const articleListArticles: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Articles.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Articles.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Articles.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Articles.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/articles",
  method: "get",
  operationId: "articleListArticles",
};

export const projectDeleteProjectAvatar: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/avatar",
  method: "delete",
  operationId: "projectDeleteProjectAvatar",
};

export const projectRequestProjectAvatarUpload: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Avatar.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/avatar",
  method: "post",
  operationId: "projectRequestProjectAvatarUpload",
};

export const customerIsCustomerLegallyCompetent: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Legally_Competent.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/legally-competent",
  method: "get",
  operationId: "customerIsCustomerLegallyCompetent",
};

export const conversationListCategories: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversation_Categories.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversation-categories",
  method: "get",
  operationId: "conversationListCategories",
};

export const conversationGetCategory: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversation_Categories_CategoryId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversation-categories/{categoryId}",
  method: "get",
  operationId: "conversationGetCategory",
};

export const contractCancelContractTariffChange: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Tariff_Change.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/items/{contractItemId}/tariff-change",
  method: "delete",
  operationId: "contractCancelContractTariffChange",
};

export const conversationSetConversationStatus: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Status.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/status",
  method: "put",
  operationId: "conversationSetConversationStatus",
};

export const notificationsListNotifications: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Notifications.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Notifications.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Notifications.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/notifications",
  method: "get",
  operationId: "notificationsListNotifications",
};

export const orderGetOrder: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Orders_OrderId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Orders_OrderId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders_OrderId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders_OrderId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders_OrderId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/orders/{orderId}",
  method: "get",
  operationId: "orderGetOrder",
};

export const domainListDomains: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Domains.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains",
  method: "get",
  operationId: "domainListDomains",
};

export const domainUpdateDomainNameservers: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Nameservers.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/nameservers",
  method: "patch",
  operationId: "domainUpdateDomainNameservers",
};

export const domainDeleteDomain: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Parameters.Path;

    query: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}",
  method: "delete",
  operationId: "domainDeleteDomain",
};

export const domainGetDomain: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains_DomainId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}",
  method: "get",
  operationId: "domainGetDomain",
};

export const conversationRequestFileUpload: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/files",
  method: "post",
  operationId: "conversationRequestFileUpload",
};

export const domainResendDomainEmail: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Resend_Email.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Resend_Email.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Resend_Email.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Resend_Email.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Resend_Email.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Resend_Email.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/actions/resend-email",
  method: "post",
  operationId: "domainResendDomainEmail",
};

export const relocationCreateRelocation: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Relocation.Post.Parameters.RequestBody;

    header?: MittwaldApi.Paths.V2_Relocation.Post.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Relocation.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Relocation.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Relocation.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/relocation",
  method: "post",
  operationId: "relocationCreateRelocation",
};

export const orderListProjectOrders: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Orders.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Orders.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Orders.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Orders.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Orders.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Orders.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/orders",
  method: "get",
  operationId: "orderListProjectOrders",
};

export const invoiceGetDetailOfInvoiceSettings: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/invoice-settings",
  method: "get",
  operationId: "invoiceGetDetailOfInvoiceSettings",
};

export const invoiceUpdateInvoiceSettings: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoice_Settings.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/invoice-settings",
  method: "put",
  operationId: "invoiceUpdateInvoiceSettings",
};

export const fileCreateFile: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Files.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$401.Content.Application_Json;
    })
  | ({ status: 406 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$406.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/files",
  method: "post",
  operationId: "fileCreateFile",
};

export const backupCreateProjectBackup: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/backups",
  method: "post",
  operationId: "backupCreateProjectBackup",
};

export const backupListProjectBackups: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backups.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/backups",
  method: "get",
  operationId: "backupListProjectBackups",
};

export const backupCreateProjectBackupSchedule: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/backup-schedules",
  method: "post",
  operationId: "backupCreateProjectBackupSchedule",
};

export const backupListProjectBackupSchedules: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Backup_Schedules.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/backup-schedules",
  method: "get",
  operationId: "backupListProjectBackupSchedules",
};

export const backupDeleteProjectBackup: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backups/{projectBackupId}",
  method: "delete",
  operationId: "backupDeleteProjectBackup",
};

export const backupGetProjectBackup: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backups/{projectBackupId}",
  method: "get",
  operationId: "backupGetProjectBackup",
};

export const backupCreateProjectBackupExport: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backups/{projectBackupId}/export",
  method: "post",
  operationId: "backupCreateProjectBackupExport",
};

export const backupDeleteProjectBackupExport: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Export.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backups/{projectBackupId}/export",
  method: "delete",
  operationId: "backupDeleteProjectBackupExport",
};

export const backupDeleteProjectBackupSchedule: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backup-schedules/{projectBackupScheduleId}",
  method: "delete",
  operationId: "backupDeleteProjectBackupSchedule",
};

export const backupGetProjectBackupSchedule: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backup-schedules/{projectBackupScheduleId}",
  method: "get",
  operationId: "backupGetProjectBackupSchedule",
};

export const backupUpdateProjectBackupSchedule: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backup_Schedules_ProjectBackupScheduleId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backup-schedules/{projectBackupScheduleId}",
  method: "patch",
  operationId: "backupUpdateProjectBackupSchedule",
};

export const backupUpdateProjectBackupDescription: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Backups_ProjectBackupId_Description.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-backups/{projectBackupId}/description",
  method: "patch",
  operationId: "backupUpdateProjectBackupDescription",
};

export const cronjobUpdateCronjobAppId: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_App_Id.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}/app-id",
  method: "patch",
  operationId: "cronjobUpdateCronjobAppId",
};

export const contractGetBaseItemOfContract: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Base_Items.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/base-items",
  method: "get",
  operationId: "contractGetBaseItemOfContract",
};

export const contractGetNextTerminationDateForItem: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contracts_ContractId_Items_ContractItemId_Next_Termination_Dates.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contracts/{contractId}/items/{contractItemId}/next-termination-dates",
  method: "get",
  operationId: "contractGetNextTerminationDateForItem",
};

export const projectDeleteServerAvatar: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/avatar",
  method: "delete",
  operationId: "projectDeleteServerAvatar",
};

export const projectRequestServerAvatarUpload: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Avatar.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/avatar",
  method: "post",
  operationId: "projectRequestServerAvatarUpload",
};

export const projectListServers: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Servers.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Servers.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers",
  method: "get",
  operationId: "projectListServers",
};

export const projectGetServer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Servers_ServerId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}",
  method: "get",
  operationId: "projectGetServer",
};

export const projectCreateProject: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Projects.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/projects",
  method: "post",
  operationId: "projectCreateProject",
};

export const projectUpdateServerDescription: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Description.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/description",
  method: "patch",
  operationId: "projectUpdateServerDescription",
};

export const databaseCreateMysqlDatabase: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/mysql-databases",
  method: "post",
  operationId: "databaseCreateMysqlDatabase",
};

export const databaseListMysqlDatabases: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mysql_Databases.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/mysql-databases",
  method: "get",
  operationId: "databaseListMysqlDatabases",
};

export const databaseCreateRedisDatabase: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/redis-databases",
  method: "post",
  operationId: "databaseCreateRedisDatabase",
};

export const databaseListRedisDatabases: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Redis_Databases.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/redis-databases",
  method: "get",
  operationId: "databaseListRedisDatabases",
};

export const databaseListMysqlVersions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Versions.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Mysql_Versions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Versions.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Versions.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Versions.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Versions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Versions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-versions",
  method: "get",
  operationId: "databaseListMysqlVersions",
};

export const databaseListRedisVersions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Redis_Versions.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Redis_Versions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Versions.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Versions.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Versions.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Versions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Versions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/redis-versions",
  method: "get",
  operationId: "databaseListRedisVersions",
};

export const customerGetCustomerTokenInvite: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Token_Invite.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Token_Invite.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Token_Invite.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Token_Invite.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Token_Invite.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-token-invite",
  method: "get",
  operationId: "customerGetCustomerTokenInvite",
};

export const customerCreateCustomerInvite: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/invites",
  method: "post",
  operationId: "customerCreateCustomerInvite",
};

export const customerListInvitesForCustomer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Responses.$200.Headers;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invites.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/invites",
  method: "get",
  operationId: "customerListInvitesForCustomer",
};

export const customerListMembershipsForCustomer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Responses.$200.Headers;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Memberships.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/memberships",
  method: "get",
  operationId: "customerListMembershipsForCustomer",
};

export const projectGetProjectTokenInvite: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Token_Invite.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Token_Invite.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Token_Invite.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Token_Invite.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Token_Invite.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-token-invite",
  method: "get",
  operationId: "projectGetProjectTokenInvite",
};

export const projectCreateProjectInvite: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/invites",
  method: "post",
  operationId: "projectCreateProjectInvite",
};

export const projectListInvitesForProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Responses.$200.Headers;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Invites.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/invites",
  method: "get",
  operationId: "projectListInvitesForProject",
};

export const customerListCustomerInvites: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Invites.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Customer_Invites.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customer_Invites.Get.Responses.$200.Headers;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-invites",
  method: "get",
  operationId: "customerListCustomerInvites",
};

export const customerListCustomerMemberships: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Memberships.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Customer_Memberships.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customer_Memberships.Get.Responses.$200.Headers;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-memberships",
  method: "get",
  operationId: "customerListCustomerMemberships",
};

export const projectListMembershipsForProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Responses.$200.Headers;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/memberships",
  method: "get",
  operationId: "projectListMembershipsForProject",
};

export const projectListProjectInvites: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Invites.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Project_Invites.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Project_Invites.Get.Responses.$200.Headers;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-invites",
  method: "get",
  operationId: "projectListProjectInvites",
};

export const projectListProjectMemberships: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Memberships.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Project_Memberships.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Project_Memberships.Get.Responses.$200.Headers;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-memberships",
  method: "get",
  operationId: "projectListProjectMemberships",
};

export const customerCreateCategory: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customer_Categories.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customer_Categories.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-categories",
  method: "post",
  operationId: "customerCreateCategory",
};

export const customerListOfCustomerCategories: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Categories.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-categories",
  method: "get",
  operationId: "customerListOfCustomerCategories",
};

export const customerDeleteCategory: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-categories/{categoryId}",
  method: "delete",
  operationId: "customerDeleteCategory",
};

export const customerGetCustomerCategory: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-categories/{categoryId}",
  method: "get",
  operationId: "customerGetCustomerCategory",
};

export const customerUpdateCategory: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Categories_CategoryId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-categories/{categoryId}",
  method: "put",
  operationId: "customerUpdateCategory",
};

export const appGetAppversion: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Apps_AppId_Versions_AppVersionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Apps_AppId_Versions_AppVersionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_AppVersionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_AppVersionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_AppVersionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_AppVersionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/apps/{appId}/versions/{appVersionId}",
  method: "get",
  operationId: "appGetAppversion",
};

export const appListAppversions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/apps/{appId}/versions",
  method: "get",
  operationId: "appListAppversions",
};

export const sftpUserDeleteSftpUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/sftp-users/{sftpUserId}",
  method: "delete",
  operationId: "sftpUserDeleteSftpUser",
};

export const sftpUserGetSftpUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/sftp-users/{sftpUserId}",
  method: "get",
  operationId: "sftpUserGetSftpUser",
};

export const sftpUserUpdateSftpUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Sftp_Users_SftpUserId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/sftp-users/{sftpUserId}",
  method: "patch",
  operationId: "sftpUserUpdateSftpUser",
};

export const sshUserDeleteSshUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ssh-users/{sshUserId}",
  method: "delete",
  operationId: "sshUserDeleteSshUser",
};

export const sshUserGetSshUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ssh-users/{sshUserId}",
  method: "get",
  operationId: "sshUserGetSshUser",
};

export const sshUserUpdateSshUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ssh_Users_SshUserId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ssh-users/{sshUserId}",
  method: "patch",
  operationId: "sshUserUpdateSshUser",
};

export const sftpUserCreateSftpUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/sftp-users",
  method: "post",
  operationId: "sftpUserCreateSftpUser",
};

export const sftpUserListSftpUsers: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Responses.$200.Headers;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Sftp_Users.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/sftp-users",
  method: "get",
  operationId: "sftpUserListSftpUsers",
};

export const sshUserCreateSshUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/ssh-users",
  method: "post",
  operationId: "sshUserCreateSshUser",
};

export const sshUserListSshUsers: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Responses.$200.Headers;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Ssh_Users.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/ssh-users",
  method: "get",
  operationId: "sshUserListSshUsers",
};

export const projectGetSelfMembershipForProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Memberships_Self.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/memberships/self",
  method: "get",
  operationId: "projectGetSelfMembershipForProject",
};

export const orderCreateOrder: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Orders.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Orders.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/orders",
  method: "post",
  operationId: "orderCreateOrder",
};

export const orderListOrders: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Orders.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Orders.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Orders.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/orders",
  method: "get",
  operationId: "orderListOrders",
};

export const orderCreateTariffChange: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Tariff_Changes.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Tariff_Changes.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Changes.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Changes.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Changes.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Changes.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/tariff-changes",
  method: "post",
  operationId: "orderCreateTariffChange",
};

export const orderPreviewOrder: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Order_Previews.Post.Parameters.RequestBody;

    header?: MittwaldApi.Paths.V2_Order_Previews.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Order_Previews.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Order_Previews.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Order_Previews.Post.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Order_Previews.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Order_Previews.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/order-previews",
  method: "post",
  operationId: "orderPreviewOrder",
};

export const orderPreviewTariffChange: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Tariff_Change_Previews.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/tariff-change-previews",
  method: "post",
  operationId: "orderPreviewTariffChange",
};

export const relocationCreateLegacyTariffChange: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Legacy_Tariff_Change.Post.Parameters.RequestBody;

    header?: MittwaldApi.Paths.V2_Legacy_Tariff_Change.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Legacy_Tariff_Change.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Legacy_Tariff_Change.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Legacy_Tariff_Change.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/legacy-tariff-change",
  method: "post",
  operationId: "relocationCreateLegacyTariffChange",
};

export const contractGetDetailOfContractByDomain: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contract.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/contract",
  method: "get",
  operationId: "contractGetDetailOfContractByDomain",
};

export const contractGetDetailOfContractByProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Contract.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/contract",
  method: "get",
  operationId: "contractGetDetailOfContractByProject",
};

export const contractGetDetailOfContractByServer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Contract.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/contract",
  method: "get",
  operationId: "contractGetDetailOfContractByServer",
};

export const appListUpdateCandidatesForAppversion: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Apps_AppId_Versions_BaseAppVersionId_Update_Candidates.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/apps/{appId}/versions/{baseAppVersionId}/update-candidates",
  method: "get",
  operationId: "appListUpdateCandidatesForAppversion",
};

export const userAuthenticateMfa: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Authenticate_Mfa.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Authenticate_Mfa.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Mfa.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Mfa.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 408 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Mfa.Post.Responses.$408.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Mfa.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/authenticate-mfa",
  method: "post",
  operationId: "userAuthenticateMfa",
};

export const userAuthenticate: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Authenticate.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Authenticate.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 202 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate.Post.Responses.$202.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate.Post.Responses.$401.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/authenticate",
  method: "post",
  operationId: "userAuthenticate",
};

export const userChangeEmail: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Put.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/email",
  method: "put",
  operationId: "userChangeEmail",
};

export const userGetOwnEmail: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/email",
  method: "get",
  operationId: "userGetOwnEmail",
};

export const userChangePassword: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Password.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Password.Put.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 202 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password.Put.Responses.$202.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/password",
  method: "put",
  operationId: "userChangePassword",
};

export const userCheckToken: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Token.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Token.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Token.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Token.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Token.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/token",
  method: "post",
  operationId: "userCheckToken",
};

export const userConfirmMfa: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/mfa",
  method: "post",
  operationId: "userConfirmMfa",
};

export const userDisableMfa: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Delete.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Delete.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/mfa",
  method: "delete",
  operationId: "userDisableMfa",
};

export const userGetMfaStatus: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/mfa",
  method: "get",
  operationId: "userGetMfaStatus",
};

export const userResetRecoverycodes: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Put.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Mfa.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/mfa",
  method: "put",
  operationId: "userResetRecoverycodes",
};

export const userConfirmPasswordReset: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Confirm_Reset.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Confirm_Reset.Post.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Confirm_Reset.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Confirm_Reset.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Confirm_Reset.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/password/confirm-reset",
  method: "post",
  operationId: "userConfirmPasswordReset",
};

export const userCreateApiToken: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/api-tokens",
  method: "post",
  operationId: "userCreateApiToken",
};

export const userListApiTokens: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/api-tokens",
  method: "get",
  operationId: "userListApiTokens",
};

export const userCreateSshKey: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/ssh-keys",
  method: "post",
  operationId: "userCreateSshKey",
};

export const userListSshKeys: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/ssh-keys",
  method: "get",
  operationId: "userListSshKeys",
};

export const userDeleteApiToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/api-tokens/{apiTokenId}",
  method: "delete",
  operationId: "userDeleteApiToken",
};

export const userEditApiToken: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/api-tokens/{apiTokenId}",
  method: "put",
  operationId: "userEditApiToken",
};

export const userGetApiToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Api_Tokens_ApiTokenId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/api-tokens/{apiTokenId}",
  method: "get",
  operationId: "userGetApiToken",
};

export const userDeleteSshKey: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/ssh-keys/{sshKeyId}",
  method: "delete",
  operationId: "userDeleteSshKey",
};

export const userEditSshKey: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/ssh-keys/{sshKeyId}",
  method: "put",
  operationId: "userEditSshKey",
};

export const userGetSshKey: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Ssh_Keys_SshKeyId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/ssh-keys/{sshKeyId}",
  method: "get",
  operationId: "userGetSshKey",
};

export const userDeleteUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self.Delete.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self.Delete.Parameters.Header;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 202 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self.Delete.Responses.$202.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self.Delete.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self",
  method: "delete",
  operationId: "userDeleteUser",
};

export const userUpdateAccount: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Personal_Information.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Personal_Information.Put.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Personal_Information.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Personal_Information.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Personal_Information.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/personal-information",
  method: "put",
  operationId: "userUpdateAccount",
};

export const userGetPasswordUpdatedAt: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Updated_At.Get.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Updated_At.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Updated_At.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Updated_At.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Password_Updated_At.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/password-updated-at",
  method: "get",
  operationId: "userGetPasswordUpdatedAt",
};

export const userGetSession: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/sessions/{tokenId}",
  method: "get",
  operationId: "userGetSession",
};

export const userTerminateSession: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions_TokenId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/sessions/{tokenId}",
  method: "delete",
  operationId: "userTerminateSession",
};

export const userInitMfa: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Init_Mfa.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Init_Mfa.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Init_Mfa.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Init_Mfa.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Init_Mfa.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Init_Mfa.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/init-mfa",
  method: "post",
  operationId: "userInitMfa",
};

export const userInitPasswordReset: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Actions_Init_Password_Reset.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Actions_Init_Password_Reset.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Actions_Init_Password_Reset.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Actions_Init_Password_Reset.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Actions_Init_Password_Reset.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Actions_Init_Password_Reset.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/actions/init-password-reset",
  method: "post",
  operationId: "userInitPasswordReset",
};

export const userListSessions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Sessions.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/sessions",
  method: "get",
  operationId: "userListSessions",
};

export const userRefreshSession: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Sessions.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Sessions.Put.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/sessions",
  method: "put",
  operationId: "userRefreshSession",
};

export const userTerminateAllSessions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Sessions.Delete.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Sessions.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/sessions",
  method: "delete",
  operationId: "userTerminateAllSessions",
};

export const userLogout: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Logout.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Logout.Put.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Logout.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Logout.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Logout.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/logout",
  method: "put",
  operationId: "userLogout",
};

export const userRegister: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Register.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Register.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Register.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Register.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Register.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Register.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/register",
  method: "post",
  operationId: "userRegister",
};

export const userResendVerificationEmail: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Resend_Email.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Resend_Email.Post.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Resend_Email.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Resend_Email.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Resend_Email.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/email/actions/resend-email",
  method: "post",
  operationId: "userResendVerificationEmail",
};

export const userSupportCodeRequest: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Support_Code.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Users_Self_Credentials_Support_Code.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Support_Code.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Support_Code.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Support_Code.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/support-code",
  method: "get",
  operationId: "userSupportCodeRequest",
};

export const userVerifyEmail: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Verify_Email.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Verify_Email.Post.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Verify_Email.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Verify_Email.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Verify_Email.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Credentials_Email_Actions_Verify_Email.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/credentials/email/actions/verify-email",
  method: "post",
  operationId: "userVerifyEmail",
};

export const userVerifyRegistration: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Verify_Registration.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Verify_Registration.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Verify_Registration.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Verify_Registration.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Verify_Registration.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Verify_Registration.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Verify_Registration.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/verify-registration",
  method: "post",
  operationId: "userVerifyRegistration",
};

export const userAddPhoneNumber: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/phone",
  method: "post",
  operationId: "userAddPhoneNumber",
};

export const userRemovePhoneNumber: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_UserId_Phone.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Phone.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Phone.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/phone",
  method: "delete",
  operationId: "userRemovePhoneNumber",
};

export const userCreateFeedback: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Responses.$401.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_Self_Feedback.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/self/feedback",
  method: "post",
  operationId: "userCreateFeedback",
};

export const userGetPersonalizedSettings: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_UserId_Settings.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Settings.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Settings.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Settings.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Settings.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/settings",
  method: "get",
  operationId: "userGetPersonalizedSettings",
};

export const userUpdatePersonalizedSettings: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_UserId_Settings.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_UserId_Settings.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Settings.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Settings.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Settings.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Settings.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/settings",
  method: "put",
  operationId: "userUpdatePersonalizedSettings",
};

export const userGetUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_UserId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}",
  method: "get",
  operationId: "userGetUser",
};

export const userUpdatePersonalInformation: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_UserId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_UserId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}",
  method: "put",
  operationId: "userUpdatePersonalInformation",
};

export const userListFeedback: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_UserId_Feedback.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Feedback.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Users_UserId_Feedback.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Feedback.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Feedback.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Feedback.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/feedback",
  method: "get",
  operationId: "userListFeedback",
};

export const userRemoveAvatar: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Users_UserId_Avatar.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Avatar.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/avatar",
  method: "delete",
  operationId: "userRemoveAvatar",
};

export const userRequestAvatarUpload: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Avatar.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/avatar",
  method: "post",
  operationId: "userRequestAvatarUpload",
};

export const ingressRequestIngressAcmeCertificateIssuance: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Request_Acme_Certificate_Issuance.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses/{ingressId}/actions/request-acme-certificate-issuance",
  method: "post",
  operationId: "ingressRequestIngressAcmeCertificateIssuance",
};

export const newsletterGetInfo: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/newsletter-subscriptions/self",
  method: "get",
  operationId: "newsletterGetInfo",
};

export const newsletterUnsubscribeUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Delete.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions_Self.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/newsletter-subscriptions/self",
  method: "delete",
  operationId: "newsletterUnsubscribeUser",
};

export const newsletterSubscribeUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Newsletter_Subscriptions.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Newsletter_Subscriptions.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Newsletter_Subscriptions.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/newsletter-subscriptions",
  method: "post",
  operationId: "newsletterSubscribeUser",
};

export const domainCheckDomainRegistrability: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domain_Registrable.Post.Parameters.RequestBody;

    header?: MittwaldApi.Paths.V2_Domain_Registrable.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Registrable.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Registrable.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Registrable.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Registrable.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domain-registrable",
  method: "post",
  operationId: "domainCheckDomainRegistrability",
};

export const domainListTldContactSchemas: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Domain_Tlds_Tld_Contact_Schemas.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domain_Tlds_Tld_Contact_Schemas.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Tlds_Tld_Contact_Schemas.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Tlds_Tld_Contact_Schemas.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Tlds_Tld_Contact_Schemas.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domain-tlds/{tld}/contact-schemas",
  method: "get",
  operationId: "domainListTldContactSchemas",
};

export const dnsCreateDnsZone: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Dns_Zones.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Dns_Zones.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/dns-zones",
  method: "post",
  operationId: "dnsCreateDnsZone",
};

export const dnsDeleteDnsZone: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/dns-zones/{dnsZoneId}",
  method: "delete",
  operationId: "dnsDeleteDnsZone",
};

export const dnsGetDnsZone: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/dns-zones/{dnsZoneId}",
  method: "get",
  operationId: "dnsGetDnsZone",
};

export const dnsListDnsZones: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Dns_Zones.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Dns_Zones.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Dns_Zones.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Dns_Zones.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Dns_Zones.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Dns_Zones.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/dns-zones",
  method: "get",
  operationId: "dnsListDnsZones",
};

export const dnsSetRecordSetManaged: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Responses.$204.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet_Actions_Set_Managed.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/dns-zones/{dnsZoneId}/record-sets/{recordSet}/actions/set-managed",
  method: "post",
  operationId: "dnsSetRecordSetManaged",
};

export const dnsUpdateRecordSet: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Dns_Zones_DnsZoneId_Record_Sets_RecordSet.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/dns-zones/{dnsZoneId}/record-sets/{recordSet}",
  method: "put",
  operationId: "dnsUpdateRecordSet",
};

export const domainAbortDomainDeclaration: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains_DomainId_Declaration.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Declaration.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Declaration.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Declaration.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Declaration.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Declaration.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/declaration",
  method: "delete",
  operationId: "domainAbortDomainDeclaration",
};

export const domainCreateDomainAuthCode: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Actions_Auth_Code.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/actions/auth-code",
  method: "post",
  operationId: "domainCreateDomainAuthCode",
};

export const domainListTlds: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Domain_Tlds.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Tlds.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Tlds.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Tlds.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domain-tlds",
  method: "get",
  operationId: "domainListTlds",
};

export const domainUpdateDomainAuthCode: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Auth_Code.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/auth-code",
  method: "patch",
  operationId: "domainUpdateDomainAuthCode",
};

export const domainUpdateDomainContact: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Contacts_Contact.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/contacts/{contact}",
  method: "patch",
  operationId: "domainUpdateDomainContact",
};

export const domainUpdateDomainProjectId: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Project_Id.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/project-id",
  method: "patch",
  operationId: "domainUpdateDomainProjectId",
};

export const mailCreateDeliverybox: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/delivery-boxes",
  method: "post",
  operationId: "mailCreateDeliverybox",
};

export const mailListDeliveryBoxes: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Delivery_Boxes.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/delivery-boxes",
  method: "get",
  operationId: "mailListDeliveryBoxes",
};

export const mailCreateMailAddress: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/mail-addresses",
  method: "post",
  operationId: "mailCreateMailAddress",
};

export const mailListMailAddresses: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Addresses.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/mail-addresses",
  method: "get",
  operationId: "mailListMailAddresses",
};

export const mailDeleteDeliveryBox: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/delivery-boxes/{deliveryBoxId}",
  method: "delete",
  operationId: "mailDeleteDeliveryBox",
};

export const mailGetDeliveryBox: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/delivery-boxes/{deliveryBoxId}",
  method: "get",
  operationId: "mailGetDeliveryBox",
};

export const mailDeleteMailAddress: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}",
  method: "delete",
  operationId: "mailDeleteMailAddress",
};

export const mailGetMailAddress: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}",
  method: "get",
  operationId: "mailGetMailAddress",
};

export const mailListProjectMailSettings: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/mail-settings",
  method: "get",
  operationId: "mailListProjectMailSettings",
};

export const mailUpdateDeliveryBoxDescription: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Description.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/delivery-boxes/{deliveryBoxId}/description",
  method: "patch",
  operationId: "mailUpdateDeliveryBoxDescription",
};

export const mailUpdateDeliveryBoxPassword: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Delivery_Boxes_DeliveryBoxId_Password.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/delivery-boxes/{deliveryBoxId}/password",
  method: "patch",
  operationId: "mailUpdateDeliveryBoxPassword",
};

export const mailUpdateMailAddressAddress: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Address.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/address",
  method: "patch",
  operationId: "mailUpdateMailAddressAddress",
};

export const mailUpdateMailAddressAutoresponder: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Autoresponder.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/autoresponder",
  method: "patch",
  operationId: "mailUpdateMailAddressAutoresponder",
};

export const mailUpdateMailAddressCatchAll: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Catch_All.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/catch-all",
  method: "patch",
  operationId: "mailUpdateMailAddressCatchAll",
};

export const mailUpdateMailAddressForwardAddresses: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Forward_Addresses.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/forward-addresses",
  method: "patch",
  operationId: "mailUpdateMailAddressForwardAddresses",
};

export const mailUpdateMailAddressPassword: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Password.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/password",
  method: "patch",
  operationId: "mailUpdateMailAddressPassword",
};

export const mailUpdateMailAddressQuota: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Quota.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/quota",
  method: "patch",
  operationId: "mailUpdateMailAddressQuota",
};

export const mailUpdateMailAddressSpamProtection: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mail_Addresses_MailAddressId_Spam_Protection.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mail-addresses/{mailAddressId}/spam-protection",
  method: "patch",
  operationId: "mailUpdateMailAddressSpamProtection",
};

export const appExecuteAction: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Action.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Action.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Action.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Action.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Action.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Action.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/actions/{action}",
  method: "post",
  operationId: "appExecuteAction",
};

export const appGetAppinstallation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}",
  method: "get",
  operationId: "appGetAppinstallation",
};

export const appPatchAppinstallation: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}",
  method: "patch",
  operationId: "appPatchAppinstallation",
};

export const appUninstallAppinstallation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}",
  method: "delete",
  operationId: "appUninstallAppinstallation",
};

export const appGetMissingDependenciesForAppinstallation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Missing_Dependencies.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/missing-dependencies",
  method: "get",
  operationId: "appGetMissingDependenciesForAppinstallation",
};

export const appGetSystemsoftware: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_System_Softwares_SystemSoftwareId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_System_Softwares_SystemSoftwareId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares_SystemSoftwareId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares_SystemSoftwareId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares_SystemSoftwareId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares_SystemSoftwareId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/system-softwares/{systemSoftwareId}",
  method: "get",
  operationId: "appGetSystemsoftware",
};

export const appGetSystemsoftwareversion: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions_SystemSoftwareVersionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/system-software/{systemSoftwareId}/versions/{systemSoftwareVersionId}",
  method: "get",
  operationId: "appGetSystemsoftwareversion",
};

export const appLinkDatabase: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/database",
  method: "patch",
  operationId: "appLinkDatabase",
};

export const appListAppinstallations: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/app-installations",
  method: "get",
  operationId: "appListAppinstallations",
};

export const appRequestAppinstallation: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_App_Installations.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/app-installations",
  method: "post",
  operationId: "appRequestAppinstallation",
};

export const appListSystemsoftwares: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_System_Softwares.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_System_Softwares.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_System_Softwares.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Softwares.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/system-softwares",
  method: "get",
  operationId: "appListSystemsoftwares",
};

export const appListSystemsoftwareversions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_System_Software_SystemSoftwareId_Versions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/system-software/{systemSoftwareId}/versions",
  method: "get",
  operationId: "appListSystemsoftwareversions",
};

export const appRetrieveStatus: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Status.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Status.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Status.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Status.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Status.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Status.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/status",
  method: "get",
  operationId: "appRetrieveStatus",
};

export const appUnlinkDatabase: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/databases/{databaseId}",
  method: "delete",
  operationId: "appUnlinkDatabase",
};

export const databaseDeleteMysqlDatabase: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-databases/{mysqlDatabaseId}",
  method: "delete",
  operationId: "databaseDeleteMysqlDatabase",
};

export const databaseGetMysqlDatabase: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-databases/{mysqlDatabaseId}",
  method: "get",
  operationId: "databaseGetMysqlDatabase",
};

export const databaseDeleteMysqlUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}",
  method: "delete",
  operationId: "databaseDeleteMysqlUser",
};

export const databaseGetMysqlUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}",
  method: "get",
  operationId: "databaseGetMysqlUser",
};

export const databaseUpdateMysqlUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}",
  method: "put",
  operationId: "databaseUpdateMysqlUser",
};

export const databaseDeleteRedisDatabase: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/redis-databases/{redisDatabaseId}",
  method: "delete",
  operationId: "databaseDeleteRedisDatabase",
};

export const databaseGetRedisDatabase: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/redis-databases/{redisDatabaseId}",
  method: "get",
  operationId: "databaseGetRedisDatabase",
};

export const databaseDisableMysqlUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Disable.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}/actions/disable",
  method: "post",
  operationId: "databaseDisableMysqlUser",
};

export const databaseEnableMysqlUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Actions_Enable.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}/actions/enable",
  method: "post",
  operationId: "databaseEnableMysqlUser",
};

export const databaseGetMysqlUserPhpMyAdminUrl: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Php_My_Admin_Url.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}/php-my-admin-url",
  method: "get",
  operationId: "databaseGetMysqlUserPhpMyAdminUrl",
};

export const databaseUpdateMysqlDatabaseDefaultCharset: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Default_Charset.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-databases/{mysqlDatabaseId}/default-charset",
  method: "patch",
  operationId: "databaseUpdateMysqlDatabaseDefaultCharset",
};

export const databaseUpdateMysqlDatabaseDescription: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Description.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-databases/{mysqlDatabaseId}/description",
  method: "patch",
  operationId: "databaseUpdateMysqlDatabaseDescription",
};

export const databaseUpdateMysqlUserPassword: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Users_MysqlUserId_Password.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-users/{mysqlUserId}/password",
  method: "patch",
  operationId: "databaseUpdateMysqlUserPassword",
};

export const databaseUpdateRedisDatabaseConfiguration: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Configuration.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/redis-databases/{redisDatabaseId}/configuration",
  method: "patch",
  operationId: "databaseUpdateRedisDatabaseConfiguration",
};

export const databaseUpdateRedisDatabaseDescription: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Redis_Databases_RedisDatabaseId_Description.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/redis-databases/{redisDatabaseId}/description",
  method: "patch",
  operationId: "databaseUpdateRedisDatabaseDescription",
};

export const fileGetFileMeta: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$401.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_Meta.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/files/{fileId}/meta",
  method: "get",
  operationId: "fileGetFileMeta",
};

export const fileGetFile: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Files_FileId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Files_FileId.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Files_FileId.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/octet-stream";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$200.Content.Application_Octet_Stream;
    })
  | ({ status: 200 } & {
      mediaType: "text/plain;base64";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$200.Content.Text_Plain_Base64;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$401.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/files/{fileId}",
  method: "get",
  operationId: "fileGetFile",
};

export const pageinsightsGetPerformanceData: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Page_Insights.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Page_Insights.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Page_Insights.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Page_Insights.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Page_Insights.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Page_Insights.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Page_Insights.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/page-insights",
  method: "get",
  operationId: "pageinsightsGetPerformanceData",
};

export const pageinsightsListPerformanceDataForProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Page_Insights.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/page-insights",
  method: "get",
  operationId: "pageinsightsListPerformanceDataForProject",
};

export const projectFileSystemGetDirectories: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Directories.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/filesystem-directories",
  method: "get",
  operationId: "projectFileSystemGetDirectories",
};

export const projectFileSystemGetDiskUsage: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Disk_Usage.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/filesystem-disk-usage",
  method: "get",
  operationId: "projectFileSystemGetDiskUsage",
};

export const projectFileSystemGetFileContent: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "text/plain";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Responses.$200.Content.Text_Plain;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_File_Content.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/filesystem-file-content",
  method: "get",
  operationId: "projectFileSystemGetFileContent",
};

export const projectFileSystemListFiles: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Filesystem_Files.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/filesystem-files",
  method: "get",
  operationId: "projectFileSystemListFiles",
};

export const projectUpdateProjectDescription: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Description.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/description",
  method: "patch",
  operationId: "projectUpdateProjectDescription",
};

export const fileGetFileUploadTokenRules: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Tokens_FileUploadToken_Rules.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/file-upload-tokens/{fileUploadToken}/rules",
  method: "get",
  operationId: "fileGetFileUploadTokenRules",
};

export const fileGetFileUploadTypeRules: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_File_Upload_Types_FileUploadType_Rules.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/file-upload-types/{fileUploadType}/rules",
  method: "get",
  operationId: "fileGetFileUploadTypeRules",
};

export const conversationGetConversationMembers: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Members.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/members",
  method: "get",
  operationId: "conversationGetConversationMembers",
};

export const conversationGetFileAccessToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Conversations_ConversationId_Files_FileId_Access_Token.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/conversations/{conversationId}/files/{fileId}/access-token",
  method: "get",
  operationId: "conversationGetFileAccessToken",
};

export const invoiceGetFileAccessToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Invoices_InvoiceId_File_Access_Token.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/invoices/{invoiceId}/file-access-token",
  method: "get",
  operationId: "invoiceGetFileAccessToken",
};

export const pageinsightsGetStraceData: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces_StraceId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/straces/{straceId}",
  method: "get",
  operationId: "pageinsightsGetStraceData",
};

export const pageinsightsScheduleStrace: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Parameters.Path;
  },
  | ({ status: 202 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Responses.$202.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Straces.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/straces",
  method: "post",
  operationId: "pageinsightsScheduleStrace",
};

export const userAuthenticateWithAccessTokenRetrievalKey: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Authenticate_Token_Retrieval_Key.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Authenticate_Token_Retrieval_Key.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Token_Retrieval_Key.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Token_Retrieval_Key.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Authenticate_Token_Retrieval_Key.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/authenticate-token-retrieval-key",
  method: "post",
  operationId: "userAuthenticateWithAccessTokenRetrievalKey",
};

export const databaseCreateMysqlUser: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-databases/{mysqlDatabaseId}/users",
  method: "post",
  operationId: "databaseCreateMysqlUser",
};

export const databaseListMysqlUsers: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Mysql_Databases_MysqlDatabaseId_Users.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/mysql-databases/{mysqlDatabaseId}/users",
  method: "get",
  operationId: "databaseListMysqlUsers",
};

export const ingressIngressVerifyOwnership: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Ingresses_IngressId_Actions_Verify_Ownership.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/ingresses/{ingressId}/actions/verify-ownership",
  method: "post",
  operationId: "ingressIngressVerifyOwnership",
};

export const mailUpdateProjectMailSetting: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Mail_Settings_MailSetting.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/mail-settings/{mailSetting}",
  method: "patch",
  operationId: "mailUpdateProjectMailSetting",
};

export const customerAcceptCustomerInvite: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Accept.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-invites/{customerInviteId}/actions/accept",
  method: "post",
  operationId: "customerAcceptCustomerInvite",
};

export const customerDeclineCustomerInvite: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Decline.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Decline.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Decline.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Decline.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Decline.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-invites/{customerInviteId}/actions/decline",
  method: "post",
  operationId: "customerDeclineCustomerInvite",
};

export const customerDeleteCustomerInvite: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-invites/{customerInviteId}",
  method: "delete",
  operationId: "customerDeleteCustomerInvite",
};

export const customerGetCustomerInvite: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-invites/{customerInviteId}",
  method: "get",
  operationId: "customerGetCustomerInvite",
};

export const customerDeleteCustomerMembership: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-memberships/{customerMembershipId}",
  method: "delete",
  operationId: "customerDeleteCustomerMembership",
};

export const customerGetCustomerMembership: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-memberships/{customerMembershipId}",
  method: "get",
  operationId: "customerGetCustomerMembership",
};

export const customerUpdateCustomerMembership: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Memberships_CustomerMembershipId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-memberships/{customerMembershipId}",
  method: "patch",
  operationId: "customerUpdateCustomerMembership",
};

export const customerResendCustomerInviteMail: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Resend.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Resend.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Resend.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Resend.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Resend.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customer_Invites_CustomerInviteId_Actions_Resend.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customer-invites/{customerInviteId}/actions/resend",
  method: "post",
  operationId: "customerResendCustomerInviteMail",
};

export const projectAcceptProjectInvite: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Accept.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-invites/{projectInviteId}/actions/accept",
  method: "post",
  operationId: "projectAcceptProjectInvite",
};

export const projectDeclineProjectInvite: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Decline.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Decline.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Decline.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Decline.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Decline.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-invites/{projectInviteId}/actions/decline",
  method: "post",
  operationId: "projectDeclineProjectInvite",
};

export const projectDeleteProjectInvite: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-invites/{projectInviteId}",
  method: "delete",
  operationId: "projectDeleteProjectInvite",
};

export const projectGetProjectInvite: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-invites/{projectInviteId}",
  method: "get",
  operationId: "projectGetProjectInvite",
};

export const projectDeleteProjectMembership: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-memberships/{projectMembershipId}",
  method: "delete",
  operationId: "projectDeleteProjectMembership",
};

export const projectGetProjectMembership: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-memberships/{projectMembershipId}",
  method: "get",
  operationId: "projectGetProjectMembership",
};

export const projectUpdateProjectMembership: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Memberships_ProjectMembershipId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-memberships/{projectMembershipId}",
  method: "patch",
  operationId: "projectUpdateProjectMembership",
};

export const projectResendProjectInviteMail: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Resend.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Resend.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Resend.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Resend.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Resend.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Project_Invites_ProjectInviteId_Actions_Resend.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/project-invites/{projectInviteId}/actions/resend",
  method: "post",
  operationId: "projectResendProjectInviteMail",
};

export const appGetInstalledSystemsoftwareForAppinstallation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_SystemSoftware.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/systemSoftware",
  method: "get",
  operationId: "appGetInstalledSystemsoftwareForAppinstallation",
};

export const invoiceDetail: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Invoices_InvoiceId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/invoices/{invoiceId}",
  method: "get",
  operationId: "invoiceDetail",
};

export const appRequestAppinstallationCopy: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Actions_Copy.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/actions/copy",
  method: "post",
  operationId: "appRequestAppinstallationCopy",
};

export const appSetDatabaseUsers: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Databases_DatabaseId_Users.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/databases/{databaseId}/users",
  method: "put",
  operationId: "appSetDatabaseUsers",
};

export const extensionAuthenticateInstance: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Tokens.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Tokens.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Tokens.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Tokens.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Tokens.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Tokens.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/tokens",
  method: "post",
  operationId: "extensionAuthenticateInstance",
};

export const extensionConsentToExtensionScopes: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Scopes.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Scopes.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Scopes.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Scopes.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Scopes.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Scopes.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/scopes",
  method: "patch",
  operationId: "extensionConsentToExtensionScopes",
};

export const extensionCreateExtensionInstance: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extension_Instances.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extension_Instances.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances",
  method: "post",
  operationId: "extensionCreateExtensionInstance",
};

export const extensionListExtensionInstances: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Extension_Instances.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Extension_Instances.Get.Responses.$200.Headers;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances",
  method: "get",
  operationId: "extensionListExtensionInstances",
};

export const extensionDeleteExtensionInstance: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Delete.Responses.$204.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}",
  method: "delete",
  operationId: "extensionDeleteExtensionInstance",
};

export const extensionGetExtensionInstance: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}",
  method: "get",
  operationId: "extensionGetExtensionInstance",
};

export const extensionDisableExtensionInstance: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Disable.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Disable.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Disable.Post.Responses.$204.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Disable.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Disable.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Disable.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/actions/disable",
  method: "post",
  operationId: "extensionDisableExtensionInstance",
};

export const extensionEnableExtensionInstance: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Enable.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Enable.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Enable.Post.Responses.$204.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Enable.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Enable.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Enable.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/actions/enable",
  method: "post",
  operationId: "extensionEnableExtensionInstance",
};

export const extensionGetContributor: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Contributors_ContributorId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}",
  method: "get",
  operationId: "extensionGetContributor",
};

export const extensionGetExtension: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Extensions_ExtensionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extensions_ExtensionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extensions/{extensionId}",
  method: "get",
  operationId: "extensionGetExtension",
};

export const extensionListContributors: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Contributors.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Contributors.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors",
  method: "get",
  operationId: "extensionListContributors",
};

export const extensionListExtensions: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Extensions.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Extensions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extensions",
  method: "get",
  operationId: "extensionListExtensions",
};

export const userOauthGetAuthorization: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Oauth2_Authorize.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Oauth2_Authorize.Get.Parameters.Query;
  },
  | ({ status: 302 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Authorize.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Authorize.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Authorize.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/oauth2/authorize",
  method: "get",
  operationId: "userOauthGetAuthorization",
};

export const userOauthRetrieveAccessToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Oauth2_Token.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Token.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Token.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Token.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Oauth2_Token.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/oauth2/token",
  method: "post",
  operationId: "userOauthRetrieveAccessToken",
};

export const userVerifyPhoneNumber: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Users_UserId_Actions_Verify_Phone.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/users/{userId}/actions/verify-phone",
  method: "post",
  operationId: "userVerifyPhoneNumber",
};

export const notificationsCountUnreadNotifications: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Notification_Unread_Counts.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notification_Unread_Counts.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notification_Unread_Counts.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notification_Unread_Counts.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/notification-unread-counts",
  method: "get",
  operationId: "notificationsCountUnreadNotifications",
};

export const fileGetFileWithName: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/octet-stream";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$200.Content.Application_Octet_Stream;
    })
  | ({ status: 200 } & {
      mediaType: "text/plain;base64";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$200.Content.Text_Plain_Base64;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$401.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Files_FileId_FileName.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/files/{fileId}/{fileName}",
  method: "get",
  operationId: "fileGetFileWithName",
};

export const domainCheckDomainTransferability: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domain_Transferable.Post.Parameters.RequestBody;

    header?: MittwaldApi.Paths.V2_Domain_Transferable.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Transferable.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Transferable.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Transferable.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Transferable.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domain-transferable",
  method: "post",
  operationId: "domainCheckDomainTransferability",
};

export const appListAppinstallationsForUser: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_App_Installations.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_App_Installations.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_App_Installations.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations",
  method: "get",
  operationId: "appListAppinstallationsForUser",
};

export const domainGetLatestScreenshot: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domains_DomainId_Latest_Screenshot.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domains/{domainId}/latest-screenshot",
  method: "get",
  operationId: "domainGetLatestScreenshot",
};

export const extensionGetPublicKey: OperationDescriptor<
  {
    header?: MittwaldApi.Paths.V2_Webhook_Public_Keys_Serial.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Webhook_Public_Keys_Serial.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Webhook_Public_Keys_Serial.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Webhook_Public_Keys_Serial.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Webhook_Public_Keys_Serial.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Webhook_Public_Keys_Serial.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/webhook-public-keys/{serial}",
  method: "get",
  operationId: "extensionGetPublicKey",
};

export const notificationsReadAllNotifications: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Parameters.Header;

    query: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_Actions_Read_All.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/notifications/actions/read-all",
  method: "post",
  operationId: "notificationsReadAllNotifications",
};

export const notificationsReadNotification: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Notifications_NotificationId_Status.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/notifications/{notificationId}/status",
  method: "put",
  operationId: "notificationsReadNotification",
};

export const userGetPollStatus: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/poll-settings/{userId}",
  method: "get",
  operationId: "userGetPollStatus",
};

export const userPostPollStatus: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Poll_Settings_UserId.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/poll-settings/{userId}",
  method: "post",
  operationId: "userPostPollStatus",
};

export const containerValidateContainerRegistryUri: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_Validate_Container_Registry_Uri.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/actions/validate-container-registry-uri",
  method: "post",
  operationId: "containerValidateContainerRegistryUri",
};

export const containerDeleteRegistry: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/registries/{registryId}",
  method: "delete",
  operationId: "containerDeleteRegistry",
};

export const containerGetRegistry: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/registries/{registryId}",
  method: "get",
  operationId: "containerGetRegistry",
};

export const containerUpdateRegistry: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.$409.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/registries/{registryId}",
  method: "patch",
  operationId: "containerUpdateRegistry",
};

export const containerGetContainerImageConfig: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Container_Image_Config.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Container_Image_Config.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Container_Image_Config.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/container-image-config",
  method: "get",
  operationId: "containerGetContainerImageConfig",
};

export const containerCreateRegistry: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/registries",
  method: "post",
  operationId: "containerCreateRegistry",
};

export const containerListRegistries: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.$200.Headers;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Registries.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/registries",
  method: "get",
  operationId: "containerListRegistries",
};

export const containerValidateRegistryCredentials: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Registries_RegistryId_Actions_Validate_Credentials.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/registries/{registryId}/actions/validate-credentials",
  method: "post",
  operationId: "containerValidateRegistryCredentials",
};

export const containerDeleteVolume: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/volumes/{volumeId}",
  method: "delete",
  operationId: "containerDeleteVolume",
};

export const containerGetVolume: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Volumes_VolumeId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/volumes/{volumeId}",
  method: "get",
  operationId: "containerGetVolume",
};

export const containerGetServiceLogs: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "text/plain";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.$200.Content.Text_Plain;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 503 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.$503.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Logs.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}/logs",
  method: "get",
  operationId: "containerGetServiceLogs",
};

export const containerGetService: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}",
  method: "get",
  operationId: "containerGetService",
};

export const containerListServices: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Services.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/services",
  method: "get",
  operationId: "containerListServices",
};

export const containerListStacks: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Stacks.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/stacks",
  method: "get",
  operationId: "containerListStacks",
};

export const containerListVolumes: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Volumes.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/volumes",
  method: "get",
  operationId: "containerListVolumes",
};

export const containerDeclareStack: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Stacks_StackId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Stacks_StackId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}",
  method: "put",
  operationId: "containerDeclareStack",
};

export const containerGetStack: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}",
  method: "get",
  operationId: "containerGetStack",
};

export const containerUpdateStack: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.$403.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}",
  method: "patch",
  operationId: "containerUpdateStack",
};

export const containerRecreateService: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Recreate.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}/actions/recreate",
  method: "post",
  operationId: "containerRecreateService",
};

export const containerRestartService: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Restart.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}/actions/restart",
  method: "post",
  operationId: "containerRestartService",
};

export const containerStartService: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Start.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}/actions/start",
  method: "post",
  operationId: "containerStartService",
};

export const containerStopService: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Stop.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}/actions/stop",
  method: "post",
  operationId: "containerStopService",
};

export const extensionCreateRetrievalKey: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Actions_Create_Access_Token_Retrieval_Key.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/actions/create-access-token-retrieval-key",
  method: "post",
  operationId: "extensionCreateRetrievalKey",
};

export const contributorRotateSecretForExtensionInstance: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Secret.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/extension-instances/{extensionInstanceId}/secret",
  method: "put",
  operationId: "contributorRotateSecretForExtensionInstance",
};

export const domainSuggest: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Domain_Suggestions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/domain-suggestions",
  method: "get",
  operationId: "domainSuggest",
};

export const appReplaceDatabase: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_App_Installations_AppInstallationId_Database_Replace.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/app-installations/{appInstallationId}/database/replace",
  method: "patch",
  operationId: "appReplaceDatabase",
};

export const contractGetDetailOfContractByCertificate: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Contract.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificates/{certificateId}/contract",
  method: "get",
  operationId: "contractGetDetailOfContractByCertificate",
};

export const ingressListIngressesCompatibleWithCertificate: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Actions_List_Ingresses_Compatible_With_Certificate.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/actions/list-ingresses-compatible-with-certificate",
  method: "post",
  operationId: "ingressListIngressesCompatibleWithCertificate",
};

export const sslCheckReplaceCertificate: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId_Actions_Check_Replace_Certificate.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificates/{certificateId}/actions/check-replace-certificate",
  method: "post",
  operationId: "sslCheckReplaceCertificate",
};

export const sslCreateCertificateRequest: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Certificate_Requests.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Certificate_Requests.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificate-requests",
  method: "post",
  operationId: "sslCreateCertificateRequest",
};

export const sslListCertificateRequests: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificate_Requests.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Certificate_Requests.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificate-requests",
  method: "get",
  operationId: "sslListCertificateRequests",
};

export const sslDeleteCertificateRequest: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificate_Request_CertificateRequestId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificate_Request_CertificateRequestId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Request_CertificateRequestId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Request_CertificateRequestId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Request_CertificateRequestId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificate-request/{certificateRequestId}",
  method: "delete",
  operationId: "sslDeleteCertificateRequest",
};

export const sslDeleteCertificate: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificate_CertificateId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificate_CertificateId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_CertificateId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_CertificateId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_CertificateId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificate/{certificateId}",
  method: "delete",
  operationId: "sslDeleteCertificate",
};

export const sslGetCertificateRequest: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificate-requests/{certificateRequestId}",
  method: "get",
  operationId: "sslGetCertificateRequest",
};

export const sslGetCertificate: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificates_CertificateId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificates_CertificateId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificates/{certificateId}",
  method: "get",
  operationId: "sslGetCertificate",
};

export const sslReplaceCertificate: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates_CertificateId.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificates/{certificateId}",
  method: "put",
  operationId: "sslReplaceCertificate",
};

export const sslListCertificates: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Certificates.Get.Parameters.Header;

    query: MittwaldApi.Paths.V2_Certificates.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificates.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificates",
  method: "get",
  operationId: "sslListCertificates",
};

export const sslSetCertificateRequestCertificate: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Certificate_Requests_CertificateRequestId_Certificate.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/certificate-requests/{certificateRequestId}/certificate",
  method: "patch",
  operationId: "sslSetCertificateRequestCertificate",
};

export const extensionDryRunWebhook: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Parameters.Path;

    query: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Extension_Instances_ExtensionInstanceId_Actions_Dry_Run_WebhookKind.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/extension-instances/{extensionInstanceId}/actions/dry-run/{webhookKind}",
  method: "post",
  operationId: "extensionDryRunWebhook",
};

export const storagespaceReplaceProjectNotificationThreshold: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Notification_Threshold.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/storage-space-notification-threshold",
  method: "put",
  operationId: "storagespaceReplaceProjectNotificationThreshold",
};

export const storagespaceGetProjectStatistics: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Storage_Space_Statistics.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/storage-space-statistics",
  method: "get",
  operationId: "storagespaceGetProjectStatistics",
};

export const storagespaceGetServerStatistics: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Statistics.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/storage-space-statistics",
  method: "get",
  operationId: "storagespaceGetServerStatistics",
};

export const storagespaceReplaceServerNotificationThreshold: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Responses.$403.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Responses.$500.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Servers_ServerId_Storage_Space_Notification_Threshold.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/servers/{serverId}/storage-space-notification-threshold",
  method: "put",
  operationId: "storagespaceReplaceServerNotificationThreshold",
};

export const cronjobAbortExecution: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Cronjobs_CronjobId_Executions_ExecutionId_Actions_Abort.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/cronjobs/{cronjobId}/executions/{executionId}/actions/abort",
  method: "post",
  operationId: "cronjobAbortExecution",
};

export const extensionGetExtensionInstanceForCustomer: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Extensions_ExtensionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Extensions_ExtensionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extensions_ExtensionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extensions_ExtensionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extensions_ExtensionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extensions_ExtensionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/extensions/{extensionId}",
  method: "get",
  operationId: "extensionGetExtensionInstanceForCustomer",
};

export const extensionGetExtensionInstanceForProject: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Extensions_ExtensionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Extensions_ExtensionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extensions_ExtensionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extensions_ExtensionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extensions_ExtensionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extensions_ExtensionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/extensions/{extensionId}",
  method: "get",
  operationId: "extensionGetExtensionInstanceForProject",
};

export const extensionListOwnExtensions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions",
  method: "get",
  operationId: "extensionListOwnExtensions",
};

export const extensionRegisterExtension: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions",
  method: "post",
  operationId: "extensionRegisterExtension",
};

export const extensionDeleteExtension: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Delete.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}",
  method: "delete",
  operationId: "extensionDeleteExtension",
};

export const extensionGetOwnExtension: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}",
  method: "get",
  operationId: "extensionGetOwnExtension",
};

export const extensionPatchExtension: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId.Patch.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}",
  method: "patch",
  operationId: "extensionPatchExtension",
};

export const leadfyndrGetLead: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads_LeadId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/leads/{leadId}",
  method: "get",
  operationId: "leadfyndrGetLead",
};

export const leadfyndrGetUnlockedLead: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/unlocked-leads/{leadId}",
  method: "get",
  operationId: "leadfyndrGetUnlockedLead",
};

export const leadfyndrUnlockLead: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/unlocked-leads/{leadId}",
  method: "post",
  operationId: "leadfyndrUnlockLead",
};

export const leadfyndrListLeads: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Leads.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/leads",
  method: "get",
  operationId: "leadfyndrListLeads",
};

export const leadfyndrListUnlockedLeads: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Parameters.Path;

    query: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Responses.$200.Headers;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/unlocked-leads",
  method: "get",
  operationId: "leadfyndrListUnlockedLeads",
};

export const extensionGenerateSessionToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Sessions_SessionId.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/sessions/{sessionId}",
  method: "post",
  operationId: "extensionGenerateSessionToken",
};

export const customerCreateRecommendationSuggestion: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Recommendation_Suggestions.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/recommendation-suggestions",
  method: "post",
  operationId: "customerCreateRecommendationSuggestion",
};

export const customerCreateWallet: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/wallet",
  method: "post",
  operationId: "customerCreateWallet",
};

export const customerGetWallet: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.$409.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Wallet.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/wallet",
  method: "get",
  operationId: "customerGetWallet",
};

export const containerPullImageForService: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Stacks_StackId_Services_ServiceId_Actions_Pull.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/stacks/{stackId}/services/{serviceId}/actions/pull",
  method: "post",
  operationId: "containerPullImageForService",
};

export const leadfyndrRemoveUnlockedLeadReservation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/unlocked-leads/{leadId}/reservation",
  method: "delete",
  operationId: "leadfyndrRemoveUnlockedLeadReservation",
};

export const leadfyndrReserveUnlockedLead: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Unlocked_Leads_LeadId_Reservation.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/unlocked-leads/{leadId}/reservation",
  method: "post",
  operationId: "leadfyndrReserveUnlockedLead",
};

export const extensionStartExtensionCheckout: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Checkout.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extensions/{extensionId}/checkout",
  method: "post",
  operationId: "extensionStartExtensionCheckout",
};

export const extensionCancelExtensionTermination: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/termination",
  method: "delete",
  operationId: "extensionCancelExtensionTermination",
};

export const extensionScheduleExtensionTermination: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Termination.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/termination",
  method: "post",
  operationId: "extensionScheduleExtensionTermination",
};

export const contributorGetBillingInformation: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Billing_Information.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/billing-information",
  method: "get",
  operationId: "contributorGetBillingInformation",
};

export const contributorGetLoginLink: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Dashboard.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/dashboard",
  method: "get",
  operationId: "contributorGetLoginLink",
};

export const contributorListIncomingInvoices: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/invoices/incoming",
  method: "get",
  operationId: "contributorListIncomingInvoices",
};

export const contributorListOnbehalfInvoices: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Outgoing.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/invoices/outgoing",
  method: "get",
  operationId: "contributorListOnbehalfInvoices",
};

export const contributorReceiptGetFileAccessToken: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Invoices_Incoming_ContributorReceiptId_File_Access_Token.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/invoices/incoming/{contributorReceiptId}/file-access-token",
  method: "get",
  operationId: "contributorReceiptGetFileAccessToken",
};

export const extensionChangeContext: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Context.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/context",
  method: "put",
  operationId: "extensionChangeContext",
};

export const extensionCreateContributorOnboardingProcess: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Onboarding_Process.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/onboarding-process",
  method: "post",
  operationId: "extensionCreateContributorOnboardingProcess",
};

export const extensionRemoveAsset: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets_AssetRefId.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets_AssetRefId.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets_AssetRefId.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets_AssetRefId.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets_AssetRefId.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/assets/{assetRefId}",
  method: "delete",
  operationId: "extensionRemoveAsset",
};

export const extensionRemoveLogo: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Delete.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Delete.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Delete.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Delete.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/logo",
  method: "delete",
  operationId: "extensionRemoveLogo",
};

export const extensionRequestLogoUpload: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Logo.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/logo",
  method: "post",
  operationId: "extensionRequestLogoUpload",
};

export const extensionRequestAssetUpload: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 412 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Responses.$412.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Assets.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/assets",
  method: "post",
  operationId: "extensionRequestAssetUpload",
};

export const extensionRequestExtensionVerification: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process.Post.Responses.$204.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Verification_Process.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/verification-process",
  method: "post",
  operationId: "extensionRequestExtensionVerification",
};

export const extensionSetExtensionPublishedState: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extensions_ExtensionId_Published.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extensions/{extensionId}/published",
  method: "put",
  operationId: "extensionSetExtensionPublishedState",
};

export const extensionGetExtensionInstanceContract: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/contract",
  method: "get",
  operationId: "extensionGetExtensionInstanceContract",
};

export const extensionUpdateExtensionInstanceContract: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extension_Instances_ExtensionInstanceId_Contract.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extension-instances/{extensionInstanceId}/contract",
  method: "put",
  operationId: "extensionUpdateExtensionInstanceContract",
};

export const extensionUpdateExtensionPricing: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Contributors_ContributorId_Extension_ExtensionId_Pricing.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/contributors/{contributorId}/extension/{extensionId}/pricing",
  method: "put",
  operationId: "extensionUpdateExtensionPricing",
};

export const contributorGetCustomerBillingPortalLink: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Billing_Portal.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/billing-portal",
  method: "get",
  operationId: "contributorGetCustomerBillingPortalLink",
};

export const marketplaceCustomerUpdatePaymentMethod: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Put.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/payment-method",
  method: "put",
  operationId: "marketplaceCustomerUpdatePaymentMethod",
};

export const marketplaceCustomerGetPaymentMethod: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Payment_Method.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/payment-method",
  method: "get",
  operationId: "marketplaceCustomerGetPaymentMethod",
};

export const extensionOrderExtension: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Extensions_ExtensionId_Order.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/extensions/{extensionId}/order",
  method: "post",
  operationId: "extensionOrderExtension",
};

export const leadfyndrGetLeadFyndrProfileRequest: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/lead-fyndr-profile-request",
  method: "get",
  operationId: "leadfyndrGetLeadFyndrProfileRequest",
};

export const leadfyndrCreateLeadFyndrAccessRequest: OperationDescriptor<
  {
    requestBody: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Parameters.RequestBody;

    header: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.$409.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Request.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/lead-fyndr-profile-request",
  method: "post",
  operationId: "leadfyndrCreateLeadFyndrAccessRequest",
};

export const leadfyndrGetLeadFyndrProfile: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/lead-fyndr-profile",
  method: "get",
  operationId: "leadfyndrGetLeadFyndrProfile",
};

export const leadfyndrGetLeadFyndrProfileTariffOptions: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Lead_Fyndr_Profile_Tariff.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/lead-fyndr-profile/tariff",
  method: "get",
  operationId: "leadfyndrGetLeadFyndrProfileTariffOptions",
};

export const extensionGetCustomerExtensionInstanceOrders: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Customers_CustomerId_Extension_Orders.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/customers/{customerId}/extension-orders",
  method: "get",
  operationId: "extensionGetCustomerExtensionInstanceOrders",
};

export const extensionGetProjectExtensionInstanceOrders: OperationDescriptor<
  {
    header: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Parameters.Header;

    path: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Responses.$429.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldApi.Paths.V2_Projects_ProjectId_Extension_Orders.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/projects/{projectId}/extension-orders",
  method: "get",
  operationId: "extensionGetProjectExtensionInstanceOrders",
};

/**
 * ====================================
 * Client
 * ====================================
 */
export class MittwaldApiClient {
  private static instance: MittwaldApiClient | undefined;

  public static getInstance(): MittwaldApiClient {
    const requireClientInstanceMethod = (
      methodName: string | symbol
    ): Function => {
      const client = MittwaldApiClient.instance as
        | undefined
        | Record<string | symbol, any>;

      if (!client) {
        throw new Error(
          "ApiClientInstanceNotSet: API-Client-instance must be set before using hooks. Use MittwaldApiClient.setInstance()."
        );
      }

      if (!(methodName in client)) {
        throw new Error(
          `InvalidMethodCall: Could not find method ${String(
            methodName
          )} in MittwaldApiClient`
        );
      }

      const method = client[methodName];

      if (typeof method !== "function") {
        throw new Error(
          `InvalidMethodCall: ${String(
            methodName
          )} in MittwaldApiClient is not a function`
        );
      }

      return method;
    };

    /**
     * Catch access to all props and return proxy method that proxies
     * calls to the underlying client instance, while accessing the instance
     * at call-time.
     */
    const lazyAccessingClientInstanceHandler: ProxyHandler<MittwaldApiClient> =
      {
        get(client, prop) {
          return (...params: any[]) =>
            requireClientInstanceMethod(prop)(...params);
        },
      };

    return new Proxy(
      {} as MittwaldApiClient,
      lazyAccessingClientInstanceHandler
    );
  }

  public static setInstance(client: MittwaldApiClient): void {
    MittwaldApiClient.instance = client;
  }

  public contractGetDetailOfContract: RequestFunction<
    typeof contractGetDetailOfContract
  >;

  public contractCancelContractItemTermination: RequestFunction<
    typeof contractCancelContractItemTermination
  >;

  public contractTerminateContractItem: RequestFunction<
    typeof contractTerminateContractItem
  >;

  public contractCancelContractTermination: RequestFunction<
    typeof contractCancelContractTermination
  >;

  public contractTerminateContract: RequestFunction<
    typeof contractTerminateContract
  >;

  public contractGetDetailOfContractItem: RequestFunction<
    typeof contractGetDetailOfContractItem
  >;

  public contractListContracts: RequestFunction<typeof contractListContracts>;

  public cronjobCreateCronjob: RequestFunction<typeof cronjobCreateCronjob>;

  public cronjobListCronjobs: RequestFunction<typeof cronjobListCronjobs>;

  public cronjobCreateExecution: RequestFunction<typeof cronjobCreateExecution>;

  public cronjobListExecutions: RequestFunction<typeof cronjobListExecutions>;

  public cronjobDeleteCronjob: RequestFunction<typeof cronjobDeleteCronjob>;

  public cronjobGetCronjob: RequestFunction<typeof cronjobGetCronjob>;

  public cronjobUpdateCronjob: RequestFunction<typeof cronjobUpdateCronjob>;

  public cronjobGetExecution: RequestFunction<typeof cronjobGetExecution>;

  public customerRemoveAvatar: RequestFunction<typeof customerRemoveAvatar>;

  public customerRequestAvatarUpload: RequestFunction<
    typeof customerRequestAvatarUpload
  >;

  public customerCreateCustomer: RequestFunction<typeof customerCreateCustomer>;

  public customerListCustomers: RequestFunction<typeof customerListCustomers>;

  public customerDeleteCustomer: RequestFunction<typeof customerDeleteCustomer>;

  public customerGetCustomer: RequestFunction<typeof customerGetCustomer>;

  public customerUpdateCustomer: RequestFunction<typeof customerUpdateCustomer>;

  public databaseListMysqlCharsets: RequestFunction<
    typeof databaseListMysqlCharsets
  >;

  public ingressDeleteIngress: RequestFunction<typeof ingressDeleteIngress>;

  public ingressGetIngress: RequestFunction<typeof ingressGetIngress>;

  public ingressCreateIngress: RequestFunction<typeof ingressCreateIngress>;

  public ingressListIngresses: RequestFunction<typeof ingressListIngresses>;

  public ingressUpdateIngressPaths: RequestFunction<
    typeof ingressUpdateIngressPaths
  >;

  public ingressUpdateIngressTls: RequestFunction<
    typeof ingressUpdateIngressTls
  >;

  public invoiceListCustomerInvoices: RequestFunction<
    typeof invoiceListCustomerInvoices
  >;

  public projectFileSystemGetJwt: RequestFunction<
    typeof projectFileSystemGetJwt
  >;

  public projectListProjects: RequestFunction<typeof projectListProjects>;

  public orderListCustomerOrders: RequestFunction<
    typeof orderListCustomerOrders
  >;

  public appGetApp: RequestFunction<typeof appGetApp>;

  public appListApps: RequestFunction<typeof appListApps>;

  public conversationCreateConversation: RequestFunction<
    typeof conversationCreateConversation
  >;

  public conversationListConversations: RequestFunction<
    typeof conversationListConversations
  >;

  public conversationCreateMessage: RequestFunction<
    typeof conversationCreateMessage
  >;

  public conversationListMessagesByConversation: RequestFunction<
    typeof conversationListMessagesByConversation
  >;

  public conversationGetConversation: RequestFunction<
    typeof conversationGetConversation
  >;

  public conversationUpdateConversation: RequestFunction<
    typeof conversationUpdateConversation
  >;

  public conversationUpdateMessage: RequestFunction<
    typeof conversationUpdateMessage
  >;

  public projectDeleteProject: RequestFunction<typeof projectDeleteProject>;

  public projectGetProject: RequestFunction<typeof projectGetProject>;

  public articleGetArticle: RequestFunction<typeof articleGetArticle>;

  public articleListArticles: RequestFunction<typeof articleListArticles>;

  public projectDeleteProjectAvatar: RequestFunction<
    typeof projectDeleteProjectAvatar
  >;

  public projectRequestProjectAvatarUpload: RequestFunction<
    typeof projectRequestProjectAvatarUpload
  >;

  public customerIsCustomerLegallyCompetent: RequestFunction<
    typeof customerIsCustomerLegallyCompetent
  >;

  public conversationListCategories: RequestFunction<
    typeof conversationListCategories
  >;

  public conversationGetCategory: RequestFunction<
    typeof conversationGetCategory
  >;

  public contractCancelContractTariffChange: RequestFunction<
    typeof contractCancelContractTariffChange
  >;

  public conversationSetConversationStatus: RequestFunction<
    typeof conversationSetConversationStatus
  >;

  public notificationsListNotifications: RequestFunction<
    typeof notificationsListNotifications
  >;

  public orderGetOrder: RequestFunction<typeof orderGetOrder>;

  public domainListDomains: RequestFunction<typeof domainListDomains>;

  public domainUpdateDomainNameservers: RequestFunction<
    typeof domainUpdateDomainNameservers
  >;

  public domainDeleteDomain: RequestFunction<typeof domainDeleteDomain>;

  public domainGetDomain: RequestFunction<typeof domainGetDomain>;

  public conversationRequestFileUpload: RequestFunction<
    typeof conversationRequestFileUpload
  >;

  public domainResendDomainEmail: RequestFunction<
    typeof domainResendDomainEmail
  >;

  public relocationCreateRelocation: RequestFunction<
    typeof relocationCreateRelocation
  >;

  public orderListProjectOrders: RequestFunction<typeof orderListProjectOrders>;

  public invoiceGetDetailOfInvoiceSettings: RequestFunction<
    typeof invoiceGetDetailOfInvoiceSettings
  >;

  public invoiceUpdateInvoiceSettings: RequestFunction<
    typeof invoiceUpdateInvoiceSettings
  >;

  public fileCreateFile: RequestFunction<typeof fileCreateFile>;

  public backupCreateProjectBackup: RequestFunction<
    typeof backupCreateProjectBackup
  >;

  public backupListProjectBackups: RequestFunction<
    typeof backupListProjectBackups
  >;

  public backupCreateProjectBackupSchedule: RequestFunction<
    typeof backupCreateProjectBackupSchedule
  >;

  public backupListProjectBackupSchedules: RequestFunction<
    typeof backupListProjectBackupSchedules
  >;

  public backupDeleteProjectBackup: RequestFunction<
    typeof backupDeleteProjectBackup
  >;

  public backupGetProjectBackup: RequestFunction<typeof backupGetProjectBackup>;

  public backupCreateProjectBackupExport: RequestFunction<
    typeof backupCreateProjectBackupExport
  >;

  public backupDeleteProjectBackupExport: RequestFunction<
    typeof backupDeleteProjectBackupExport
  >;

  public backupDeleteProjectBackupSchedule: RequestFunction<
    typeof backupDeleteProjectBackupSchedule
  >;

  public backupGetProjectBackupSchedule: RequestFunction<
    typeof backupGetProjectBackupSchedule
  >;

  public backupUpdateProjectBackupSchedule: RequestFunction<
    typeof backupUpdateProjectBackupSchedule
  >;

  public backupUpdateProjectBackupDescription: RequestFunction<
    typeof backupUpdateProjectBackupDescription
  >;

  public cronjobUpdateCronjobAppId: RequestFunction<
    typeof cronjobUpdateCronjobAppId
  >;

  public contractGetBaseItemOfContract: RequestFunction<
    typeof contractGetBaseItemOfContract
  >;

  public contractGetNextTerminationDateForItem: RequestFunction<
    typeof contractGetNextTerminationDateForItem
  >;

  public projectDeleteServerAvatar: RequestFunction<
    typeof projectDeleteServerAvatar
  >;

  public projectRequestServerAvatarUpload: RequestFunction<
    typeof projectRequestServerAvatarUpload
  >;

  public projectListServers: RequestFunction<typeof projectListServers>;

  public projectGetServer: RequestFunction<typeof projectGetServer>;

  public projectCreateProject: RequestFunction<typeof projectCreateProject>;

  public projectUpdateServerDescription: RequestFunction<
    typeof projectUpdateServerDescription
  >;

  public databaseCreateMysqlDatabase: RequestFunction<
    typeof databaseCreateMysqlDatabase
  >;

  public databaseListMysqlDatabases: RequestFunction<
    typeof databaseListMysqlDatabases
  >;

  public databaseCreateRedisDatabase: RequestFunction<
    typeof databaseCreateRedisDatabase
  >;

  public databaseListRedisDatabases: RequestFunction<
    typeof databaseListRedisDatabases
  >;

  public databaseListMysqlVersions: RequestFunction<
    typeof databaseListMysqlVersions
  >;

  public databaseListRedisVersions: RequestFunction<
    typeof databaseListRedisVersions
  >;

  public customerGetCustomerTokenInvite: RequestFunction<
    typeof customerGetCustomerTokenInvite
  >;

  public customerCreateCustomerInvite: RequestFunction<
    typeof customerCreateCustomerInvite
  >;

  public customerListInvitesForCustomer: RequestFunction<
    typeof customerListInvitesForCustomer
  >;

  public customerListMembershipsForCustomer: RequestFunction<
    typeof customerListMembershipsForCustomer
  >;

  public projectGetProjectTokenInvite: RequestFunction<
    typeof projectGetProjectTokenInvite
  >;

  public projectCreateProjectInvite: RequestFunction<
    typeof projectCreateProjectInvite
  >;

  public projectListInvitesForProject: RequestFunction<
    typeof projectListInvitesForProject
  >;

  public customerListCustomerInvites: RequestFunction<
    typeof customerListCustomerInvites
  >;

  public customerListCustomerMemberships: RequestFunction<
    typeof customerListCustomerMemberships
  >;

  public projectListMembershipsForProject: RequestFunction<
    typeof projectListMembershipsForProject
  >;

  public projectListProjectInvites: RequestFunction<
    typeof projectListProjectInvites
  >;

  public projectListProjectMemberships: RequestFunction<
    typeof projectListProjectMemberships
  >;

  public customerCreateCategory: RequestFunction<typeof customerCreateCategory>;

  public customerListOfCustomerCategories: RequestFunction<
    typeof customerListOfCustomerCategories
  >;

  public customerDeleteCategory: RequestFunction<typeof customerDeleteCategory>;

  public customerGetCustomerCategory: RequestFunction<
    typeof customerGetCustomerCategory
  >;

  public customerUpdateCategory: RequestFunction<typeof customerUpdateCategory>;

  public appGetAppversion: RequestFunction<typeof appGetAppversion>;

  public appListAppversions: RequestFunction<typeof appListAppversions>;

  public sftpUserDeleteSftpUser: RequestFunction<typeof sftpUserDeleteSftpUser>;

  public sftpUserGetSftpUser: RequestFunction<typeof sftpUserGetSftpUser>;

  public sftpUserUpdateSftpUser: RequestFunction<typeof sftpUserUpdateSftpUser>;

  public sshUserDeleteSshUser: RequestFunction<typeof sshUserDeleteSshUser>;

  public sshUserGetSshUser: RequestFunction<typeof sshUserGetSshUser>;

  public sshUserUpdateSshUser: RequestFunction<typeof sshUserUpdateSshUser>;

  public sftpUserCreateSftpUser: RequestFunction<typeof sftpUserCreateSftpUser>;

  public sftpUserListSftpUsers: RequestFunction<typeof sftpUserListSftpUsers>;

  public sshUserCreateSshUser: RequestFunction<typeof sshUserCreateSshUser>;

  public sshUserListSshUsers: RequestFunction<typeof sshUserListSshUsers>;

  public projectGetSelfMembershipForProject: RequestFunction<
    typeof projectGetSelfMembershipForProject
  >;

  public orderCreateOrder: RequestFunction<typeof orderCreateOrder>;

  public orderListOrders: RequestFunction<typeof orderListOrders>;

  public orderCreateTariffChange: RequestFunction<
    typeof orderCreateTariffChange
  >;

  public orderPreviewOrder: RequestFunction<typeof orderPreviewOrder>;

  public orderPreviewTariffChange: RequestFunction<
    typeof orderPreviewTariffChange
  >;

  public relocationCreateLegacyTariffChange: RequestFunction<
    typeof relocationCreateLegacyTariffChange
  >;

  public contractGetDetailOfContractByDomain: RequestFunction<
    typeof contractGetDetailOfContractByDomain
  >;

  public contractGetDetailOfContractByProject: RequestFunction<
    typeof contractGetDetailOfContractByProject
  >;

  public contractGetDetailOfContractByServer: RequestFunction<
    typeof contractGetDetailOfContractByServer
  >;

  public appListUpdateCandidatesForAppversion: RequestFunction<
    typeof appListUpdateCandidatesForAppversion
  >;

  public userAuthenticateMfa: RequestFunction<typeof userAuthenticateMfa>;

  public userAuthenticate: RequestFunction<typeof userAuthenticate>;

  public userChangeEmail: RequestFunction<typeof userChangeEmail>;

  public userGetOwnEmail: RequestFunction<typeof userGetOwnEmail>;

  public userChangePassword: RequestFunction<typeof userChangePassword>;

  public userCheckToken: RequestFunction<typeof userCheckToken>;

  public userConfirmMfa: RequestFunction<typeof userConfirmMfa>;

  public userDisableMfa: RequestFunction<typeof userDisableMfa>;

  public userGetMfaStatus: RequestFunction<typeof userGetMfaStatus>;

  public userResetRecoverycodes: RequestFunction<typeof userResetRecoverycodes>;

  public userConfirmPasswordReset: RequestFunction<
    typeof userConfirmPasswordReset
  >;

  public userCreateApiToken: RequestFunction<typeof userCreateApiToken>;

  public userListApiTokens: RequestFunction<typeof userListApiTokens>;

  public userCreateSshKey: RequestFunction<typeof userCreateSshKey>;

  public userListSshKeys: RequestFunction<typeof userListSshKeys>;

  public userDeleteApiToken: RequestFunction<typeof userDeleteApiToken>;

  public userEditApiToken: RequestFunction<typeof userEditApiToken>;

  public userGetApiToken: RequestFunction<typeof userGetApiToken>;

  public userDeleteSshKey: RequestFunction<typeof userDeleteSshKey>;

  public userEditSshKey: RequestFunction<typeof userEditSshKey>;

  public userGetSshKey: RequestFunction<typeof userGetSshKey>;

  public userDeleteUser: RequestFunction<typeof userDeleteUser>;

  public userUpdateAccount: RequestFunction<typeof userUpdateAccount>;

  public userGetPasswordUpdatedAt: RequestFunction<
    typeof userGetPasswordUpdatedAt
  >;

  public userGetSession: RequestFunction<typeof userGetSession>;

  public userTerminateSession: RequestFunction<typeof userTerminateSession>;

  public userInitMfa: RequestFunction<typeof userInitMfa>;

  public userInitPasswordReset: RequestFunction<typeof userInitPasswordReset>;

  public userListSessions: RequestFunction<typeof userListSessions>;

  public userRefreshSession: RequestFunction<typeof userRefreshSession>;

  public userTerminateAllSessions: RequestFunction<
    typeof userTerminateAllSessions
  >;

  public userLogout: RequestFunction<typeof userLogout>;

  public userRegister: RequestFunction<typeof userRegister>;

  public userResendVerificationEmail: RequestFunction<
    typeof userResendVerificationEmail
  >;

  public userSupportCodeRequest: RequestFunction<typeof userSupportCodeRequest>;

  public userVerifyEmail: RequestFunction<typeof userVerifyEmail>;

  public userVerifyRegistration: RequestFunction<typeof userVerifyRegistration>;

  public userAddPhoneNumber: RequestFunction<typeof userAddPhoneNumber>;

  public userRemovePhoneNumber: RequestFunction<typeof userRemovePhoneNumber>;

  public userCreateFeedback: RequestFunction<typeof userCreateFeedback>;

  public userGetPersonalizedSettings: RequestFunction<
    typeof userGetPersonalizedSettings
  >;

  public userUpdatePersonalizedSettings: RequestFunction<
    typeof userUpdatePersonalizedSettings
  >;

  public userGetUser: RequestFunction<typeof userGetUser>;

  public userUpdatePersonalInformation: RequestFunction<
    typeof userUpdatePersonalInformation
  >;

  public userListFeedback: RequestFunction<typeof userListFeedback>;

  public userRemoveAvatar: RequestFunction<typeof userRemoveAvatar>;

  public userRequestAvatarUpload: RequestFunction<
    typeof userRequestAvatarUpload
  >;

  public ingressRequestIngressAcmeCertificateIssuance: RequestFunction<
    typeof ingressRequestIngressAcmeCertificateIssuance
  >;

  public newsletterGetInfo: RequestFunction<typeof newsletterGetInfo>;

  public newsletterUnsubscribeUser: RequestFunction<
    typeof newsletterUnsubscribeUser
  >;

  public newsletterSubscribeUser: RequestFunction<
    typeof newsletterSubscribeUser
  >;

  public domainCheckDomainRegistrability: RequestFunction<
    typeof domainCheckDomainRegistrability
  >;

  public domainListTldContactSchemas: RequestFunction<
    typeof domainListTldContactSchemas
  >;

  public dnsCreateDnsZone: RequestFunction<typeof dnsCreateDnsZone>;

  public dnsDeleteDnsZone: RequestFunction<typeof dnsDeleteDnsZone>;

  public dnsGetDnsZone: RequestFunction<typeof dnsGetDnsZone>;

  public dnsListDnsZones: RequestFunction<typeof dnsListDnsZones>;

  public dnsSetRecordSetManaged: RequestFunction<typeof dnsSetRecordSetManaged>;

  public dnsUpdateRecordSet: RequestFunction<typeof dnsUpdateRecordSet>;

  public domainAbortDomainDeclaration: RequestFunction<
    typeof domainAbortDomainDeclaration
  >;

  public domainCreateDomainAuthCode: RequestFunction<
    typeof domainCreateDomainAuthCode
  >;

  public domainListTlds: RequestFunction<typeof domainListTlds>;

  public domainUpdateDomainAuthCode: RequestFunction<
    typeof domainUpdateDomainAuthCode
  >;

  public domainUpdateDomainContact: RequestFunction<
    typeof domainUpdateDomainContact
  >;

  public domainUpdateDomainProjectId: RequestFunction<
    typeof domainUpdateDomainProjectId
  >;

  public mailCreateDeliverybox: RequestFunction<typeof mailCreateDeliverybox>;

  public mailListDeliveryBoxes: RequestFunction<typeof mailListDeliveryBoxes>;

  public mailCreateMailAddress: RequestFunction<typeof mailCreateMailAddress>;

  public mailListMailAddresses: RequestFunction<typeof mailListMailAddresses>;

  public mailDeleteDeliveryBox: RequestFunction<typeof mailDeleteDeliveryBox>;

  public mailGetDeliveryBox: RequestFunction<typeof mailGetDeliveryBox>;

  public mailDeleteMailAddress: RequestFunction<typeof mailDeleteMailAddress>;

  public mailGetMailAddress: RequestFunction<typeof mailGetMailAddress>;

  public mailListProjectMailSettings: RequestFunction<
    typeof mailListProjectMailSettings
  >;

  public mailUpdateDeliveryBoxDescription: RequestFunction<
    typeof mailUpdateDeliveryBoxDescription
  >;

  public mailUpdateDeliveryBoxPassword: RequestFunction<
    typeof mailUpdateDeliveryBoxPassword
  >;

  public mailUpdateMailAddressAddress: RequestFunction<
    typeof mailUpdateMailAddressAddress
  >;

  public mailUpdateMailAddressAutoresponder: RequestFunction<
    typeof mailUpdateMailAddressAutoresponder
  >;

  public mailUpdateMailAddressCatchAll: RequestFunction<
    typeof mailUpdateMailAddressCatchAll
  >;

  public mailUpdateMailAddressForwardAddresses: RequestFunction<
    typeof mailUpdateMailAddressForwardAddresses
  >;

  public mailUpdateMailAddressPassword: RequestFunction<
    typeof mailUpdateMailAddressPassword
  >;

  public mailUpdateMailAddressQuota: RequestFunction<
    typeof mailUpdateMailAddressQuota
  >;

  public mailUpdateMailAddressSpamProtection: RequestFunction<
    typeof mailUpdateMailAddressSpamProtection
  >;

  public appExecuteAction: RequestFunction<typeof appExecuteAction>;

  public appGetAppinstallation: RequestFunction<typeof appGetAppinstallation>;

  public appPatchAppinstallation: RequestFunction<
    typeof appPatchAppinstallation
  >;

  public appUninstallAppinstallation: RequestFunction<
    typeof appUninstallAppinstallation
  >;

  public appGetMissingDependenciesForAppinstallation: RequestFunction<
    typeof appGetMissingDependenciesForAppinstallation
  >;

  public appGetSystemsoftware: RequestFunction<typeof appGetSystemsoftware>;

  public appGetSystemsoftwareversion: RequestFunction<
    typeof appGetSystemsoftwareversion
  >;

  public appLinkDatabase: RequestFunction<typeof appLinkDatabase>;

  public appListAppinstallations: RequestFunction<
    typeof appListAppinstallations
  >;

  public appRequestAppinstallation: RequestFunction<
    typeof appRequestAppinstallation
  >;

  public appListSystemsoftwares: RequestFunction<typeof appListSystemsoftwares>;

  public appListSystemsoftwareversions: RequestFunction<
    typeof appListSystemsoftwareversions
  >;

  public appRetrieveStatus: RequestFunction<typeof appRetrieveStatus>;

  public appUnlinkDatabase: RequestFunction<typeof appUnlinkDatabase>;

  public databaseDeleteMysqlDatabase: RequestFunction<
    typeof databaseDeleteMysqlDatabase
  >;

  public databaseGetMysqlDatabase: RequestFunction<
    typeof databaseGetMysqlDatabase
  >;

  public databaseDeleteMysqlUser: RequestFunction<
    typeof databaseDeleteMysqlUser
  >;

  public databaseGetMysqlUser: RequestFunction<typeof databaseGetMysqlUser>;

  public databaseUpdateMysqlUser: RequestFunction<
    typeof databaseUpdateMysqlUser
  >;

  public databaseDeleteRedisDatabase: RequestFunction<
    typeof databaseDeleteRedisDatabase
  >;

  public databaseGetRedisDatabase: RequestFunction<
    typeof databaseGetRedisDatabase
  >;

  public databaseDisableMysqlUser: RequestFunction<
    typeof databaseDisableMysqlUser
  >;

  public databaseEnableMysqlUser: RequestFunction<
    typeof databaseEnableMysqlUser
  >;

  public databaseGetMysqlUserPhpMyAdminUrl: RequestFunction<
    typeof databaseGetMysqlUserPhpMyAdminUrl
  >;

  public databaseUpdateMysqlDatabaseDefaultCharset: RequestFunction<
    typeof databaseUpdateMysqlDatabaseDefaultCharset
  >;

  public databaseUpdateMysqlDatabaseDescription: RequestFunction<
    typeof databaseUpdateMysqlDatabaseDescription
  >;

  public databaseUpdateMysqlUserPassword: RequestFunction<
    typeof databaseUpdateMysqlUserPassword
  >;

  public databaseUpdateRedisDatabaseConfiguration: RequestFunction<
    typeof databaseUpdateRedisDatabaseConfiguration
  >;

  public databaseUpdateRedisDatabaseDescription: RequestFunction<
    typeof databaseUpdateRedisDatabaseDescription
  >;

  public fileGetFileMeta: RequestFunction<typeof fileGetFileMeta>;

  public fileGetFile: RequestFunction<typeof fileGetFile>;

  public pageinsightsGetPerformanceData: RequestFunction<
    typeof pageinsightsGetPerformanceData
  >;

  public pageinsightsListPerformanceDataForProject: RequestFunction<
    typeof pageinsightsListPerformanceDataForProject
  >;

  public projectFileSystemGetDirectories: RequestFunction<
    typeof projectFileSystemGetDirectories
  >;

  public projectFileSystemGetDiskUsage: RequestFunction<
    typeof projectFileSystemGetDiskUsage
  >;

  public projectFileSystemGetFileContent: RequestFunction<
    typeof projectFileSystemGetFileContent
  >;

  public projectFileSystemListFiles: RequestFunction<
    typeof projectFileSystemListFiles
  >;

  public projectUpdateProjectDescription: RequestFunction<
    typeof projectUpdateProjectDescription
  >;

  public fileGetFileUploadTokenRules: RequestFunction<
    typeof fileGetFileUploadTokenRules
  >;

  public fileGetFileUploadTypeRules: RequestFunction<
    typeof fileGetFileUploadTypeRules
  >;

  public conversationGetConversationMembers: RequestFunction<
    typeof conversationGetConversationMembers
  >;

  public conversationGetFileAccessToken: RequestFunction<
    typeof conversationGetFileAccessToken
  >;

  public invoiceGetFileAccessToken: RequestFunction<
    typeof invoiceGetFileAccessToken
  >;

  public pageinsightsGetStraceData: RequestFunction<
    typeof pageinsightsGetStraceData
  >;

  public pageinsightsScheduleStrace: RequestFunction<
    typeof pageinsightsScheduleStrace
  >;

  public userAuthenticateWithAccessTokenRetrievalKey: RequestFunction<
    typeof userAuthenticateWithAccessTokenRetrievalKey
  >;

  public databaseCreateMysqlUser: RequestFunction<
    typeof databaseCreateMysqlUser
  >;

  public databaseListMysqlUsers: RequestFunction<typeof databaseListMysqlUsers>;

  public ingressIngressVerifyOwnership: RequestFunction<
    typeof ingressIngressVerifyOwnership
  >;

  public mailUpdateProjectMailSetting: RequestFunction<
    typeof mailUpdateProjectMailSetting
  >;

  public customerAcceptCustomerInvite: RequestFunction<
    typeof customerAcceptCustomerInvite
  >;

  public customerDeclineCustomerInvite: RequestFunction<
    typeof customerDeclineCustomerInvite
  >;

  public customerDeleteCustomerInvite: RequestFunction<
    typeof customerDeleteCustomerInvite
  >;

  public customerGetCustomerInvite: RequestFunction<
    typeof customerGetCustomerInvite
  >;

  public customerDeleteCustomerMembership: RequestFunction<
    typeof customerDeleteCustomerMembership
  >;

  public customerGetCustomerMembership: RequestFunction<
    typeof customerGetCustomerMembership
  >;

  public customerUpdateCustomerMembership: RequestFunction<
    typeof customerUpdateCustomerMembership
  >;

  public customerResendCustomerInviteMail: RequestFunction<
    typeof customerResendCustomerInviteMail
  >;

  public projectAcceptProjectInvite: RequestFunction<
    typeof projectAcceptProjectInvite
  >;

  public projectDeclineProjectInvite: RequestFunction<
    typeof projectDeclineProjectInvite
  >;

  public projectDeleteProjectInvite: RequestFunction<
    typeof projectDeleteProjectInvite
  >;

  public projectGetProjectInvite: RequestFunction<
    typeof projectGetProjectInvite
  >;

  public projectDeleteProjectMembership: RequestFunction<
    typeof projectDeleteProjectMembership
  >;

  public projectGetProjectMembership: RequestFunction<
    typeof projectGetProjectMembership
  >;

  public projectUpdateProjectMembership: RequestFunction<
    typeof projectUpdateProjectMembership
  >;

  public projectResendProjectInviteMail: RequestFunction<
    typeof projectResendProjectInviteMail
  >;

  public appGetInstalledSystemsoftwareForAppinstallation: RequestFunction<
    typeof appGetInstalledSystemsoftwareForAppinstallation
  >;

  public invoiceDetail: RequestFunction<typeof invoiceDetail>;

  public appRequestAppinstallationCopy: RequestFunction<
    typeof appRequestAppinstallationCopy
  >;

  public appSetDatabaseUsers: RequestFunction<typeof appSetDatabaseUsers>;

  public extensionAuthenticateInstance: RequestFunction<
    typeof extensionAuthenticateInstance
  >;

  public extensionConsentToExtensionScopes: RequestFunction<
    typeof extensionConsentToExtensionScopes
  >;

  public extensionCreateExtensionInstance: RequestFunction<
    typeof extensionCreateExtensionInstance
  >;

  public extensionListExtensionInstances: RequestFunction<
    typeof extensionListExtensionInstances
  >;

  public extensionDeleteExtensionInstance: RequestFunction<
    typeof extensionDeleteExtensionInstance
  >;

  public extensionGetExtensionInstance: RequestFunction<
    typeof extensionGetExtensionInstance
  >;

  public extensionDisableExtensionInstance: RequestFunction<
    typeof extensionDisableExtensionInstance
  >;

  public extensionEnableExtensionInstance: RequestFunction<
    typeof extensionEnableExtensionInstance
  >;

  public extensionGetContributor: RequestFunction<
    typeof extensionGetContributor
  >;

  public extensionGetExtension: RequestFunction<typeof extensionGetExtension>;

  public extensionListContributors: RequestFunction<
    typeof extensionListContributors
  >;

  public extensionListExtensions: RequestFunction<
    typeof extensionListExtensions
  >;

  public userOauthGetAuthorization: RequestFunction<
    typeof userOauthGetAuthorization
  >;

  public userOauthRetrieveAccessToken: RequestFunction<
    typeof userOauthRetrieveAccessToken
  >;

  public userVerifyPhoneNumber: RequestFunction<typeof userVerifyPhoneNumber>;

  public notificationsCountUnreadNotifications: RequestFunction<
    typeof notificationsCountUnreadNotifications
  >;

  public fileGetFileWithName: RequestFunction<typeof fileGetFileWithName>;

  public domainCheckDomainTransferability: RequestFunction<
    typeof domainCheckDomainTransferability
  >;

  public appListAppinstallationsForUser: RequestFunction<
    typeof appListAppinstallationsForUser
  >;

  public domainGetLatestScreenshot: RequestFunction<
    typeof domainGetLatestScreenshot
  >;

  public extensionGetPublicKey: RequestFunction<typeof extensionGetPublicKey>;

  public notificationsReadAllNotifications: RequestFunction<
    typeof notificationsReadAllNotifications
  >;

  public notificationsReadNotification: RequestFunction<
    typeof notificationsReadNotification
  >;

  public userGetPollStatus: RequestFunction<typeof userGetPollStatus>;

  public userPostPollStatus: RequestFunction<typeof userPostPollStatus>;

  public containerValidateContainerRegistryUri: RequestFunction<
    typeof containerValidateContainerRegistryUri
  >;

  public containerDeleteRegistry: RequestFunction<
    typeof containerDeleteRegistry
  >;

  public containerGetRegistry: RequestFunction<typeof containerGetRegistry>;

  public containerUpdateRegistry: RequestFunction<
    typeof containerUpdateRegistry
  >;

  public containerGetContainerImageConfig: RequestFunction<
    typeof containerGetContainerImageConfig
  >;

  public containerCreateRegistry: RequestFunction<
    typeof containerCreateRegistry
  >;

  public containerListRegistries: RequestFunction<
    typeof containerListRegistries
  >;

  public containerValidateRegistryCredentials: RequestFunction<
    typeof containerValidateRegistryCredentials
  >;

  public containerDeleteVolume: RequestFunction<typeof containerDeleteVolume>;

  public containerGetVolume: RequestFunction<typeof containerGetVolume>;

  public containerGetServiceLogs: RequestFunction<
    typeof containerGetServiceLogs
  >;

  public containerGetService: RequestFunction<typeof containerGetService>;

  public containerListServices: RequestFunction<typeof containerListServices>;

  public containerListStacks: RequestFunction<typeof containerListStacks>;

  public containerListVolumes: RequestFunction<typeof containerListVolumes>;

  public containerDeclareStack: RequestFunction<typeof containerDeclareStack>;

  public containerGetStack: RequestFunction<typeof containerGetStack>;

  public containerUpdateStack: RequestFunction<typeof containerUpdateStack>;

  public containerRecreateService: RequestFunction<
    typeof containerRecreateService
  >;

  public containerRestartService: RequestFunction<
    typeof containerRestartService
  >;

  public containerStartService: RequestFunction<typeof containerStartService>;

  public containerStopService: RequestFunction<typeof containerStopService>;

  public extensionCreateRetrievalKey: RequestFunction<
    typeof extensionCreateRetrievalKey
  >;

  public contributorRotateSecretForExtensionInstance: RequestFunction<
    typeof contributorRotateSecretForExtensionInstance
  >;

  public domainSuggest: RequestFunction<typeof domainSuggest>;

  public appReplaceDatabase: RequestFunction<typeof appReplaceDatabase>;

  public contractGetDetailOfContractByCertificate: RequestFunction<
    typeof contractGetDetailOfContractByCertificate
  >;

  public ingressListIngressesCompatibleWithCertificate: RequestFunction<
    typeof ingressListIngressesCompatibleWithCertificate
  >;

  public sslCheckReplaceCertificate: RequestFunction<
    typeof sslCheckReplaceCertificate
  >;

  public sslCreateCertificateRequest: RequestFunction<
    typeof sslCreateCertificateRequest
  >;

  public sslListCertificateRequests: RequestFunction<
    typeof sslListCertificateRequests
  >;

  public sslDeleteCertificateRequest: RequestFunction<
    typeof sslDeleteCertificateRequest
  >;

  public sslDeleteCertificate: RequestFunction<typeof sslDeleteCertificate>;

  public sslGetCertificateRequest: RequestFunction<
    typeof sslGetCertificateRequest
  >;

  public sslGetCertificate: RequestFunction<typeof sslGetCertificate>;

  public sslReplaceCertificate: RequestFunction<typeof sslReplaceCertificate>;

  public sslListCertificates: RequestFunction<typeof sslListCertificates>;

  public sslSetCertificateRequestCertificate: RequestFunction<
    typeof sslSetCertificateRequestCertificate
  >;

  public extensionDryRunWebhook: RequestFunction<typeof extensionDryRunWebhook>;

  public storagespaceReplaceProjectNotificationThreshold: RequestFunction<
    typeof storagespaceReplaceProjectNotificationThreshold
  >;

  public storagespaceGetProjectStatistics: RequestFunction<
    typeof storagespaceGetProjectStatistics
  >;

  public storagespaceGetServerStatistics: RequestFunction<
    typeof storagespaceGetServerStatistics
  >;

  public storagespaceReplaceServerNotificationThreshold: RequestFunction<
    typeof storagespaceReplaceServerNotificationThreshold
  >;

  public cronjobAbortExecution: RequestFunction<typeof cronjobAbortExecution>;

  public extensionGetExtensionInstanceForCustomer: RequestFunction<
    typeof extensionGetExtensionInstanceForCustomer
  >;

  public extensionGetExtensionInstanceForProject: RequestFunction<
    typeof extensionGetExtensionInstanceForProject
  >;

  public extensionListOwnExtensions: RequestFunction<
    typeof extensionListOwnExtensions
  >;

  public extensionRegisterExtension: RequestFunction<
    typeof extensionRegisterExtension
  >;

  public extensionDeleteExtension: RequestFunction<
    typeof extensionDeleteExtension
  >;

  public extensionGetOwnExtension: RequestFunction<
    typeof extensionGetOwnExtension
  >;

  public extensionPatchExtension: RequestFunction<
    typeof extensionPatchExtension
  >;

  public leadfyndrGetLead: RequestFunction<typeof leadfyndrGetLead>;

  public leadfyndrGetUnlockedLead: RequestFunction<
    typeof leadfyndrGetUnlockedLead
  >;

  public leadfyndrUnlockLead: RequestFunction<typeof leadfyndrUnlockLead>;

  public leadfyndrListLeads: RequestFunction<typeof leadfyndrListLeads>;

  public leadfyndrListUnlockedLeads: RequestFunction<
    typeof leadfyndrListUnlockedLeads
  >;

  public extensionGenerateSessionToken: RequestFunction<
    typeof extensionGenerateSessionToken
  >;

  public customerCreateRecommendationSuggestion: RequestFunction<
    typeof customerCreateRecommendationSuggestion
  >;

  public customerCreateWallet: RequestFunction<typeof customerCreateWallet>;

  public customerGetWallet: RequestFunction<typeof customerGetWallet>;

  public containerPullImageForService: RequestFunction<
    typeof containerPullImageForService
  >;

  public leadfyndrRemoveUnlockedLeadReservation: RequestFunction<
    typeof leadfyndrRemoveUnlockedLeadReservation
  >;

  public leadfyndrReserveUnlockedLead: RequestFunction<
    typeof leadfyndrReserveUnlockedLead
  >;

  public extensionStartExtensionCheckout: RequestFunction<
    typeof extensionStartExtensionCheckout
  >;

  public extensionCancelExtensionTermination: RequestFunction<
    typeof extensionCancelExtensionTermination
  >;

  public extensionScheduleExtensionTermination: RequestFunction<
    typeof extensionScheduleExtensionTermination
  >;

  public contributorGetBillingInformation: RequestFunction<
    typeof contributorGetBillingInformation
  >;

  public contributorGetLoginLink: RequestFunction<
    typeof contributorGetLoginLink
  >;

  public contributorListIncomingInvoices: RequestFunction<
    typeof contributorListIncomingInvoices
  >;

  public contributorListOnbehalfInvoices: RequestFunction<
    typeof contributorListOnbehalfInvoices
  >;

  public contributorReceiptGetFileAccessToken: RequestFunction<
    typeof contributorReceiptGetFileAccessToken
  >;

  public extensionChangeContext: RequestFunction<typeof extensionChangeContext>;

  public extensionCreateContributorOnboardingProcess: RequestFunction<
    typeof extensionCreateContributorOnboardingProcess
  >;

  public extensionRemoveAsset: RequestFunction<typeof extensionRemoveAsset>;

  public extensionRemoveLogo: RequestFunction<typeof extensionRemoveLogo>;

  public extensionRequestLogoUpload: RequestFunction<
    typeof extensionRequestLogoUpload
  >;

  public extensionRequestAssetUpload: RequestFunction<
    typeof extensionRequestAssetUpload
  >;

  public extensionRequestExtensionVerification: RequestFunction<
    typeof extensionRequestExtensionVerification
  >;

  public extensionSetExtensionPublishedState: RequestFunction<
    typeof extensionSetExtensionPublishedState
  >;

  public extensionGetExtensionInstanceContract: RequestFunction<
    typeof extensionGetExtensionInstanceContract
  >;

  public extensionUpdateExtensionInstanceContract: RequestFunction<
    typeof extensionUpdateExtensionInstanceContract
  >;

  public extensionUpdateExtensionPricing: RequestFunction<
    typeof extensionUpdateExtensionPricing
  >;

  public contributorGetCustomerBillingPortalLink: RequestFunction<
    typeof contributorGetCustomerBillingPortalLink
  >;

  public marketplaceCustomerUpdatePaymentMethod: RequestFunction<
    typeof marketplaceCustomerUpdatePaymentMethod
  >;

  public marketplaceCustomerGetPaymentMethod: RequestFunction<
    typeof marketplaceCustomerGetPaymentMethod
  >;

  public extensionOrderExtension: RequestFunction<
    typeof extensionOrderExtension
  >;

  public extensionGetCustomerExtensionInstanceOrders: RequestFunction<
    typeof extensionGetCustomerExtensionInstanceOrders
  >;

  public extensionGetProjectExtensionInstanceOrders: RequestFunction<
    typeof extensionGetProjectExtensionInstanceOrders
  >;

  public leadfyndrGetLeadFyndrProfileRequest: RequestFunction<
    typeof leadfyndrGetLeadFyndrProfileRequest
  >;

  public leadfyndrCreateLeadFyndrAccessRequest: RequestFunction<
    typeof leadfyndrCreateLeadFyndrAccessRequest
  >;

  public leadfyndrGetLeadFyndrProfile: RequestFunction<
    typeof leadfyndrGetLeadFyndrProfile
  >;

  public leadfyndrGetLeadFyndrProfileTariffOptions: RequestFunction<
    typeof leadfyndrGetLeadFyndrProfileTariffOptions
  >;

  public constructor(clientOrUrl: Client | string) {
    const client =
      typeof clientOrUrl === "string"
        ? new KyClient({ ky: { prefixUrl: clientOrUrl } })
        : clientOrUrl;

    this.contractGetDetailOfContract = client.requestFunctionFactory(
      contractGetDetailOfContract
    );

    this.contractCancelContractItemTermination = client.requestFunctionFactory(
      contractCancelContractItemTermination
    );

    this.contractTerminateContractItem = client.requestFunctionFactory(
      contractTerminateContractItem
    );

    this.contractCancelContractTermination = client.requestFunctionFactory(
      contractCancelContractTermination
    );

    this.contractTerminateContract = client.requestFunctionFactory(
      contractTerminateContract
    );

    this.contractGetDetailOfContractItem = client.requestFunctionFactory(
      contractGetDetailOfContractItem
    );

    this.contractListContracts = client.requestFunctionFactory(
      contractListContracts
    );

    this.cronjobCreateCronjob =
      client.requestFunctionFactory(cronjobCreateCronjob);

    this.cronjobListCronjobs =
      client.requestFunctionFactory(cronjobListCronjobs);

    this.cronjobCreateExecution = client.requestFunctionFactory(
      cronjobCreateExecution
    );

    this.cronjobListExecutions = client.requestFunctionFactory(
      cronjobListExecutions
    );

    this.cronjobDeleteCronjob =
      client.requestFunctionFactory(cronjobDeleteCronjob);

    this.cronjobGetCronjob = client.requestFunctionFactory(cronjobGetCronjob);

    this.cronjobUpdateCronjob =
      client.requestFunctionFactory(cronjobUpdateCronjob);

    this.cronjobGetExecution =
      client.requestFunctionFactory(cronjobGetExecution);

    this.customerRemoveAvatar =
      client.requestFunctionFactory(customerRemoveAvatar);

    this.customerRequestAvatarUpload = client.requestFunctionFactory(
      customerRequestAvatarUpload
    );

    this.customerCreateCustomer = client.requestFunctionFactory(
      customerCreateCustomer
    );

    this.customerListCustomers = client.requestFunctionFactory(
      customerListCustomers
    );

    this.customerDeleteCustomer = client.requestFunctionFactory(
      customerDeleteCustomer
    );

    this.customerGetCustomer =
      client.requestFunctionFactory(customerGetCustomer);

    this.customerUpdateCustomer = client.requestFunctionFactory(
      customerUpdateCustomer
    );

    this.databaseListMysqlCharsets = client.requestFunctionFactory(
      databaseListMysqlCharsets
    );

    this.ingressDeleteIngress =
      client.requestFunctionFactory(ingressDeleteIngress);

    this.ingressGetIngress = client.requestFunctionFactory(ingressGetIngress);

    this.ingressCreateIngress =
      client.requestFunctionFactory(ingressCreateIngress);

    this.ingressListIngresses =
      client.requestFunctionFactory(ingressListIngresses);

    this.ingressUpdateIngressPaths = client.requestFunctionFactory(
      ingressUpdateIngressPaths
    );

    this.ingressUpdateIngressTls = client.requestFunctionFactory(
      ingressUpdateIngressTls
    );

    this.invoiceListCustomerInvoices = client.requestFunctionFactory(
      invoiceListCustomerInvoices
    );

    this.projectFileSystemGetJwt = client.requestFunctionFactory(
      projectFileSystemGetJwt
    );

    this.projectListProjects =
      client.requestFunctionFactory(projectListProjects);

    this.orderListCustomerOrders = client.requestFunctionFactory(
      orderListCustomerOrders
    );

    this.appGetApp = client.requestFunctionFactory(appGetApp);

    this.appListApps = client.requestFunctionFactory(appListApps);

    this.conversationCreateConversation = client.requestFunctionFactory(
      conversationCreateConversation
    );

    this.conversationListConversations = client.requestFunctionFactory(
      conversationListConversations
    );

    this.conversationCreateMessage = client.requestFunctionFactory(
      conversationCreateMessage
    );

    this.conversationListMessagesByConversation = client.requestFunctionFactory(
      conversationListMessagesByConversation
    );

    this.conversationGetConversation = client.requestFunctionFactory(
      conversationGetConversation
    );

    this.conversationUpdateConversation = client.requestFunctionFactory(
      conversationUpdateConversation
    );

    this.conversationUpdateMessage = client.requestFunctionFactory(
      conversationUpdateMessage
    );

    this.projectDeleteProject =
      client.requestFunctionFactory(projectDeleteProject);

    this.projectGetProject = client.requestFunctionFactory(projectGetProject);

    this.articleGetArticle = client.requestFunctionFactory(articleGetArticle);

    this.articleListArticles =
      client.requestFunctionFactory(articleListArticles);

    this.projectDeleteProjectAvatar = client.requestFunctionFactory(
      projectDeleteProjectAvatar
    );

    this.projectRequestProjectAvatarUpload = client.requestFunctionFactory(
      projectRequestProjectAvatarUpload
    );

    this.customerIsCustomerLegallyCompetent = client.requestFunctionFactory(
      customerIsCustomerLegallyCompetent
    );

    this.conversationListCategories = client.requestFunctionFactory(
      conversationListCategories
    );

    this.conversationGetCategory = client.requestFunctionFactory(
      conversationGetCategory
    );

    this.contractCancelContractTariffChange = client.requestFunctionFactory(
      contractCancelContractTariffChange
    );

    this.conversationSetConversationStatus = client.requestFunctionFactory(
      conversationSetConversationStatus
    );

    this.notificationsListNotifications = client.requestFunctionFactory(
      notificationsListNotifications
    );

    this.orderGetOrder = client.requestFunctionFactory(orderGetOrder);

    this.domainListDomains = client.requestFunctionFactory(domainListDomains);

    this.domainUpdateDomainNameservers = client.requestFunctionFactory(
      domainUpdateDomainNameservers
    );

    this.domainDeleteDomain = client.requestFunctionFactory(domainDeleteDomain);

    this.domainGetDomain = client.requestFunctionFactory(domainGetDomain);

    this.conversationRequestFileUpload = client.requestFunctionFactory(
      conversationRequestFileUpload
    );

    this.domainResendDomainEmail = client.requestFunctionFactory(
      domainResendDomainEmail
    );

    this.relocationCreateRelocation = client.requestFunctionFactory(
      relocationCreateRelocation
    );

    this.orderListProjectOrders = client.requestFunctionFactory(
      orderListProjectOrders
    );

    this.invoiceGetDetailOfInvoiceSettings = client.requestFunctionFactory(
      invoiceGetDetailOfInvoiceSettings
    );

    this.invoiceUpdateInvoiceSettings = client.requestFunctionFactory(
      invoiceUpdateInvoiceSettings
    );

    this.fileCreateFile = client.requestFunctionFactory(fileCreateFile);

    this.backupCreateProjectBackup = client.requestFunctionFactory(
      backupCreateProjectBackup
    );

    this.backupListProjectBackups = client.requestFunctionFactory(
      backupListProjectBackups
    );

    this.backupCreateProjectBackupSchedule = client.requestFunctionFactory(
      backupCreateProjectBackupSchedule
    );

    this.backupListProjectBackupSchedules = client.requestFunctionFactory(
      backupListProjectBackupSchedules
    );

    this.backupDeleteProjectBackup = client.requestFunctionFactory(
      backupDeleteProjectBackup
    );

    this.backupGetProjectBackup = client.requestFunctionFactory(
      backupGetProjectBackup
    );

    this.backupCreateProjectBackupExport = client.requestFunctionFactory(
      backupCreateProjectBackupExport
    );

    this.backupDeleteProjectBackupExport = client.requestFunctionFactory(
      backupDeleteProjectBackupExport
    );

    this.backupDeleteProjectBackupSchedule = client.requestFunctionFactory(
      backupDeleteProjectBackupSchedule
    );

    this.backupGetProjectBackupSchedule = client.requestFunctionFactory(
      backupGetProjectBackupSchedule
    );

    this.backupUpdateProjectBackupSchedule = client.requestFunctionFactory(
      backupUpdateProjectBackupSchedule
    );

    this.backupUpdateProjectBackupDescription = client.requestFunctionFactory(
      backupUpdateProjectBackupDescription
    );

    this.cronjobUpdateCronjobAppId = client.requestFunctionFactory(
      cronjobUpdateCronjobAppId
    );

    this.contractGetBaseItemOfContract = client.requestFunctionFactory(
      contractGetBaseItemOfContract
    );

    this.contractGetNextTerminationDateForItem = client.requestFunctionFactory(
      contractGetNextTerminationDateForItem
    );

    this.projectDeleteServerAvatar = client.requestFunctionFactory(
      projectDeleteServerAvatar
    );

    this.projectRequestServerAvatarUpload = client.requestFunctionFactory(
      projectRequestServerAvatarUpload
    );

    this.projectListServers = client.requestFunctionFactory(projectListServers);

    this.projectGetServer = client.requestFunctionFactory(projectGetServer);

    this.projectCreateProject =
      client.requestFunctionFactory(projectCreateProject);

    this.projectUpdateServerDescription = client.requestFunctionFactory(
      projectUpdateServerDescription
    );

    this.databaseCreateMysqlDatabase = client.requestFunctionFactory(
      databaseCreateMysqlDatabase
    );

    this.databaseListMysqlDatabases = client.requestFunctionFactory(
      databaseListMysqlDatabases
    );

    this.databaseCreateRedisDatabase = client.requestFunctionFactory(
      databaseCreateRedisDatabase
    );

    this.databaseListRedisDatabases = client.requestFunctionFactory(
      databaseListRedisDatabases
    );

    this.databaseListMysqlVersions = client.requestFunctionFactory(
      databaseListMysqlVersions
    );

    this.databaseListRedisVersions = client.requestFunctionFactory(
      databaseListRedisVersions
    );

    this.customerGetCustomerTokenInvite = client.requestFunctionFactory(
      customerGetCustomerTokenInvite
    );

    this.customerCreateCustomerInvite = client.requestFunctionFactory(
      customerCreateCustomerInvite
    );

    this.customerListInvitesForCustomer = client.requestFunctionFactory(
      customerListInvitesForCustomer
    );

    this.customerListMembershipsForCustomer = client.requestFunctionFactory(
      customerListMembershipsForCustomer
    );

    this.projectGetProjectTokenInvite = client.requestFunctionFactory(
      projectGetProjectTokenInvite
    );

    this.projectCreateProjectInvite = client.requestFunctionFactory(
      projectCreateProjectInvite
    );

    this.projectListInvitesForProject = client.requestFunctionFactory(
      projectListInvitesForProject
    );

    this.customerListCustomerInvites = client.requestFunctionFactory(
      customerListCustomerInvites
    );

    this.customerListCustomerMemberships = client.requestFunctionFactory(
      customerListCustomerMemberships
    );

    this.projectListMembershipsForProject = client.requestFunctionFactory(
      projectListMembershipsForProject
    );

    this.projectListProjectInvites = client.requestFunctionFactory(
      projectListProjectInvites
    );

    this.projectListProjectMemberships = client.requestFunctionFactory(
      projectListProjectMemberships
    );

    this.customerCreateCategory = client.requestFunctionFactory(
      customerCreateCategory
    );

    this.customerListOfCustomerCategories = client.requestFunctionFactory(
      customerListOfCustomerCategories
    );

    this.customerDeleteCategory = client.requestFunctionFactory(
      customerDeleteCategory
    );

    this.customerGetCustomerCategory = client.requestFunctionFactory(
      customerGetCustomerCategory
    );

    this.customerUpdateCategory = client.requestFunctionFactory(
      customerUpdateCategory
    );

    this.appGetAppversion = client.requestFunctionFactory(appGetAppversion);

    this.appListAppversions = client.requestFunctionFactory(appListAppversions);

    this.sftpUserDeleteSftpUser = client.requestFunctionFactory(
      sftpUserDeleteSftpUser
    );

    this.sftpUserGetSftpUser =
      client.requestFunctionFactory(sftpUserGetSftpUser);

    this.sftpUserUpdateSftpUser = client.requestFunctionFactory(
      sftpUserUpdateSftpUser
    );

    this.sshUserDeleteSshUser =
      client.requestFunctionFactory(sshUserDeleteSshUser);

    this.sshUserGetSshUser = client.requestFunctionFactory(sshUserGetSshUser);

    this.sshUserUpdateSshUser =
      client.requestFunctionFactory(sshUserUpdateSshUser);

    this.sftpUserCreateSftpUser = client.requestFunctionFactory(
      sftpUserCreateSftpUser
    );

    this.sftpUserListSftpUsers = client.requestFunctionFactory(
      sftpUserListSftpUsers
    );

    this.sshUserCreateSshUser =
      client.requestFunctionFactory(sshUserCreateSshUser);

    this.sshUserListSshUsers =
      client.requestFunctionFactory(sshUserListSshUsers);

    this.projectGetSelfMembershipForProject = client.requestFunctionFactory(
      projectGetSelfMembershipForProject
    );

    this.orderCreateOrder = client.requestFunctionFactory(orderCreateOrder);

    this.orderListOrders = client.requestFunctionFactory(orderListOrders);

    this.orderCreateTariffChange = client.requestFunctionFactory(
      orderCreateTariffChange
    );

    this.orderPreviewOrder = client.requestFunctionFactory(orderPreviewOrder);

    this.orderPreviewTariffChange = client.requestFunctionFactory(
      orderPreviewTariffChange
    );

    this.relocationCreateLegacyTariffChange = client.requestFunctionFactory(
      relocationCreateLegacyTariffChange
    );

    this.contractGetDetailOfContractByDomain = client.requestFunctionFactory(
      contractGetDetailOfContractByDomain
    );

    this.contractGetDetailOfContractByProject = client.requestFunctionFactory(
      contractGetDetailOfContractByProject
    );

    this.contractGetDetailOfContractByServer = client.requestFunctionFactory(
      contractGetDetailOfContractByServer
    );

    this.appListUpdateCandidatesForAppversion = client.requestFunctionFactory(
      appListUpdateCandidatesForAppversion
    );

    this.userAuthenticateMfa =
      client.requestFunctionFactory(userAuthenticateMfa);

    this.userAuthenticate = client.requestFunctionFactory(userAuthenticate);

    this.userChangeEmail = client.requestFunctionFactory(userChangeEmail);

    this.userGetOwnEmail = client.requestFunctionFactory(userGetOwnEmail);

    this.userChangePassword = client.requestFunctionFactory(userChangePassword);

    this.userCheckToken = client.requestFunctionFactory(userCheckToken);

    this.userConfirmMfa = client.requestFunctionFactory(userConfirmMfa);

    this.userDisableMfa = client.requestFunctionFactory(userDisableMfa);

    this.userGetMfaStatus = client.requestFunctionFactory(userGetMfaStatus);

    this.userResetRecoverycodes = client.requestFunctionFactory(
      userResetRecoverycodes
    );

    this.userConfirmPasswordReset = client.requestFunctionFactory(
      userConfirmPasswordReset
    );

    this.userCreateApiToken = client.requestFunctionFactory(userCreateApiToken);

    this.userListApiTokens = client.requestFunctionFactory(userListApiTokens);

    this.userCreateSshKey = client.requestFunctionFactory(userCreateSshKey);

    this.userListSshKeys = client.requestFunctionFactory(userListSshKeys);

    this.userDeleteApiToken = client.requestFunctionFactory(userDeleteApiToken);

    this.userEditApiToken = client.requestFunctionFactory(userEditApiToken);

    this.userGetApiToken = client.requestFunctionFactory(userGetApiToken);

    this.userDeleteSshKey = client.requestFunctionFactory(userDeleteSshKey);

    this.userEditSshKey = client.requestFunctionFactory(userEditSshKey);

    this.userGetSshKey = client.requestFunctionFactory(userGetSshKey);

    this.userDeleteUser = client.requestFunctionFactory(userDeleteUser);

    this.userUpdateAccount = client.requestFunctionFactory(userUpdateAccount);

    this.userGetPasswordUpdatedAt = client.requestFunctionFactory(
      userGetPasswordUpdatedAt
    );

    this.userGetSession = client.requestFunctionFactory(userGetSession);

    this.userTerminateSession =
      client.requestFunctionFactory(userTerminateSession);

    this.userInitMfa = client.requestFunctionFactory(userInitMfa);

    this.userInitPasswordReset = client.requestFunctionFactory(
      userInitPasswordReset
    );

    this.userListSessions = client.requestFunctionFactory(userListSessions);

    this.userRefreshSession = client.requestFunctionFactory(userRefreshSession);

    this.userTerminateAllSessions = client.requestFunctionFactory(
      userTerminateAllSessions
    );

    this.userLogout = client.requestFunctionFactory(userLogout);

    this.userRegister = client.requestFunctionFactory(userRegister);

    this.userResendVerificationEmail = client.requestFunctionFactory(
      userResendVerificationEmail
    );

    this.userSupportCodeRequest = client.requestFunctionFactory(
      userSupportCodeRequest
    );

    this.userVerifyEmail = client.requestFunctionFactory(userVerifyEmail);

    this.userVerifyRegistration = client.requestFunctionFactory(
      userVerifyRegistration
    );

    this.userAddPhoneNumber = client.requestFunctionFactory(userAddPhoneNumber);

    this.userRemovePhoneNumber = client.requestFunctionFactory(
      userRemovePhoneNumber
    );

    this.userCreateFeedback = client.requestFunctionFactory(userCreateFeedback);

    this.userGetPersonalizedSettings = client.requestFunctionFactory(
      userGetPersonalizedSettings
    );

    this.userUpdatePersonalizedSettings = client.requestFunctionFactory(
      userUpdatePersonalizedSettings
    );

    this.userGetUser = client.requestFunctionFactory(userGetUser);

    this.userUpdatePersonalInformation = client.requestFunctionFactory(
      userUpdatePersonalInformation
    );

    this.userListFeedback = client.requestFunctionFactory(userListFeedback);

    this.userRemoveAvatar = client.requestFunctionFactory(userRemoveAvatar);

    this.userRequestAvatarUpload = client.requestFunctionFactory(
      userRequestAvatarUpload
    );

    this.ingressRequestIngressAcmeCertificateIssuance =
      client.requestFunctionFactory(
        ingressRequestIngressAcmeCertificateIssuance
      );

    this.newsletterGetInfo = client.requestFunctionFactory(newsletterGetInfo);

    this.newsletterUnsubscribeUser = client.requestFunctionFactory(
      newsletterUnsubscribeUser
    );

    this.newsletterSubscribeUser = client.requestFunctionFactory(
      newsletterSubscribeUser
    );

    this.domainCheckDomainRegistrability = client.requestFunctionFactory(
      domainCheckDomainRegistrability
    );

    this.domainListTldContactSchemas = client.requestFunctionFactory(
      domainListTldContactSchemas
    );

    this.dnsCreateDnsZone = client.requestFunctionFactory(dnsCreateDnsZone);

    this.dnsDeleteDnsZone = client.requestFunctionFactory(dnsDeleteDnsZone);

    this.dnsGetDnsZone = client.requestFunctionFactory(dnsGetDnsZone);

    this.dnsListDnsZones = client.requestFunctionFactory(dnsListDnsZones);

    this.dnsSetRecordSetManaged = client.requestFunctionFactory(
      dnsSetRecordSetManaged
    );

    this.dnsUpdateRecordSet = client.requestFunctionFactory(dnsUpdateRecordSet);

    this.domainAbortDomainDeclaration = client.requestFunctionFactory(
      domainAbortDomainDeclaration
    );

    this.domainCreateDomainAuthCode = client.requestFunctionFactory(
      domainCreateDomainAuthCode
    );

    this.domainListTlds = client.requestFunctionFactory(domainListTlds);

    this.domainUpdateDomainAuthCode = client.requestFunctionFactory(
      domainUpdateDomainAuthCode
    );

    this.domainUpdateDomainContact = client.requestFunctionFactory(
      domainUpdateDomainContact
    );

    this.domainUpdateDomainProjectId = client.requestFunctionFactory(
      domainUpdateDomainProjectId
    );

    this.mailCreateDeliverybox = client.requestFunctionFactory(
      mailCreateDeliverybox
    );

    this.mailListDeliveryBoxes = client.requestFunctionFactory(
      mailListDeliveryBoxes
    );

    this.mailCreateMailAddress = client.requestFunctionFactory(
      mailCreateMailAddress
    );

    this.mailListMailAddresses = client.requestFunctionFactory(
      mailListMailAddresses
    );

    this.mailDeleteDeliveryBox = client.requestFunctionFactory(
      mailDeleteDeliveryBox
    );

    this.mailGetDeliveryBox = client.requestFunctionFactory(mailGetDeliveryBox);

    this.mailDeleteMailAddress = client.requestFunctionFactory(
      mailDeleteMailAddress
    );

    this.mailGetMailAddress = client.requestFunctionFactory(mailGetMailAddress);

    this.mailListProjectMailSettings = client.requestFunctionFactory(
      mailListProjectMailSettings
    );

    this.mailUpdateDeliveryBoxDescription = client.requestFunctionFactory(
      mailUpdateDeliveryBoxDescription
    );

    this.mailUpdateDeliveryBoxPassword = client.requestFunctionFactory(
      mailUpdateDeliveryBoxPassword
    );

    this.mailUpdateMailAddressAddress = client.requestFunctionFactory(
      mailUpdateMailAddressAddress
    );

    this.mailUpdateMailAddressAutoresponder = client.requestFunctionFactory(
      mailUpdateMailAddressAutoresponder
    );

    this.mailUpdateMailAddressCatchAll = client.requestFunctionFactory(
      mailUpdateMailAddressCatchAll
    );

    this.mailUpdateMailAddressForwardAddresses = client.requestFunctionFactory(
      mailUpdateMailAddressForwardAddresses
    );

    this.mailUpdateMailAddressPassword = client.requestFunctionFactory(
      mailUpdateMailAddressPassword
    );

    this.mailUpdateMailAddressQuota = client.requestFunctionFactory(
      mailUpdateMailAddressQuota
    );

    this.mailUpdateMailAddressSpamProtection = client.requestFunctionFactory(
      mailUpdateMailAddressSpamProtection
    );

    this.appExecuteAction = client.requestFunctionFactory(appExecuteAction);

    this.appGetAppinstallation = client.requestFunctionFactory(
      appGetAppinstallation
    );

    this.appPatchAppinstallation = client.requestFunctionFactory(
      appPatchAppinstallation
    );

    this.appUninstallAppinstallation = client.requestFunctionFactory(
      appUninstallAppinstallation
    );

    this.appGetMissingDependenciesForAppinstallation =
      client.requestFunctionFactory(
        appGetMissingDependenciesForAppinstallation
      );

    this.appGetSystemsoftware =
      client.requestFunctionFactory(appGetSystemsoftware);

    this.appGetSystemsoftwareversion = client.requestFunctionFactory(
      appGetSystemsoftwareversion
    );

    this.appLinkDatabase = client.requestFunctionFactory(appLinkDatabase);

    this.appListAppinstallations = client.requestFunctionFactory(
      appListAppinstallations
    );

    this.appRequestAppinstallation = client.requestFunctionFactory(
      appRequestAppinstallation
    );

    this.appListSystemsoftwares = client.requestFunctionFactory(
      appListSystemsoftwares
    );

    this.appListSystemsoftwareversions = client.requestFunctionFactory(
      appListSystemsoftwareversions
    );

    this.appRetrieveStatus = client.requestFunctionFactory(appRetrieveStatus);

    this.appUnlinkDatabase = client.requestFunctionFactory(appUnlinkDatabase);

    this.databaseDeleteMysqlDatabase = client.requestFunctionFactory(
      databaseDeleteMysqlDatabase
    );

    this.databaseGetMysqlDatabase = client.requestFunctionFactory(
      databaseGetMysqlDatabase
    );

    this.databaseDeleteMysqlUser = client.requestFunctionFactory(
      databaseDeleteMysqlUser
    );

    this.databaseGetMysqlUser =
      client.requestFunctionFactory(databaseGetMysqlUser);

    this.databaseUpdateMysqlUser = client.requestFunctionFactory(
      databaseUpdateMysqlUser
    );

    this.databaseDeleteRedisDatabase = client.requestFunctionFactory(
      databaseDeleteRedisDatabase
    );

    this.databaseGetRedisDatabase = client.requestFunctionFactory(
      databaseGetRedisDatabase
    );

    this.databaseDisableMysqlUser = client.requestFunctionFactory(
      databaseDisableMysqlUser
    );

    this.databaseEnableMysqlUser = client.requestFunctionFactory(
      databaseEnableMysqlUser
    );

    this.databaseGetMysqlUserPhpMyAdminUrl = client.requestFunctionFactory(
      databaseGetMysqlUserPhpMyAdminUrl
    );

    this.databaseUpdateMysqlDatabaseDefaultCharset =
      client.requestFunctionFactory(databaseUpdateMysqlDatabaseDefaultCharset);

    this.databaseUpdateMysqlDatabaseDescription = client.requestFunctionFactory(
      databaseUpdateMysqlDatabaseDescription
    );

    this.databaseUpdateMysqlUserPassword = client.requestFunctionFactory(
      databaseUpdateMysqlUserPassword
    );

    this.databaseUpdateRedisDatabaseConfiguration =
      client.requestFunctionFactory(databaseUpdateRedisDatabaseConfiguration);

    this.databaseUpdateRedisDatabaseDescription = client.requestFunctionFactory(
      databaseUpdateRedisDatabaseDescription
    );

    this.fileGetFileMeta = client.requestFunctionFactory(fileGetFileMeta);

    this.fileGetFile = client.requestFunctionFactory(fileGetFile);

    this.pageinsightsGetPerformanceData = client.requestFunctionFactory(
      pageinsightsGetPerformanceData
    );

    this.pageinsightsListPerformanceDataForProject =
      client.requestFunctionFactory(pageinsightsListPerformanceDataForProject);

    this.projectFileSystemGetDirectories = client.requestFunctionFactory(
      projectFileSystemGetDirectories
    );

    this.projectFileSystemGetDiskUsage = client.requestFunctionFactory(
      projectFileSystemGetDiskUsage
    );

    this.projectFileSystemGetFileContent = client.requestFunctionFactory(
      projectFileSystemGetFileContent
    );

    this.projectFileSystemListFiles = client.requestFunctionFactory(
      projectFileSystemListFiles
    );

    this.projectUpdateProjectDescription = client.requestFunctionFactory(
      projectUpdateProjectDescription
    );

    this.fileGetFileUploadTokenRules = client.requestFunctionFactory(
      fileGetFileUploadTokenRules
    );

    this.fileGetFileUploadTypeRules = client.requestFunctionFactory(
      fileGetFileUploadTypeRules
    );

    this.conversationGetConversationMembers = client.requestFunctionFactory(
      conversationGetConversationMembers
    );

    this.conversationGetFileAccessToken = client.requestFunctionFactory(
      conversationGetFileAccessToken
    );

    this.invoiceGetFileAccessToken = client.requestFunctionFactory(
      invoiceGetFileAccessToken
    );

    this.pageinsightsGetStraceData = client.requestFunctionFactory(
      pageinsightsGetStraceData
    );

    this.pageinsightsScheduleStrace = client.requestFunctionFactory(
      pageinsightsScheduleStrace
    );

    this.userAuthenticateWithAccessTokenRetrievalKey =
      client.requestFunctionFactory(
        userAuthenticateWithAccessTokenRetrievalKey
      );

    this.databaseCreateMysqlUser = client.requestFunctionFactory(
      databaseCreateMysqlUser
    );

    this.databaseListMysqlUsers = client.requestFunctionFactory(
      databaseListMysqlUsers
    );

    this.ingressIngressVerifyOwnership = client.requestFunctionFactory(
      ingressIngressVerifyOwnership
    );

    this.mailUpdateProjectMailSetting = client.requestFunctionFactory(
      mailUpdateProjectMailSetting
    );

    this.customerAcceptCustomerInvite = client.requestFunctionFactory(
      customerAcceptCustomerInvite
    );

    this.customerDeclineCustomerInvite = client.requestFunctionFactory(
      customerDeclineCustomerInvite
    );

    this.customerDeleteCustomerInvite = client.requestFunctionFactory(
      customerDeleteCustomerInvite
    );

    this.customerGetCustomerInvite = client.requestFunctionFactory(
      customerGetCustomerInvite
    );

    this.customerDeleteCustomerMembership = client.requestFunctionFactory(
      customerDeleteCustomerMembership
    );

    this.customerGetCustomerMembership = client.requestFunctionFactory(
      customerGetCustomerMembership
    );

    this.customerUpdateCustomerMembership = client.requestFunctionFactory(
      customerUpdateCustomerMembership
    );

    this.customerResendCustomerInviteMail = client.requestFunctionFactory(
      customerResendCustomerInviteMail
    );

    this.projectAcceptProjectInvite = client.requestFunctionFactory(
      projectAcceptProjectInvite
    );

    this.projectDeclineProjectInvite = client.requestFunctionFactory(
      projectDeclineProjectInvite
    );

    this.projectDeleteProjectInvite = client.requestFunctionFactory(
      projectDeleteProjectInvite
    );

    this.projectGetProjectInvite = client.requestFunctionFactory(
      projectGetProjectInvite
    );

    this.projectDeleteProjectMembership = client.requestFunctionFactory(
      projectDeleteProjectMembership
    );

    this.projectGetProjectMembership = client.requestFunctionFactory(
      projectGetProjectMembership
    );

    this.projectUpdateProjectMembership = client.requestFunctionFactory(
      projectUpdateProjectMembership
    );

    this.projectResendProjectInviteMail = client.requestFunctionFactory(
      projectResendProjectInviteMail
    );

    this.appGetInstalledSystemsoftwareForAppinstallation =
      client.requestFunctionFactory(
        appGetInstalledSystemsoftwareForAppinstallation
      );

    this.invoiceDetail = client.requestFunctionFactory(invoiceDetail);

    this.appRequestAppinstallationCopy = client.requestFunctionFactory(
      appRequestAppinstallationCopy
    );

    this.appSetDatabaseUsers =
      client.requestFunctionFactory(appSetDatabaseUsers);

    this.extensionAuthenticateInstance = client.requestFunctionFactory(
      extensionAuthenticateInstance
    );

    this.extensionConsentToExtensionScopes = client.requestFunctionFactory(
      extensionConsentToExtensionScopes
    );

    this.extensionCreateExtensionInstance = client.requestFunctionFactory(
      extensionCreateExtensionInstance
    );

    this.extensionListExtensionInstances = client.requestFunctionFactory(
      extensionListExtensionInstances
    );

    this.extensionDeleteExtensionInstance = client.requestFunctionFactory(
      extensionDeleteExtensionInstance
    );

    this.extensionGetExtensionInstance = client.requestFunctionFactory(
      extensionGetExtensionInstance
    );

    this.extensionDisableExtensionInstance = client.requestFunctionFactory(
      extensionDisableExtensionInstance
    );

    this.extensionEnableExtensionInstance = client.requestFunctionFactory(
      extensionEnableExtensionInstance
    );

    this.extensionGetContributor = client.requestFunctionFactory(
      extensionGetContributor
    );

    this.extensionGetExtension = client.requestFunctionFactory(
      extensionGetExtension
    );

    this.extensionListContributors = client.requestFunctionFactory(
      extensionListContributors
    );

    this.extensionListExtensions = client.requestFunctionFactory(
      extensionListExtensions
    );

    this.userOauthGetAuthorization = client.requestFunctionFactory(
      userOauthGetAuthorization
    );

    this.userOauthRetrieveAccessToken = client.requestFunctionFactory(
      userOauthRetrieveAccessToken
    );

    this.userVerifyPhoneNumber = client.requestFunctionFactory(
      userVerifyPhoneNumber
    );

    this.notificationsCountUnreadNotifications = client.requestFunctionFactory(
      notificationsCountUnreadNotifications
    );

    this.fileGetFileWithName =
      client.requestFunctionFactory(fileGetFileWithName);

    this.domainCheckDomainTransferability = client.requestFunctionFactory(
      domainCheckDomainTransferability
    );

    this.appListAppinstallationsForUser = client.requestFunctionFactory(
      appListAppinstallationsForUser
    );

    this.domainGetLatestScreenshot = client.requestFunctionFactory(
      domainGetLatestScreenshot
    );

    this.extensionGetPublicKey = client.requestFunctionFactory(
      extensionGetPublicKey
    );

    this.notificationsReadAllNotifications = client.requestFunctionFactory(
      notificationsReadAllNotifications
    );

    this.notificationsReadNotification = client.requestFunctionFactory(
      notificationsReadNotification
    );

    this.userGetPollStatus = client.requestFunctionFactory(userGetPollStatus);

    this.userPostPollStatus = client.requestFunctionFactory(userPostPollStatus);

    this.containerValidateContainerRegistryUri = client.requestFunctionFactory(
      containerValidateContainerRegistryUri
    );

    this.containerDeleteRegistry = client.requestFunctionFactory(
      containerDeleteRegistry
    );

    this.containerGetRegistry =
      client.requestFunctionFactory(containerGetRegistry);

    this.containerUpdateRegistry = client.requestFunctionFactory(
      containerUpdateRegistry
    );

    this.containerGetContainerImageConfig = client.requestFunctionFactory(
      containerGetContainerImageConfig
    );

    this.containerCreateRegistry = client.requestFunctionFactory(
      containerCreateRegistry
    );

    this.containerListRegistries = client.requestFunctionFactory(
      containerListRegistries
    );

    this.containerValidateRegistryCredentials = client.requestFunctionFactory(
      containerValidateRegistryCredentials
    );

    this.containerDeleteVolume = client.requestFunctionFactory(
      containerDeleteVolume
    );

    this.containerGetVolume = client.requestFunctionFactory(containerGetVolume);

    this.containerGetServiceLogs = client.requestFunctionFactory(
      containerGetServiceLogs
    );

    this.containerGetService =
      client.requestFunctionFactory(containerGetService);

    this.containerListServices = client.requestFunctionFactory(
      containerListServices
    );

    this.containerListStacks =
      client.requestFunctionFactory(containerListStacks);

    this.containerListVolumes =
      client.requestFunctionFactory(containerListVolumes);

    this.containerDeclareStack = client.requestFunctionFactory(
      containerDeclareStack
    );

    this.containerGetStack = client.requestFunctionFactory(containerGetStack);

    this.containerUpdateStack =
      client.requestFunctionFactory(containerUpdateStack);

    this.containerRecreateService = client.requestFunctionFactory(
      containerRecreateService
    );

    this.containerRestartService = client.requestFunctionFactory(
      containerRestartService
    );

    this.containerStartService = client.requestFunctionFactory(
      containerStartService
    );

    this.containerStopService =
      client.requestFunctionFactory(containerStopService);

    this.extensionCreateRetrievalKey = client.requestFunctionFactory(
      extensionCreateRetrievalKey
    );

    this.contributorRotateSecretForExtensionInstance =
      client.requestFunctionFactory(
        contributorRotateSecretForExtensionInstance
      );

    this.domainSuggest = client.requestFunctionFactory(domainSuggest);

    this.appReplaceDatabase = client.requestFunctionFactory(appReplaceDatabase);

    this.contractGetDetailOfContractByCertificate =
      client.requestFunctionFactory(contractGetDetailOfContractByCertificate);

    this.ingressListIngressesCompatibleWithCertificate =
      client.requestFunctionFactory(
        ingressListIngressesCompatibleWithCertificate
      );

    this.sslCheckReplaceCertificate = client.requestFunctionFactory(
      sslCheckReplaceCertificate
    );

    this.sslCreateCertificateRequest = client.requestFunctionFactory(
      sslCreateCertificateRequest
    );

    this.sslListCertificateRequests = client.requestFunctionFactory(
      sslListCertificateRequests
    );

    this.sslDeleteCertificateRequest = client.requestFunctionFactory(
      sslDeleteCertificateRequest
    );

    this.sslDeleteCertificate =
      client.requestFunctionFactory(sslDeleteCertificate);

    this.sslGetCertificateRequest = client.requestFunctionFactory(
      sslGetCertificateRequest
    );

    this.sslGetCertificate = client.requestFunctionFactory(sslGetCertificate);

    this.sslReplaceCertificate = client.requestFunctionFactory(
      sslReplaceCertificate
    );

    this.sslListCertificates =
      client.requestFunctionFactory(sslListCertificates);

    this.sslSetCertificateRequestCertificate = client.requestFunctionFactory(
      sslSetCertificateRequestCertificate
    );

    this.extensionDryRunWebhook = client.requestFunctionFactory(
      extensionDryRunWebhook
    );

    this.storagespaceReplaceProjectNotificationThreshold =
      client.requestFunctionFactory(
        storagespaceReplaceProjectNotificationThreshold
      );

    this.storagespaceGetProjectStatistics = client.requestFunctionFactory(
      storagespaceGetProjectStatistics
    );

    this.storagespaceGetServerStatistics = client.requestFunctionFactory(
      storagespaceGetServerStatistics
    );

    this.storagespaceReplaceServerNotificationThreshold =
      client.requestFunctionFactory(
        storagespaceReplaceServerNotificationThreshold
      );

    this.cronjobAbortExecution = client.requestFunctionFactory(
      cronjobAbortExecution
    );

    this.extensionGetExtensionInstanceForCustomer =
      client.requestFunctionFactory(extensionGetExtensionInstanceForCustomer);

    this.extensionGetExtensionInstanceForProject =
      client.requestFunctionFactory(extensionGetExtensionInstanceForProject);

    this.extensionListOwnExtensions = client.requestFunctionFactory(
      extensionListOwnExtensions
    );

    this.extensionRegisterExtension = client.requestFunctionFactory(
      extensionRegisterExtension
    );

    this.extensionDeleteExtension = client.requestFunctionFactory(
      extensionDeleteExtension
    );

    this.extensionGetOwnExtension = client.requestFunctionFactory(
      extensionGetOwnExtension
    );

    this.extensionPatchExtension = client.requestFunctionFactory(
      extensionPatchExtension
    );

    this.leadfyndrGetLead = client.requestFunctionFactory(leadfyndrGetLead);

    this.leadfyndrGetUnlockedLead = client.requestFunctionFactory(
      leadfyndrGetUnlockedLead
    );

    this.leadfyndrUnlockLead =
      client.requestFunctionFactory(leadfyndrUnlockLead);

    this.leadfyndrListLeads = client.requestFunctionFactory(leadfyndrListLeads);

    this.leadfyndrListUnlockedLeads = client.requestFunctionFactory(
      leadfyndrListUnlockedLeads
    );

    this.extensionGenerateSessionToken = client.requestFunctionFactory(
      extensionGenerateSessionToken
    );

    this.customerCreateRecommendationSuggestion = client.requestFunctionFactory(
      customerCreateRecommendationSuggestion
    );

    this.customerCreateWallet =
      client.requestFunctionFactory(customerCreateWallet);

    this.customerGetWallet = client.requestFunctionFactory(customerGetWallet);

    this.containerPullImageForService = client.requestFunctionFactory(
      containerPullImageForService
    );

    this.leadfyndrRemoveUnlockedLeadReservation = client.requestFunctionFactory(
      leadfyndrRemoveUnlockedLeadReservation
    );

    this.leadfyndrReserveUnlockedLead = client.requestFunctionFactory(
      leadfyndrReserveUnlockedLead
    );

    this.extensionStartExtensionCheckout = client.requestFunctionFactory(
      extensionStartExtensionCheckout
    );

    this.extensionCancelExtensionTermination = client.requestFunctionFactory(
      extensionCancelExtensionTermination
    );

    this.extensionScheduleExtensionTermination = client.requestFunctionFactory(
      extensionScheduleExtensionTermination
    );

    this.contributorGetBillingInformation = client.requestFunctionFactory(
      contributorGetBillingInformation
    );

    this.contributorGetLoginLink = client.requestFunctionFactory(
      contributorGetLoginLink
    );

    this.contributorListIncomingInvoices = client.requestFunctionFactory(
      contributorListIncomingInvoices
    );

    this.contributorListOnbehalfInvoices = client.requestFunctionFactory(
      contributorListOnbehalfInvoices
    );

    this.contributorReceiptGetFileAccessToken = client.requestFunctionFactory(
      contributorReceiptGetFileAccessToken
    );

    this.extensionChangeContext = client.requestFunctionFactory(
      extensionChangeContext
    );

    this.extensionCreateContributorOnboardingProcess =
      client.requestFunctionFactory(
        extensionCreateContributorOnboardingProcess
      );

    this.extensionRemoveAsset =
      client.requestFunctionFactory(extensionRemoveAsset);

    this.extensionRemoveLogo =
      client.requestFunctionFactory(extensionRemoveLogo);

    this.extensionRequestLogoUpload = client.requestFunctionFactory(
      extensionRequestLogoUpload
    );

    this.extensionRequestAssetUpload = client.requestFunctionFactory(
      extensionRequestAssetUpload
    );

    this.extensionRequestExtensionVerification = client.requestFunctionFactory(
      extensionRequestExtensionVerification
    );

    this.extensionSetExtensionPublishedState = client.requestFunctionFactory(
      extensionSetExtensionPublishedState
    );

    this.extensionGetExtensionInstanceContract = client.requestFunctionFactory(
      extensionGetExtensionInstanceContract
    );

    this.extensionUpdateExtensionInstanceContract =
      client.requestFunctionFactory(extensionUpdateExtensionInstanceContract);

    this.extensionUpdateExtensionPricing = client.requestFunctionFactory(
      extensionUpdateExtensionPricing
    );

    this.contributorGetCustomerBillingPortalLink =
      client.requestFunctionFactory(contributorGetCustomerBillingPortalLink);

    this.marketplaceCustomerUpdatePaymentMethod = client.requestFunctionFactory(
      marketplaceCustomerUpdatePaymentMethod
    );

    this.marketplaceCustomerGetPaymentMethod = client.requestFunctionFactory(
      marketplaceCustomerGetPaymentMethod
    );

    this.extensionOrderExtension = client.requestFunctionFactory(
      extensionOrderExtension
    );

    this.extensionGetCustomerExtensionInstanceOrders =
      client.requestFunctionFactory(
        extensionGetCustomerExtensionInstanceOrders
      );

    this.extensionGetProjectExtensionInstanceOrders =
      client.requestFunctionFactory(extensionGetProjectExtensionInstanceOrders);

    this.leadfyndrGetLeadFyndrProfileRequest = client.requestFunctionFactory(
      leadfyndrGetLeadFyndrProfileRequest
    );

    this.leadfyndrCreateLeadFyndrAccessRequest = client.requestFunctionFactory(
      leadfyndrCreateLeadFyndrAccessRequest
    );

    this.leadfyndrGetLeadFyndrProfile = client.requestFunctionFactory(
      leadfyndrGetLeadFyndrProfile
    );

    this.leadfyndrGetLeadFyndrProfileTariffOptions =
      client.requestFunctionFactory(leadfyndrGetLeadFyndrProfileTariffOptions);
  }
}

/**
 * ====================================
 * API
 * ====================================
 */

import { createGetApiOperationResource } from "@mittwald/flow-lib/dist/resources/ApiOperationResource/createGetApiOperationResource";

export const mittwaldApi = {
  contractGetDetailOfContract: {
    getResource: createGetApiOperationResource(
      contractGetDetailOfContract,
      MittwaldApiClient.getInstance().contractGetDetailOfContract
    ),

    request: MittwaldApiClient.getInstance().contractGetDetailOfContract,
    descriptor: contractGetDetailOfContract,
  },

  contractCancelContractItemTermination: {
    getResource: createGetApiOperationResource(
      contractCancelContractItemTermination,
      MittwaldApiClient.getInstance().contractCancelContractItemTermination
    ),

    request:
      MittwaldApiClient.getInstance().contractCancelContractItemTermination,
    descriptor: contractCancelContractItemTermination,
  },

  contractTerminateContractItem: {
    getResource: createGetApiOperationResource(
      contractTerminateContractItem,
      MittwaldApiClient.getInstance().contractTerminateContractItem
    ),

    request: MittwaldApiClient.getInstance().contractTerminateContractItem,
    descriptor: contractTerminateContractItem,
  },

  contractCancelContractTermination: {
    getResource: createGetApiOperationResource(
      contractCancelContractTermination,
      MittwaldApiClient.getInstance().contractCancelContractTermination
    ),

    request: MittwaldApiClient.getInstance().contractCancelContractTermination,
    descriptor: contractCancelContractTermination,
  },

  contractTerminateContract: {
    getResource: createGetApiOperationResource(
      contractTerminateContract,
      MittwaldApiClient.getInstance().contractTerminateContract
    ),

    request: MittwaldApiClient.getInstance().contractTerminateContract,
    descriptor: contractTerminateContract,
  },

  contractGetDetailOfContractItem: {
    getResource: createGetApiOperationResource(
      contractGetDetailOfContractItem,
      MittwaldApiClient.getInstance().contractGetDetailOfContractItem
    ),

    request: MittwaldApiClient.getInstance().contractGetDetailOfContractItem,
    descriptor: contractGetDetailOfContractItem,
  },

  contractListContracts: {
    getResource: createGetApiOperationResource(
      contractListContracts,
      MittwaldApiClient.getInstance().contractListContracts
    ),

    request: MittwaldApiClient.getInstance().contractListContracts,
    descriptor: contractListContracts,
  },

  cronjobCreateCronjob: {
    getResource: createGetApiOperationResource(
      cronjobCreateCronjob,
      MittwaldApiClient.getInstance().cronjobCreateCronjob
    ),

    request: MittwaldApiClient.getInstance().cronjobCreateCronjob,
    descriptor: cronjobCreateCronjob,
  },

  cronjobListCronjobs: {
    getResource: createGetApiOperationResource(
      cronjobListCronjobs,
      MittwaldApiClient.getInstance().cronjobListCronjobs
    ),

    request: MittwaldApiClient.getInstance().cronjobListCronjobs,
    descriptor: cronjobListCronjobs,
  },

  cronjobCreateExecution: {
    getResource: createGetApiOperationResource(
      cronjobCreateExecution,
      MittwaldApiClient.getInstance().cronjobCreateExecution
    ),

    request: MittwaldApiClient.getInstance().cronjobCreateExecution,
    descriptor: cronjobCreateExecution,
  },

  cronjobListExecutions: {
    getResource: createGetApiOperationResource(
      cronjobListExecutions,
      MittwaldApiClient.getInstance().cronjobListExecutions
    ),

    request: MittwaldApiClient.getInstance().cronjobListExecutions,
    descriptor: cronjobListExecutions,
  },

  cronjobDeleteCronjob: {
    getResource: createGetApiOperationResource(
      cronjobDeleteCronjob,
      MittwaldApiClient.getInstance().cronjobDeleteCronjob
    ),

    request: MittwaldApiClient.getInstance().cronjobDeleteCronjob,
    descriptor: cronjobDeleteCronjob,
  },

  cronjobGetCronjob: {
    getResource: createGetApiOperationResource(
      cronjobGetCronjob,
      MittwaldApiClient.getInstance().cronjobGetCronjob
    ),

    request: MittwaldApiClient.getInstance().cronjobGetCronjob,
    descriptor: cronjobGetCronjob,
  },

  cronjobUpdateCronjob: {
    getResource: createGetApiOperationResource(
      cronjobUpdateCronjob,
      MittwaldApiClient.getInstance().cronjobUpdateCronjob
    ),

    request: MittwaldApiClient.getInstance().cronjobUpdateCronjob,
    descriptor: cronjobUpdateCronjob,
  },

  cronjobGetExecution: {
    getResource: createGetApiOperationResource(
      cronjobGetExecution,
      MittwaldApiClient.getInstance().cronjobGetExecution
    ),

    request: MittwaldApiClient.getInstance().cronjobGetExecution,
    descriptor: cronjobGetExecution,
  },

  customerRemoveAvatar: {
    getResource: createGetApiOperationResource(
      customerRemoveAvatar,
      MittwaldApiClient.getInstance().customerRemoveAvatar
    ),

    request: MittwaldApiClient.getInstance().customerRemoveAvatar,
    descriptor: customerRemoveAvatar,
  },

  customerRequestAvatarUpload: {
    getResource: createGetApiOperationResource(
      customerRequestAvatarUpload,
      MittwaldApiClient.getInstance().customerRequestAvatarUpload
    ),

    request: MittwaldApiClient.getInstance().customerRequestAvatarUpload,
    descriptor: customerRequestAvatarUpload,
  },

  customerCreateCustomer: {
    getResource: createGetApiOperationResource(
      customerCreateCustomer,
      MittwaldApiClient.getInstance().customerCreateCustomer
    ),

    request: MittwaldApiClient.getInstance().customerCreateCustomer,
    descriptor: customerCreateCustomer,
  },

  customerListCustomers: {
    getResource: createGetApiOperationResource(
      customerListCustomers,
      MittwaldApiClient.getInstance().customerListCustomers
    ),

    request: MittwaldApiClient.getInstance().customerListCustomers,
    descriptor: customerListCustomers,
  },

  customerDeleteCustomer: {
    getResource: createGetApiOperationResource(
      customerDeleteCustomer,
      MittwaldApiClient.getInstance().customerDeleteCustomer
    ),

    request: MittwaldApiClient.getInstance().customerDeleteCustomer,
    descriptor: customerDeleteCustomer,
  },

  customerGetCustomer: {
    getResource: createGetApiOperationResource(
      customerGetCustomer,
      MittwaldApiClient.getInstance().customerGetCustomer
    ),

    request: MittwaldApiClient.getInstance().customerGetCustomer,
    descriptor: customerGetCustomer,
  },

  customerUpdateCustomer: {
    getResource: createGetApiOperationResource(
      customerUpdateCustomer,
      MittwaldApiClient.getInstance().customerUpdateCustomer
    ),

    request: MittwaldApiClient.getInstance().customerUpdateCustomer,
    descriptor: customerUpdateCustomer,
  },

  databaseListMysqlCharsets: {
    getResource: createGetApiOperationResource(
      databaseListMysqlCharsets,
      MittwaldApiClient.getInstance().databaseListMysqlCharsets
    ),

    request: MittwaldApiClient.getInstance().databaseListMysqlCharsets,
    descriptor: databaseListMysqlCharsets,
  },

  ingressDeleteIngress: {
    getResource: createGetApiOperationResource(
      ingressDeleteIngress,
      MittwaldApiClient.getInstance().ingressDeleteIngress
    ),

    request: MittwaldApiClient.getInstance().ingressDeleteIngress,
    descriptor: ingressDeleteIngress,
  },

  ingressGetIngress: {
    getResource: createGetApiOperationResource(
      ingressGetIngress,
      MittwaldApiClient.getInstance().ingressGetIngress
    ),

    request: MittwaldApiClient.getInstance().ingressGetIngress,
    descriptor: ingressGetIngress,
  },

  ingressCreateIngress: {
    getResource: createGetApiOperationResource(
      ingressCreateIngress,
      MittwaldApiClient.getInstance().ingressCreateIngress
    ),

    request: MittwaldApiClient.getInstance().ingressCreateIngress,
    descriptor: ingressCreateIngress,
  },

  ingressListIngresses: {
    getResource: createGetApiOperationResource(
      ingressListIngresses,
      MittwaldApiClient.getInstance().ingressListIngresses
    ),

    request: MittwaldApiClient.getInstance().ingressListIngresses,
    descriptor: ingressListIngresses,
  },

  ingressUpdateIngressPaths: {
    getResource: createGetApiOperationResource(
      ingressUpdateIngressPaths,
      MittwaldApiClient.getInstance().ingressUpdateIngressPaths
    ),

    request: MittwaldApiClient.getInstance().ingressUpdateIngressPaths,
    descriptor: ingressUpdateIngressPaths,
  },

  ingressUpdateIngressTls: {
    getResource: createGetApiOperationResource(
      ingressUpdateIngressTls,
      MittwaldApiClient.getInstance().ingressUpdateIngressTls
    ),

    request: MittwaldApiClient.getInstance().ingressUpdateIngressTls,
    descriptor: ingressUpdateIngressTls,
  },

  invoiceListCustomerInvoices: {
    getResource: createGetApiOperationResource(
      invoiceListCustomerInvoices,
      MittwaldApiClient.getInstance().invoiceListCustomerInvoices
    ),

    request: MittwaldApiClient.getInstance().invoiceListCustomerInvoices,
    descriptor: invoiceListCustomerInvoices,
  },

  projectFileSystemGetJwt: {
    getResource: createGetApiOperationResource(
      projectFileSystemGetJwt,
      MittwaldApiClient.getInstance().projectFileSystemGetJwt
    ),

    request: MittwaldApiClient.getInstance().projectFileSystemGetJwt,
    descriptor: projectFileSystemGetJwt,
  },

  projectListProjects: {
    getResource: createGetApiOperationResource(
      projectListProjects,
      MittwaldApiClient.getInstance().projectListProjects
    ),

    request: MittwaldApiClient.getInstance().projectListProjects,
    descriptor: projectListProjects,
  },

  orderListCustomerOrders: {
    getResource: createGetApiOperationResource(
      orderListCustomerOrders,
      MittwaldApiClient.getInstance().orderListCustomerOrders
    ),

    request: MittwaldApiClient.getInstance().orderListCustomerOrders,
    descriptor: orderListCustomerOrders,
  },

  appGetApp: {
    getResource: createGetApiOperationResource(
      appGetApp,
      MittwaldApiClient.getInstance().appGetApp
    ),

    request: MittwaldApiClient.getInstance().appGetApp,
    descriptor: appGetApp,
  },

  appListApps: {
    getResource: createGetApiOperationResource(
      appListApps,
      MittwaldApiClient.getInstance().appListApps
    ),

    request: MittwaldApiClient.getInstance().appListApps,
    descriptor: appListApps,
  },

  conversationCreateConversation: {
    getResource: createGetApiOperationResource(
      conversationCreateConversation,
      MittwaldApiClient.getInstance().conversationCreateConversation
    ),

    request: MittwaldApiClient.getInstance().conversationCreateConversation,
    descriptor: conversationCreateConversation,
  },

  conversationListConversations: {
    getResource: createGetApiOperationResource(
      conversationListConversations,
      MittwaldApiClient.getInstance().conversationListConversations
    ),

    request: MittwaldApiClient.getInstance().conversationListConversations,
    descriptor: conversationListConversations,
  },

  conversationCreateMessage: {
    getResource: createGetApiOperationResource(
      conversationCreateMessage,
      MittwaldApiClient.getInstance().conversationCreateMessage
    ),

    request: MittwaldApiClient.getInstance().conversationCreateMessage,
    descriptor: conversationCreateMessage,
  },

  conversationListMessagesByConversation: {
    getResource: createGetApiOperationResource(
      conversationListMessagesByConversation,
      MittwaldApiClient.getInstance().conversationListMessagesByConversation
    ),

    request:
      MittwaldApiClient.getInstance().conversationListMessagesByConversation,
    descriptor: conversationListMessagesByConversation,
  },

  conversationGetConversation: {
    getResource: createGetApiOperationResource(
      conversationGetConversation,
      MittwaldApiClient.getInstance().conversationGetConversation
    ),

    request: MittwaldApiClient.getInstance().conversationGetConversation,
    descriptor: conversationGetConversation,
  },

  conversationUpdateConversation: {
    getResource: createGetApiOperationResource(
      conversationUpdateConversation,
      MittwaldApiClient.getInstance().conversationUpdateConversation
    ),

    request: MittwaldApiClient.getInstance().conversationUpdateConversation,
    descriptor: conversationUpdateConversation,
  },

  conversationUpdateMessage: {
    getResource: createGetApiOperationResource(
      conversationUpdateMessage,
      MittwaldApiClient.getInstance().conversationUpdateMessage
    ),

    request: MittwaldApiClient.getInstance().conversationUpdateMessage,
    descriptor: conversationUpdateMessage,
  },

  projectDeleteProject: {
    getResource: createGetApiOperationResource(
      projectDeleteProject,
      MittwaldApiClient.getInstance().projectDeleteProject
    ),

    request: MittwaldApiClient.getInstance().projectDeleteProject,
    descriptor: projectDeleteProject,
  },

  projectGetProject: {
    getResource: createGetApiOperationResource(
      projectGetProject,
      MittwaldApiClient.getInstance().projectGetProject
    ),

    request: MittwaldApiClient.getInstance().projectGetProject,
    descriptor: projectGetProject,
  },

  articleGetArticle: {
    getResource: createGetApiOperationResource(
      articleGetArticle,
      MittwaldApiClient.getInstance().articleGetArticle
    ),

    request: MittwaldApiClient.getInstance().articleGetArticle,
    descriptor: articleGetArticle,
  },

  articleListArticles: {
    getResource: createGetApiOperationResource(
      articleListArticles,
      MittwaldApiClient.getInstance().articleListArticles
    ),

    request: MittwaldApiClient.getInstance().articleListArticles,
    descriptor: articleListArticles,
  },

  projectDeleteProjectAvatar: {
    getResource: createGetApiOperationResource(
      projectDeleteProjectAvatar,
      MittwaldApiClient.getInstance().projectDeleteProjectAvatar
    ),

    request: MittwaldApiClient.getInstance().projectDeleteProjectAvatar,
    descriptor: projectDeleteProjectAvatar,
  },

  projectRequestProjectAvatarUpload: {
    getResource: createGetApiOperationResource(
      projectRequestProjectAvatarUpload,
      MittwaldApiClient.getInstance().projectRequestProjectAvatarUpload
    ),

    request: MittwaldApiClient.getInstance().projectRequestProjectAvatarUpload,
    descriptor: projectRequestProjectAvatarUpload,
  },

  customerIsCustomerLegallyCompetent: {
    getResource: createGetApiOperationResource(
      customerIsCustomerLegallyCompetent,
      MittwaldApiClient.getInstance().customerIsCustomerLegallyCompetent
    ),

    request: MittwaldApiClient.getInstance().customerIsCustomerLegallyCompetent,
    descriptor: customerIsCustomerLegallyCompetent,
  },

  conversationListCategories: {
    getResource: createGetApiOperationResource(
      conversationListCategories,
      MittwaldApiClient.getInstance().conversationListCategories
    ),

    request: MittwaldApiClient.getInstance().conversationListCategories,
    descriptor: conversationListCategories,
  },

  conversationGetCategory: {
    getResource: createGetApiOperationResource(
      conversationGetCategory,
      MittwaldApiClient.getInstance().conversationGetCategory
    ),

    request: MittwaldApiClient.getInstance().conversationGetCategory,
    descriptor: conversationGetCategory,
  },

  contractCancelContractTariffChange: {
    getResource: createGetApiOperationResource(
      contractCancelContractTariffChange,
      MittwaldApiClient.getInstance().contractCancelContractTariffChange
    ),

    request: MittwaldApiClient.getInstance().contractCancelContractTariffChange,
    descriptor: contractCancelContractTariffChange,
  },

  conversationSetConversationStatus: {
    getResource: createGetApiOperationResource(
      conversationSetConversationStatus,
      MittwaldApiClient.getInstance().conversationSetConversationStatus
    ),

    request: MittwaldApiClient.getInstance().conversationSetConversationStatus,
    descriptor: conversationSetConversationStatus,
  },

  notificationsListNotifications: {
    getResource: createGetApiOperationResource(
      notificationsListNotifications,
      MittwaldApiClient.getInstance().notificationsListNotifications
    ),

    request: MittwaldApiClient.getInstance().notificationsListNotifications,
    descriptor: notificationsListNotifications,
  },

  orderGetOrder: {
    getResource: createGetApiOperationResource(
      orderGetOrder,
      MittwaldApiClient.getInstance().orderGetOrder
    ),

    request: MittwaldApiClient.getInstance().orderGetOrder,
    descriptor: orderGetOrder,
  },

  domainListDomains: {
    getResource: createGetApiOperationResource(
      domainListDomains,
      MittwaldApiClient.getInstance().domainListDomains
    ),

    request: MittwaldApiClient.getInstance().domainListDomains,
    descriptor: domainListDomains,
  },

  domainUpdateDomainNameservers: {
    getResource: createGetApiOperationResource(
      domainUpdateDomainNameservers,
      MittwaldApiClient.getInstance().domainUpdateDomainNameservers
    ),

    request: MittwaldApiClient.getInstance().domainUpdateDomainNameservers,
    descriptor: domainUpdateDomainNameservers,
  },

  domainDeleteDomain: {
    getResource: createGetApiOperationResource(
      domainDeleteDomain,
      MittwaldApiClient.getInstance().domainDeleteDomain
    ),

    request: MittwaldApiClient.getInstance().domainDeleteDomain,
    descriptor: domainDeleteDomain,
  },

  domainGetDomain: {
    getResource: createGetApiOperationResource(
      domainGetDomain,
      MittwaldApiClient.getInstance().domainGetDomain
    ),

    request: MittwaldApiClient.getInstance().domainGetDomain,
    descriptor: domainGetDomain,
  },

  conversationRequestFileUpload: {
    getResource: createGetApiOperationResource(
      conversationRequestFileUpload,
      MittwaldApiClient.getInstance().conversationRequestFileUpload
    ),

    request: MittwaldApiClient.getInstance().conversationRequestFileUpload,
    descriptor: conversationRequestFileUpload,
  },

  domainResendDomainEmail: {
    getResource: createGetApiOperationResource(
      domainResendDomainEmail,
      MittwaldApiClient.getInstance().domainResendDomainEmail
    ),

    request: MittwaldApiClient.getInstance().domainResendDomainEmail,
    descriptor: domainResendDomainEmail,
  },

  relocationCreateRelocation: {
    getResource: createGetApiOperationResource(
      relocationCreateRelocation,
      MittwaldApiClient.getInstance().relocationCreateRelocation
    ),

    request: MittwaldApiClient.getInstance().relocationCreateRelocation,
    descriptor: relocationCreateRelocation,
  },

  orderListProjectOrders: {
    getResource: createGetApiOperationResource(
      orderListProjectOrders,
      MittwaldApiClient.getInstance().orderListProjectOrders
    ),

    request: MittwaldApiClient.getInstance().orderListProjectOrders,
    descriptor: orderListProjectOrders,
  },

  invoiceGetDetailOfInvoiceSettings: {
    getResource: createGetApiOperationResource(
      invoiceGetDetailOfInvoiceSettings,
      MittwaldApiClient.getInstance().invoiceGetDetailOfInvoiceSettings
    ),

    request: MittwaldApiClient.getInstance().invoiceGetDetailOfInvoiceSettings,
    descriptor: invoiceGetDetailOfInvoiceSettings,
  },

  invoiceUpdateInvoiceSettings: {
    getResource: createGetApiOperationResource(
      invoiceUpdateInvoiceSettings,
      MittwaldApiClient.getInstance().invoiceUpdateInvoiceSettings
    ),

    request: MittwaldApiClient.getInstance().invoiceUpdateInvoiceSettings,
    descriptor: invoiceUpdateInvoiceSettings,
  },

  fileCreateFile: {
    getResource: createGetApiOperationResource(
      fileCreateFile,
      MittwaldApiClient.getInstance().fileCreateFile
    ),

    request: MittwaldApiClient.getInstance().fileCreateFile,
    descriptor: fileCreateFile,
  },

  backupCreateProjectBackup: {
    getResource: createGetApiOperationResource(
      backupCreateProjectBackup,
      MittwaldApiClient.getInstance().backupCreateProjectBackup
    ),

    request: MittwaldApiClient.getInstance().backupCreateProjectBackup,
    descriptor: backupCreateProjectBackup,
  },

  backupListProjectBackups: {
    getResource: createGetApiOperationResource(
      backupListProjectBackups,
      MittwaldApiClient.getInstance().backupListProjectBackups
    ),

    request: MittwaldApiClient.getInstance().backupListProjectBackups,
    descriptor: backupListProjectBackups,
  },

  backupCreateProjectBackupSchedule: {
    getResource: createGetApiOperationResource(
      backupCreateProjectBackupSchedule,
      MittwaldApiClient.getInstance().backupCreateProjectBackupSchedule
    ),

    request: MittwaldApiClient.getInstance().backupCreateProjectBackupSchedule,
    descriptor: backupCreateProjectBackupSchedule,
  },

  backupListProjectBackupSchedules: {
    getResource: createGetApiOperationResource(
      backupListProjectBackupSchedules,
      MittwaldApiClient.getInstance().backupListProjectBackupSchedules
    ),

    request: MittwaldApiClient.getInstance().backupListProjectBackupSchedules,
    descriptor: backupListProjectBackupSchedules,
  },

  backupDeleteProjectBackup: {
    getResource: createGetApiOperationResource(
      backupDeleteProjectBackup,
      MittwaldApiClient.getInstance().backupDeleteProjectBackup
    ),

    request: MittwaldApiClient.getInstance().backupDeleteProjectBackup,
    descriptor: backupDeleteProjectBackup,
  },

  backupGetProjectBackup: {
    getResource: createGetApiOperationResource(
      backupGetProjectBackup,
      MittwaldApiClient.getInstance().backupGetProjectBackup
    ),

    request: MittwaldApiClient.getInstance().backupGetProjectBackup,
    descriptor: backupGetProjectBackup,
  },

  backupCreateProjectBackupExport: {
    getResource: createGetApiOperationResource(
      backupCreateProjectBackupExport,
      MittwaldApiClient.getInstance().backupCreateProjectBackupExport
    ),

    request: MittwaldApiClient.getInstance().backupCreateProjectBackupExport,
    descriptor: backupCreateProjectBackupExport,
  },

  backupDeleteProjectBackupExport: {
    getResource: createGetApiOperationResource(
      backupDeleteProjectBackupExport,
      MittwaldApiClient.getInstance().backupDeleteProjectBackupExport
    ),

    request: MittwaldApiClient.getInstance().backupDeleteProjectBackupExport,
    descriptor: backupDeleteProjectBackupExport,
  },

  backupDeleteProjectBackupSchedule: {
    getResource: createGetApiOperationResource(
      backupDeleteProjectBackupSchedule,
      MittwaldApiClient.getInstance().backupDeleteProjectBackupSchedule
    ),

    request: MittwaldApiClient.getInstance().backupDeleteProjectBackupSchedule,
    descriptor: backupDeleteProjectBackupSchedule,
  },

  backupGetProjectBackupSchedule: {
    getResource: createGetApiOperationResource(
      backupGetProjectBackupSchedule,
      MittwaldApiClient.getInstance().backupGetProjectBackupSchedule
    ),

    request: MittwaldApiClient.getInstance().backupGetProjectBackupSchedule,
    descriptor: backupGetProjectBackupSchedule,
  },

  backupUpdateProjectBackupSchedule: {
    getResource: createGetApiOperationResource(
      backupUpdateProjectBackupSchedule,
      MittwaldApiClient.getInstance().backupUpdateProjectBackupSchedule
    ),

    request: MittwaldApiClient.getInstance().backupUpdateProjectBackupSchedule,
    descriptor: backupUpdateProjectBackupSchedule,
  },

  backupUpdateProjectBackupDescription: {
    getResource: createGetApiOperationResource(
      backupUpdateProjectBackupDescription,
      MittwaldApiClient.getInstance().backupUpdateProjectBackupDescription
    ),

    request:
      MittwaldApiClient.getInstance().backupUpdateProjectBackupDescription,
    descriptor: backupUpdateProjectBackupDescription,
  },

  cronjobUpdateCronjobAppId: {
    getResource: createGetApiOperationResource(
      cronjobUpdateCronjobAppId,
      MittwaldApiClient.getInstance().cronjobUpdateCronjobAppId
    ),

    request: MittwaldApiClient.getInstance().cronjobUpdateCronjobAppId,
    descriptor: cronjobUpdateCronjobAppId,
  },

  contractGetBaseItemOfContract: {
    getResource: createGetApiOperationResource(
      contractGetBaseItemOfContract,
      MittwaldApiClient.getInstance().contractGetBaseItemOfContract
    ),

    request: MittwaldApiClient.getInstance().contractGetBaseItemOfContract,
    descriptor: contractGetBaseItemOfContract,
  },

  contractGetNextTerminationDateForItem: {
    getResource: createGetApiOperationResource(
      contractGetNextTerminationDateForItem,
      MittwaldApiClient.getInstance().contractGetNextTerminationDateForItem
    ),

    request:
      MittwaldApiClient.getInstance().contractGetNextTerminationDateForItem,
    descriptor: contractGetNextTerminationDateForItem,
  },

  projectDeleteServerAvatar: {
    getResource: createGetApiOperationResource(
      projectDeleteServerAvatar,
      MittwaldApiClient.getInstance().projectDeleteServerAvatar
    ),

    request: MittwaldApiClient.getInstance().projectDeleteServerAvatar,
    descriptor: projectDeleteServerAvatar,
  },

  projectRequestServerAvatarUpload: {
    getResource: createGetApiOperationResource(
      projectRequestServerAvatarUpload,
      MittwaldApiClient.getInstance().projectRequestServerAvatarUpload
    ),

    request: MittwaldApiClient.getInstance().projectRequestServerAvatarUpload,
    descriptor: projectRequestServerAvatarUpload,
  },

  projectListServers: {
    getResource: createGetApiOperationResource(
      projectListServers,
      MittwaldApiClient.getInstance().projectListServers
    ),

    request: MittwaldApiClient.getInstance().projectListServers,
    descriptor: projectListServers,
  },

  projectGetServer: {
    getResource: createGetApiOperationResource(
      projectGetServer,
      MittwaldApiClient.getInstance().projectGetServer
    ),

    request: MittwaldApiClient.getInstance().projectGetServer,
    descriptor: projectGetServer,
  },

  projectCreateProject: {
    getResource: createGetApiOperationResource(
      projectCreateProject,
      MittwaldApiClient.getInstance().projectCreateProject
    ),

    request: MittwaldApiClient.getInstance().projectCreateProject,
    descriptor: projectCreateProject,
  },

  projectUpdateServerDescription: {
    getResource: createGetApiOperationResource(
      projectUpdateServerDescription,
      MittwaldApiClient.getInstance().projectUpdateServerDescription
    ),

    request: MittwaldApiClient.getInstance().projectUpdateServerDescription,
    descriptor: projectUpdateServerDescription,
  },

  databaseCreateMysqlDatabase: {
    getResource: createGetApiOperationResource(
      databaseCreateMysqlDatabase,
      MittwaldApiClient.getInstance().databaseCreateMysqlDatabase
    ),

    request: MittwaldApiClient.getInstance().databaseCreateMysqlDatabase,
    descriptor: databaseCreateMysqlDatabase,
  },

  databaseListMysqlDatabases: {
    getResource: createGetApiOperationResource(
      databaseListMysqlDatabases,
      MittwaldApiClient.getInstance().databaseListMysqlDatabases
    ),

    request: MittwaldApiClient.getInstance().databaseListMysqlDatabases,
    descriptor: databaseListMysqlDatabases,
  },

  databaseCreateRedisDatabase: {
    getResource: createGetApiOperationResource(
      databaseCreateRedisDatabase,
      MittwaldApiClient.getInstance().databaseCreateRedisDatabase
    ),

    request: MittwaldApiClient.getInstance().databaseCreateRedisDatabase,
    descriptor: databaseCreateRedisDatabase,
  },

  databaseListRedisDatabases: {
    getResource: createGetApiOperationResource(
      databaseListRedisDatabases,
      MittwaldApiClient.getInstance().databaseListRedisDatabases
    ),

    request: MittwaldApiClient.getInstance().databaseListRedisDatabases,
    descriptor: databaseListRedisDatabases,
  },

  databaseListMysqlVersions: {
    getResource: createGetApiOperationResource(
      databaseListMysqlVersions,
      MittwaldApiClient.getInstance().databaseListMysqlVersions
    ),

    request: MittwaldApiClient.getInstance().databaseListMysqlVersions,
    descriptor: databaseListMysqlVersions,
  },

  databaseListRedisVersions: {
    getResource: createGetApiOperationResource(
      databaseListRedisVersions,
      MittwaldApiClient.getInstance().databaseListRedisVersions
    ),

    request: MittwaldApiClient.getInstance().databaseListRedisVersions,
    descriptor: databaseListRedisVersions,
  },

  customerGetCustomerTokenInvite: {
    getResource: createGetApiOperationResource(
      customerGetCustomerTokenInvite,
      MittwaldApiClient.getInstance().customerGetCustomerTokenInvite
    ),

    request: MittwaldApiClient.getInstance().customerGetCustomerTokenInvite,
    descriptor: customerGetCustomerTokenInvite,
  },

  customerCreateCustomerInvite: {
    getResource: createGetApiOperationResource(
      customerCreateCustomerInvite,
      MittwaldApiClient.getInstance().customerCreateCustomerInvite
    ),

    request: MittwaldApiClient.getInstance().customerCreateCustomerInvite,
    descriptor: customerCreateCustomerInvite,
  },

  customerListInvitesForCustomer: {
    getResource: createGetApiOperationResource(
      customerListInvitesForCustomer,
      MittwaldApiClient.getInstance().customerListInvitesForCustomer
    ),

    request: MittwaldApiClient.getInstance().customerListInvitesForCustomer,
    descriptor: customerListInvitesForCustomer,
  },

  customerListMembershipsForCustomer: {
    getResource: createGetApiOperationResource(
      customerListMembershipsForCustomer,
      MittwaldApiClient.getInstance().customerListMembershipsForCustomer
    ),

    request: MittwaldApiClient.getInstance().customerListMembershipsForCustomer,
    descriptor: customerListMembershipsForCustomer,
  },

  projectGetProjectTokenInvite: {
    getResource: createGetApiOperationResource(
      projectGetProjectTokenInvite,
      MittwaldApiClient.getInstance().projectGetProjectTokenInvite
    ),

    request: MittwaldApiClient.getInstance().projectGetProjectTokenInvite,
    descriptor: projectGetProjectTokenInvite,
  },

  projectCreateProjectInvite: {
    getResource: createGetApiOperationResource(
      projectCreateProjectInvite,
      MittwaldApiClient.getInstance().projectCreateProjectInvite
    ),

    request: MittwaldApiClient.getInstance().projectCreateProjectInvite,
    descriptor: projectCreateProjectInvite,
  },

  projectListInvitesForProject: {
    getResource: createGetApiOperationResource(
      projectListInvitesForProject,
      MittwaldApiClient.getInstance().projectListInvitesForProject
    ),

    request: MittwaldApiClient.getInstance().projectListInvitesForProject,
    descriptor: projectListInvitesForProject,
  },

  customerListCustomerInvites: {
    getResource: createGetApiOperationResource(
      customerListCustomerInvites,
      MittwaldApiClient.getInstance().customerListCustomerInvites
    ),

    request: MittwaldApiClient.getInstance().customerListCustomerInvites,
    descriptor: customerListCustomerInvites,
  },

  customerListCustomerMemberships: {
    getResource: createGetApiOperationResource(
      customerListCustomerMemberships,
      MittwaldApiClient.getInstance().customerListCustomerMemberships
    ),

    request: MittwaldApiClient.getInstance().customerListCustomerMemberships,
    descriptor: customerListCustomerMemberships,
  },

  projectListMembershipsForProject: {
    getResource: createGetApiOperationResource(
      projectListMembershipsForProject,
      MittwaldApiClient.getInstance().projectListMembershipsForProject
    ),

    request: MittwaldApiClient.getInstance().projectListMembershipsForProject,
    descriptor: projectListMembershipsForProject,
  },

  projectListProjectInvites: {
    getResource: createGetApiOperationResource(
      projectListProjectInvites,
      MittwaldApiClient.getInstance().projectListProjectInvites
    ),

    request: MittwaldApiClient.getInstance().projectListProjectInvites,
    descriptor: projectListProjectInvites,
  },

  projectListProjectMemberships: {
    getResource: createGetApiOperationResource(
      projectListProjectMemberships,
      MittwaldApiClient.getInstance().projectListProjectMemberships
    ),

    request: MittwaldApiClient.getInstance().projectListProjectMemberships,
    descriptor: projectListProjectMemberships,
  },

  customerCreateCategory: {
    getResource: createGetApiOperationResource(
      customerCreateCategory,
      MittwaldApiClient.getInstance().customerCreateCategory
    ),

    request: MittwaldApiClient.getInstance().customerCreateCategory,
    descriptor: customerCreateCategory,
  },

  customerListOfCustomerCategories: {
    getResource: createGetApiOperationResource(
      customerListOfCustomerCategories,
      MittwaldApiClient.getInstance().customerListOfCustomerCategories
    ),

    request: MittwaldApiClient.getInstance().customerListOfCustomerCategories,
    descriptor: customerListOfCustomerCategories,
  },

  customerDeleteCategory: {
    getResource: createGetApiOperationResource(
      customerDeleteCategory,
      MittwaldApiClient.getInstance().customerDeleteCategory
    ),

    request: MittwaldApiClient.getInstance().customerDeleteCategory,
    descriptor: customerDeleteCategory,
  },

  customerGetCustomerCategory: {
    getResource: createGetApiOperationResource(
      customerGetCustomerCategory,
      MittwaldApiClient.getInstance().customerGetCustomerCategory
    ),

    request: MittwaldApiClient.getInstance().customerGetCustomerCategory,
    descriptor: customerGetCustomerCategory,
  },

  customerUpdateCategory: {
    getResource: createGetApiOperationResource(
      customerUpdateCategory,
      MittwaldApiClient.getInstance().customerUpdateCategory
    ),

    request: MittwaldApiClient.getInstance().customerUpdateCategory,
    descriptor: customerUpdateCategory,
  },

  appGetAppversion: {
    getResource: createGetApiOperationResource(
      appGetAppversion,
      MittwaldApiClient.getInstance().appGetAppversion
    ),

    request: MittwaldApiClient.getInstance().appGetAppversion,
    descriptor: appGetAppversion,
  },

  appListAppversions: {
    getResource: createGetApiOperationResource(
      appListAppversions,
      MittwaldApiClient.getInstance().appListAppversions
    ),

    request: MittwaldApiClient.getInstance().appListAppversions,
    descriptor: appListAppversions,
  },

  sftpUserDeleteSftpUser: {
    getResource: createGetApiOperationResource(
      sftpUserDeleteSftpUser,
      MittwaldApiClient.getInstance().sftpUserDeleteSftpUser
    ),

    request: MittwaldApiClient.getInstance().sftpUserDeleteSftpUser,
    descriptor: sftpUserDeleteSftpUser,
  },

  sftpUserGetSftpUser: {
    getResource: createGetApiOperationResource(
      sftpUserGetSftpUser,
      MittwaldApiClient.getInstance().sftpUserGetSftpUser
    ),

    request: MittwaldApiClient.getInstance().sftpUserGetSftpUser,
    descriptor: sftpUserGetSftpUser,
  },

  sftpUserUpdateSftpUser: {
    getResource: createGetApiOperationResource(
      sftpUserUpdateSftpUser,
      MittwaldApiClient.getInstance().sftpUserUpdateSftpUser
    ),

    request: MittwaldApiClient.getInstance().sftpUserUpdateSftpUser,
    descriptor: sftpUserUpdateSftpUser,
  },

  sshUserDeleteSshUser: {
    getResource: createGetApiOperationResource(
      sshUserDeleteSshUser,
      MittwaldApiClient.getInstance().sshUserDeleteSshUser
    ),

    request: MittwaldApiClient.getInstance().sshUserDeleteSshUser,
    descriptor: sshUserDeleteSshUser,
  },

  sshUserGetSshUser: {
    getResource: createGetApiOperationResource(
      sshUserGetSshUser,
      MittwaldApiClient.getInstance().sshUserGetSshUser
    ),

    request: MittwaldApiClient.getInstance().sshUserGetSshUser,
    descriptor: sshUserGetSshUser,
  },

  sshUserUpdateSshUser: {
    getResource: createGetApiOperationResource(
      sshUserUpdateSshUser,
      MittwaldApiClient.getInstance().sshUserUpdateSshUser
    ),

    request: MittwaldApiClient.getInstance().sshUserUpdateSshUser,
    descriptor: sshUserUpdateSshUser,
  },

  sftpUserCreateSftpUser: {
    getResource: createGetApiOperationResource(
      sftpUserCreateSftpUser,
      MittwaldApiClient.getInstance().sftpUserCreateSftpUser
    ),

    request: MittwaldApiClient.getInstance().sftpUserCreateSftpUser,
    descriptor: sftpUserCreateSftpUser,
  },

  sftpUserListSftpUsers: {
    getResource: createGetApiOperationResource(
      sftpUserListSftpUsers,
      MittwaldApiClient.getInstance().sftpUserListSftpUsers
    ),

    request: MittwaldApiClient.getInstance().sftpUserListSftpUsers,
    descriptor: sftpUserListSftpUsers,
  },

  sshUserCreateSshUser: {
    getResource: createGetApiOperationResource(
      sshUserCreateSshUser,
      MittwaldApiClient.getInstance().sshUserCreateSshUser
    ),

    request: MittwaldApiClient.getInstance().sshUserCreateSshUser,
    descriptor: sshUserCreateSshUser,
  },

  sshUserListSshUsers: {
    getResource: createGetApiOperationResource(
      sshUserListSshUsers,
      MittwaldApiClient.getInstance().sshUserListSshUsers
    ),

    request: MittwaldApiClient.getInstance().sshUserListSshUsers,
    descriptor: sshUserListSshUsers,
  },

  projectGetSelfMembershipForProject: {
    getResource: createGetApiOperationResource(
      projectGetSelfMembershipForProject,
      MittwaldApiClient.getInstance().projectGetSelfMembershipForProject
    ),

    request: MittwaldApiClient.getInstance().projectGetSelfMembershipForProject,
    descriptor: projectGetSelfMembershipForProject,
  },

  orderCreateOrder: {
    getResource: createGetApiOperationResource(
      orderCreateOrder,
      MittwaldApiClient.getInstance().orderCreateOrder
    ),

    request: MittwaldApiClient.getInstance().orderCreateOrder,
    descriptor: orderCreateOrder,
  },

  orderListOrders: {
    getResource: createGetApiOperationResource(
      orderListOrders,
      MittwaldApiClient.getInstance().orderListOrders
    ),

    request: MittwaldApiClient.getInstance().orderListOrders,
    descriptor: orderListOrders,
  },

  orderCreateTariffChange: {
    getResource: createGetApiOperationResource(
      orderCreateTariffChange,
      MittwaldApiClient.getInstance().orderCreateTariffChange
    ),

    request: MittwaldApiClient.getInstance().orderCreateTariffChange,
    descriptor: orderCreateTariffChange,
  },

  orderPreviewOrder: {
    getResource: createGetApiOperationResource(
      orderPreviewOrder,
      MittwaldApiClient.getInstance().orderPreviewOrder
    ),

    request: MittwaldApiClient.getInstance().orderPreviewOrder,
    descriptor: orderPreviewOrder,
  },

  orderPreviewTariffChange: {
    getResource: createGetApiOperationResource(
      orderPreviewTariffChange,
      MittwaldApiClient.getInstance().orderPreviewTariffChange
    ),

    request: MittwaldApiClient.getInstance().orderPreviewTariffChange,
    descriptor: orderPreviewTariffChange,
  },

  relocationCreateLegacyTariffChange: {
    getResource: createGetApiOperationResource(
      relocationCreateLegacyTariffChange,
      MittwaldApiClient.getInstance().relocationCreateLegacyTariffChange
    ),

    request: MittwaldApiClient.getInstance().relocationCreateLegacyTariffChange,
    descriptor: relocationCreateLegacyTariffChange,
  },

  contractGetDetailOfContractByDomain: {
    getResource: createGetApiOperationResource(
      contractGetDetailOfContractByDomain,
      MittwaldApiClient.getInstance().contractGetDetailOfContractByDomain
    ),

    request:
      MittwaldApiClient.getInstance().contractGetDetailOfContractByDomain,
    descriptor: contractGetDetailOfContractByDomain,
  },

  contractGetDetailOfContractByProject: {
    getResource: createGetApiOperationResource(
      contractGetDetailOfContractByProject,
      MittwaldApiClient.getInstance().contractGetDetailOfContractByProject
    ),

    request:
      MittwaldApiClient.getInstance().contractGetDetailOfContractByProject,
    descriptor: contractGetDetailOfContractByProject,
  },

  contractGetDetailOfContractByServer: {
    getResource: createGetApiOperationResource(
      contractGetDetailOfContractByServer,
      MittwaldApiClient.getInstance().contractGetDetailOfContractByServer
    ),

    request:
      MittwaldApiClient.getInstance().contractGetDetailOfContractByServer,
    descriptor: contractGetDetailOfContractByServer,
  },

  appListUpdateCandidatesForAppversion: {
    getResource: createGetApiOperationResource(
      appListUpdateCandidatesForAppversion,
      MittwaldApiClient.getInstance().appListUpdateCandidatesForAppversion
    ),

    request:
      MittwaldApiClient.getInstance().appListUpdateCandidatesForAppversion,
    descriptor: appListUpdateCandidatesForAppversion,
  },

  userAuthenticateMfa: {
    getResource: createGetApiOperationResource(
      userAuthenticateMfa,
      MittwaldApiClient.getInstance().userAuthenticateMfa
    ),

    request: MittwaldApiClient.getInstance().userAuthenticateMfa,
    descriptor: userAuthenticateMfa,
  },

  userAuthenticate: {
    getResource: createGetApiOperationResource(
      userAuthenticate,
      MittwaldApiClient.getInstance().userAuthenticate
    ),

    request: MittwaldApiClient.getInstance().userAuthenticate,
    descriptor: userAuthenticate,
  },

  userChangeEmail: {
    getResource: createGetApiOperationResource(
      userChangeEmail,
      MittwaldApiClient.getInstance().userChangeEmail
    ),

    request: MittwaldApiClient.getInstance().userChangeEmail,
    descriptor: userChangeEmail,
  },

  userGetOwnEmail: {
    getResource: createGetApiOperationResource(
      userGetOwnEmail,
      MittwaldApiClient.getInstance().userGetOwnEmail
    ),

    request: MittwaldApiClient.getInstance().userGetOwnEmail,
    descriptor: userGetOwnEmail,
  },

  userChangePassword: {
    getResource: createGetApiOperationResource(
      userChangePassword,
      MittwaldApiClient.getInstance().userChangePassword
    ),

    request: MittwaldApiClient.getInstance().userChangePassword,
    descriptor: userChangePassword,
  },

  userCheckToken: {
    getResource: createGetApiOperationResource(
      userCheckToken,
      MittwaldApiClient.getInstance().userCheckToken
    ),

    request: MittwaldApiClient.getInstance().userCheckToken,
    descriptor: userCheckToken,
  },

  userConfirmMfa: {
    getResource: createGetApiOperationResource(
      userConfirmMfa,
      MittwaldApiClient.getInstance().userConfirmMfa
    ),

    request: MittwaldApiClient.getInstance().userConfirmMfa,
    descriptor: userConfirmMfa,
  },

  userDisableMfa: {
    getResource: createGetApiOperationResource(
      userDisableMfa,
      MittwaldApiClient.getInstance().userDisableMfa
    ),

    request: MittwaldApiClient.getInstance().userDisableMfa,
    descriptor: userDisableMfa,
  },

  userGetMfaStatus: {
    getResource: createGetApiOperationResource(
      userGetMfaStatus,
      MittwaldApiClient.getInstance().userGetMfaStatus
    ),

    request: MittwaldApiClient.getInstance().userGetMfaStatus,
    descriptor: userGetMfaStatus,
  },

  userResetRecoverycodes: {
    getResource: createGetApiOperationResource(
      userResetRecoverycodes,
      MittwaldApiClient.getInstance().userResetRecoverycodes
    ),

    request: MittwaldApiClient.getInstance().userResetRecoverycodes,
    descriptor: userResetRecoverycodes,
  },

  userConfirmPasswordReset: {
    getResource: createGetApiOperationResource(
      userConfirmPasswordReset,
      MittwaldApiClient.getInstance().userConfirmPasswordReset
    ),

    request: MittwaldApiClient.getInstance().userConfirmPasswordReset,
    descriptor: userConfirmPasswordReset,
  },

  userCreateApiToken: {
    getResource: createGetApiOperationResource(
      userCreateApiToken,
      MittwaldApiClient.getInstance().userCreateApiToken
    ),

    request: MittwaldApiClient.getInstance().userCreateApiToken,
    descriptor: userCreateApiToken,
  },

  userListApiTokens: {
    getResource: createGetApiOperationResource(
      userListApiTokens,
      MittwaldApiClient.getInstance().userListApiTokens
    ),

    request: MittwaldApiClient.getInstance().userListApiTokens,
    descriptor: userListApiTokens,
  },

  userCreateSshKey: {
    getResource: createGetApiOperationResource(
      userCreateSshKey,
      MittwaldApiClient.getInstance().userCreateSshKey
    ),

    request: MittwaldApiClient.getInstance().userCreateSshKey,
    descriptor: userCreateSshKey,
  },

  userListSshKeys: {
    getResource: createGetApiOperationResource(
      userListSshKeys,
      MittwaldApiClient.getInstance().userListSshKeys
    ),

    request: MittwaldApiClient.getInstance().userListSshKeys,
    descriptor: userListSshKeys,
  },

  userDeleteApiToken: {
    getResource: createGetApiOperationResource(
      userDeleteApiToken,
      MittwaldApiClient.getInstance().userDeleteApiToken
    ),

    request: MittwaldApiClient.getInstance().userDeleteApiToken,
    descriptor: userDeleteApiToken,
  },

  userEditApiToken: {
    getResource: createGetApiOperationResource(
      userEditApiToken,
      MittwaldApiClient.getInstance().userEditApiToken
    ),

    request: MittwaldApiClient.getInstance().userEditApiToken,
    descriptor: userEditApiToken,
  },

  userGetApiToken: {
    getResource: createGetApiOperationResource(
      userGetApiToken,
      MittwaldApiClient.getInstance().userGetApiToken
    ),

    request: MittwaldApiClient.getInstance().userGetApiToken,
    descriptor: userGetApiToken,
  },

  userDeleteSshKey: {
    getResource: createGetApiOperationResource(
      userDeleteSshKey,
      MittwaldApiClient.getInstance().userDeleteSshKey
    ),

    request: MittwaldApiClient.getInstance().userDeleteSshKey,
    descriptor: userDeleteSshKey,
  },

  userEditSshKey: {
    getResource: createGetApiOperationResource(
      userEditSshKey,
      MittwaldApiClient.getInstance().userEditSshKey
    ),

    request: MittwaldApiClient.getInstance().userEditSshKey,
    descriptor: userEditSshKey,
  },

  userGetSshKey: {
    getResource: createGetApiOperationResource(
      userGetSshKey,
      MittwaldApiClient.getInstance().userGetSshKey
    ),

    request: MittwaldApiClient.getInstance().userGetSshKey,
    descriptor: userGetSshKey,
  },

  userDeleteUser: {
    getResource: createGetApiOperationResource(
      userDeleteUser,
      MittwaldApiClient.getInstance().userDeleteUser
    ),

    request: MittwaldApiClient.getInstance().userDeleteUser,
    descriptor: userDeleteUser,
  },

  userUpdateAccount: {
    getResource: createGetApiOperationResource(
      userUpdateAccount,
      MittwaldApiClient.getInstance().userUpdateAccount
    ),

    request: MittwaldApiClient.getInstance().userUpdateAccount,
    descriptor: userUpdateAccount,
  },

  userGetPasswordUpdatedAt: {
    getResource: createGetApiOperationResource(
      userGetPasswordUpdatedAt,
      MittwaldApiClient.getInstance().userGetPasswordUpdatedAt
    ),

    request: MittwaldApiClient.getInstance().userGetPasswordUpdatedAt,
    descriptor: userGetPasswordUpdatedAt,
  },

  userGetSession: {
    getResource: createGetApiOperationResource(
      userGetSession,
      MittwaldApiClient.getInstance().userGetSession
    ),

    request: MittwaldApiClient.getInstance().userGetSession,
    descriptor: userGetSession,
  },

  userTerminateSession: {
    getResource: createGetApiOperationResource(
      userTerminateSession,
      MittwaldApiClient.getInstance().userTerminateSession
    ),

    request: MittwaldApiClient.getInstance().userTerminateSession,
    descriptor: userTerminateSession,
  },

  userInitMfa: {
    getResource: createGetApiOperationResource(
      userInitMfa,
      MittwaldApiClient.getInstance().userInitMfa
    ),

    request: MittwaldApiClient.getInstance().userInitMfa,
    descriptor: userInitMfa,
  },

  userInitPasswordReset: {
    getResource: createGetApiOperationResource(
      userInitPasswordReset,
      MittwaldApiClient.getInstance().userInitPasswordReset
    ),

    request: MittwaldApiClient.getInstance().userInitPasswordReset,
    descriptor: userInitPasswordReset,
  },

  userListSessions: {
    getResource: createGetApiOperationResource(
      userListSessions,
      MittwaldApiClient.getInstance().userListSessions
    ),

    request: MittwaldApiClient.getInstance().userListSessions,
    descriptor: userListSessions,
  },

  userRefreshSession: {
    getResource: createGetApiOperationResource(
      userRefreshSession,
      MittwaldApiClient.getInstance().userRefreshSession
    ),

    request: MittwaldApiClient.getInstance().userRefreshSession,
    descriptor: userRefreshSession,
  },

  userTerminateAllSessions: {
    getResource: createGetApiOperationResource(
      userTerminateAllSessions,
      MittwaldApiClient.getInstance().userTerminateAllSessions
    ),

    request: MittwaldApiClient.getInstance().userTerminateAllSessions,
    descriptor: userTerminateAllSessions,
  },

  userLogout: {
    getResource: createGetApiOperationResource(
      userLogout,
      MittwaldApiClient.getInstance().userLogout
    ),

    request: MittwaldApiClient.getInstance().userLogout,
    descriptor: userLogout,
  },

  userRegister: {
    getResource: createGetApiOperationResource(
      userRegister,
      MittwaldApiClient.getInstance().userRegister
    ),

    request: MittwaldApiClient.getInstance().userRegister,
    descriptor: userRegister,
  },

  userResendVerificationEmail: {
    getResource: createGetApiOperationResource(
      userResendVerificationEmail,
      MittwaldApiClient.getInstance().userResendVerificationEmail
    ),

    request: MittwaldApiClient.getInstance().userResendVerificationEmail,
    descriptor: userResendVerificationEmail,
  },

  userSupportCodeRequest: {
    getResource: createGetApiOperationResource(
      userSupportCodeRequest,
      MittwaldApiClient.getInstance().userSupportCodeRequest
    ),

    request: MittwaldApiClient.getInstance().userSupportCodeRequest,
    descriptor: userSupportCodeRequest,
  },

  userVerifyEmail: {
    getResource: createGetApiOperationResource(
      userVerifyEmail,
      MittwaldApiClient.getInstance().userVerifyEmail
    ),

    request: MittwaldApiClient.getInstance().userVerifyEmail,
    descriptor: userVerifyEmail,
  },

  userVerifyRegistration: {
    getResource: createGetApiOperationResource(
      userVerifyRegistration,
      MittwaldApiClient.getInstance().userVerifyRegistration
    ),

    request: MittwaldApiClient.getInstance().userVerifyRegistration,
    descriptor: userVerifyRegistration,
  },

  userAddPhoneNumber: {
    getResource: createGetApiOperationResource(
      userAddPhoneNumber,
      MittwaldApiClient.getInstance().userAddPhoneNumber
    ),

    request: MittwaldApiClient.getInstance().userAddPhoneNumber,
    descriptor: userAddPhoneNumber,
  },

  userRemovePhoneNumber: {
    getResource: createGetApiOperationResource(
      userRemovePhoneNumber,
      MittwaldApiClient.getInstance().userRemovePhoneNumber
    ),

    request: MittwaldApiClient.getInstance().userRemovePhoneNumber,
    descriptor: userRemovePhoneNumber,
  },

  userCreateFeedback: {
    getResource: createGetApiOperationResource(
      userCreateFeedback,
      MittwaldApiClient.getInstance().userCreateFeedback
    ),

    request: MittwaldApiClient.getInstance().userCreateFeedback,
    descriptor: userCreateFeedback,
  },

  userGetPersonalizedSettings: {
    getResource: createGetApiOperationResource(
      userGetPersonalizedSettings,
      MittwaldApiClient.getInstance().userGetPersonalizedSettings
    ),

    request: MittwaldApiClient.getInstance().userGetPersonalizedSettings,
    descriptor: userGetPersonalizedSettings,
  },

  userUpdatePersonalizedSettings: {
    getResource: createGetApiOperationResource(
      userUpdatePersonalizedSettings,
      MittwaldApiClient.getInstance().userUpdatePersonalizedSettings
    ),

    request: MittwaldApiClient.getInstance().userUpdatePersonalizedSettings,
    descriptor: userUpdatePersonalizedSettings,
  },

  userGetUser: {
    getResource: createGetApiOperationResource(
      userGetUser,
      MittwaldApiClient.getInstance().userGetUser
    ),

    request: MittwaldApiClient.getInstance().userGetUser,
    descriptor: userGetUser,
  },

  userUpdatePersonalInformation: {
    getResource: createGetApiOperationResource(
      userUpdatePersonalInformation,
      MittwaldApiClient.getInstance().userUpdatePersonalInformation
    ),

    request: MittwaldApiClient.getInstance().userUpdatePersonalInformation,
    descriptor: userUpdatePersonalInformation,
  },

  userListFeedback: {
    getResource: createGetApiOperationResource(
      userListFeedback,
      MittwaldApiClient.getInstance().userListFeedback
    ),

    request: MittwaldApiClient.getInstance().userListFeedback,
    descriptor: userListFeedback,
  },

  userRemoveAvatar: {
    getResource: createGetApiOperationResource(
      userRemoveAvatar,
      MittwaldApiClient.getInstance().userRemoveAvatar
    ),

    request: MittwaldApiClient.getInstance().userRemoveAvatar,
    descriptor: userRemoveAvatar,
  },

  userRequestAvatarUpload: {
    getResource: createGetApiOperationResource(
      userRequestAvatarUpload,
      MittwaldApiClient.getInstance().userRequestAvatarUpload
    ),

    request: MittwaldApiClient.getInstance().userRequestAvatarUpload,
    descriptor: userRequestAvatarUpload,
  },

  ingressRequestIngressAcmeCertificateIssuance: {
    getResource: createGetApiOperationResource(
      ingressRequestIngressAcmeCertificateIssuance,
      MittwaldApiClient.getInstance()
        .ingressRequestIngressAcmeCertificateIssuance
    ),

    request:
      MittwaldApiClient.getInstance()
        .ingressRequestIngressAcmeCertificateIssuance,
    descriptor: ingressRequestIngressAcmeCertificateIssuance,
  },

  newsletterGetInfo: {
    getResource: createGetApiOperationResource(
      newsletterGetInfo,
      MittwaldApiClient.getInstance().newsletterGetInfo
    ),

    request: MittwaldApiClient.getInstance().newsletterGetInfo,
    descriptor: newsletterGetInfo,
  },

  newsletterUnsubscribeUser: {
    getResource: createGetApiOperationResource(
      newsletterUnsubscribeUser,
      MittwaldApiClient.getInstance().newsletterUnsubscribeUser
    ),

    request: MittwaldApiClient.getInstance().newsletterUnsubscribeUser,
    descriptor: newsletterUnsubscribeUser,
  },

  newsletterSubscribeUser: {
    getResource: createGetApiOperationResource(
      newsletterSubscribeUser,
      MittwaldApiClient.getInstance().newsletterSubscribeUser
    ),

    request: MittwaldApiClient.getInstance().newsletterSubscribeUser,
    descriptor: newsletterSubscribeUser,
  },

  domainCheckDomainRegistrability: {
    getResource: createGetApiOperationResource(
      domainCheckDomainRegistrability,
      MittwaldApiClient.getInstance().domainCheckDomainRegistrability
    ),

    request: MittwaldApiClient.getInstance().domainCheckDomainRegistrability,
    descriptor: domainCheckDomainRegistrability,
  },

  domainListTldContactSchemas: {
    getResource: createGetApiOperationResource(
      domainListTldContactSchemas,
      MittwaldApiClient.getInstance().domainListTldContactSchemas
    ),

    request: MittwaldApiClient.getInstance().domainListTldContactSchemas,
    descriptor: domainListTldContactSchemas,
  },

  dnsCreateDnsZone: {
    getResource: createGetApiOperationResource(
      dnsCreateDnsZone,
      MittwaldApiClient.getInstance().dnsCreateDnsZone
    ),

    request: MittwaldApiClient.getInstance().dnsCreateDnsZone,
    descriptor: dnsCreateDnsZone,
  },

  dnsDeleteDnsZone: {
    getResource: createGetApiOperationResource(
      dnsDeleteDnsZone,
      MittwaldApiClient.getInstance().dnsDeleteDnsZone
    ),

    request: MittwaldApiClient.getInstance().dnsDeleteDnsZone,
    descriptor: dnsDeleteDnsZone,
  },

  dnsGetDnsZone: {
    getResource: createGetApiOperationResource(
      dnsGetDnsZone,
      MittwaldApiClient.getInstance().dnsGetDnsZone
    ),

    request: MittwaldApiClient.getInstance().dnsGetDnsZone,
    descriptor: dnsGetDnsZone,
  },

  dnsListDnsZones: {
    getResource: createGetApiOperationResource(
      dnsListDnsZones,
      MittwaldApiClient.getInstance().dnsListDnsZones
    ),

    request: MittwaldApiClient.getInstance().dnsListDnsZones,
    descriptor: dnsListDnsZones,
  },

  dnsSetRecordSetManaged: {
    getResource: createGetApiOperationResource(
      dnsSetRecordSetManaged,
      MittwaldApiClient.getInstance().dnsSetRecordSetManaged
    ),

    request: MittwaldApiClient.getInstance().dnsSetRecordSetManaged,
    descriptor: dnsSetRecordSetManaged,
  },

  dnsUpdateRecordSet: {
    getResource: createGetApiOperationResource(
      dnsUpdateRecordSet,
      MittwaldApiClient.getInstance().dnsUpdateRecordSet
    ),

    request: MittwaldApiClient.getInstance().dnsUpdateRecordSet,
    descriptor: dnsUpdateRecordSet,
  },

  domainAbortDomainDeclaration: {
    getResource: createGetApiOperationResource(
      domainAbortDomainDeclaration,
      MittwaldApiClient.getInstance().domainAbortDomainDeclaration
    ),

    request: MittwaldApiClient.getInstance().domainAbortDomainDeclaration,
    descriptor: domainAbortDomainDeclaration,
  },

  domainCreateDomainAuthCode: {
    getResource: createGetApiOperationResource(
      domainCreateDomainAuthCode,
      MittwaldApiClient.getInstance().domainCreateDomainAuthCode
    ),

    request: MittwaldApiClient.getInstance().domainCreateDomainAuthCode,
    descriptor: domainCreateDomainAuthCode,
  },

  domainListTlds: {
    getResource: createGetApiOperationResource(
      domainListTlds,
      MittwaldApiClient.getInstance().domainListTlds
    ),

    request: MittwaldApiClient.getInstance().domainListTlds,
    descriptor: domainListTlds,
  },

  domainUpdateDomainAuthCode: {
    getResource: createGetApiOperationResource(
      domainUpdateDomainAuthCode,
      MittwaldApiClient.getInstance().domainUpdateDomainAuthCode
    ),

    request: MittwaldApiClient.getInstance().domainUpdateDomainAuthCode,
    descriptor: domainUpdateDomainAuthCode,
  },

  domainUpdateDomainContact: {
    getResource: createGetApiOperationResource(
      domainUpdateDomainContact,
      MittwaldApiClient.getInstance().domainUpdateDomainContact
    ),

    request: MittwaldApiClient.getInstance().domainUpdateDomainContact,
    descriptor: domainUpdateDomainContact,
  },

  domainUpdateDomainProjectId: {
    getResource: createGetApiOperationResource(
      domainUpdateDomainProjectId,
      MittwaldApiClient.getInstance().domainUpdateDomainProjectId
    ),

    request: MittwaldApiClient.getInstance().domainUpdateDomainProjectId,
    descriptor: domainUpdateDomainProjectId,
  },

  mailCreateDeliverybox: {
    getResource: createGetApiOperationResource(
      mailCreateDeliverybox,
      MittwaldApiClient.getInstance().mailCreateDeliverybox
    ),

    request: MittwaldApiClient.getInstance().mailCreateDeliverybox,
    descriptor: mailCreateDeliverybox,
  },

  mailListDeliveryBoxes: {
    getResource: createGetApiOperationResource(
      mailListDeliveryBoxes,
      MittwaldApiClient.getInstance().mailListDeliveryBoxes
    ),

    request: MittwaldApiClient.getInstance().mailListDeliveryBoxes,
    descriptor: mailListDeliveryBoxes,
  },

  mailCreateMailAddress: {
    getResource: createGetApiOperationResource(
      mailCreateMailAddress,
      MittwaldApiClient.getInstance().mailCreateMailAddress
    ),

    request: MittwaldApiClient.getInstance().mailCreateMailAddress,
    descriptor: mailCreateMailAddress,
  },

  mailListMailAddresses: {
    getResource: createGetApiOperationResource(
      mailListMailAddresses,
      MittwaldApiClient.getInstance().mailListMailAddresses
    ),

    request: MittwaldApiClient.getInstance().mailListMailAddresses,
    descriptor: mailListMailAddresses,
  },

  mailDeleteDeliveryBox: {
    getResource: createGetApiOperationResource(
      mailDeleteDeliveryBox,
      MittwaldApiClient.getInstance().mailDeleteDeliveryBox
    ),

    request: MittwaldApiClient.getInstance().mailDeleteDeliveryBox,
    descriptor: mailDeleteDeliveryBox,
  },

  mailGetDeliveryBox: {
    getResource: createGetApiOperationResource(
      mailGetDeliveryBox,
      MittwaldApiClient.getInstance().mailGetDeliveryBox
    ),

    request: MittwaldApiClient.getInstance().mailGetDeliveryBox,
    descriptor: mailGetDeliveryBox,
  },

  mailDeleteMailAddress: {
    getResource: createGetApiOperationResource(
      mailDeleteMailAddress,
      MittwaldApiClient.getInstance().mailDeleteMailAddress
    ),

    request: MittwaldApiClient.getInstance().mailDeleteMailAddress,
    descriptor: mailDeleteMailAddress,
  },

  mailGetMailAddress: {
    getResource: createGetApiOperationResource(
      mailGetMailAddress,
      MittwaldApiClient.getInstance().mailGetMailAddress
    ),

    request: MittwaldApiClient.getInstance().mailGetMailAddress,
    descriptor: mailGetMailAddress,
  },

  mailListProjectMailSettings: {
    getResource: createGetApiOperationResource(
      mailListProjectMailSettings,
      MittwaldApiClient.getInstance().mailListProjectMailSettings
    ),

    request: MittwaldApiClient.getInstance().mailListProjectMailSettings,
    descriptor: mailListProjectMailSettings,
  },

  mailUpdateDeliveryBoxDescription: {
    getResource: createGetApiOperationResource(
      mailUpdateDeliveryBoxDescription,
      MittwaldApiClient.getInstance().mailUpdateDeliveryBoxDescription
    ),

    request: MittwaldApiClient.getInstance().mailUpdateDeliveryBoxDescription,
    descriptor: mailUpdateDeliveryBoxDescription,
  },

  mailUpdateDeliveryBoxPassword: {
    getResource: createGetApiOperationResource(
      mailUpdateDeliveryBoxPassword,
      MittwaldApiClient.getInstance().mailUpdateDeliveryBoxPassword
    ),

    request: MittwaldApiClient.getInstance().mailUpdateDeliveryBoxPassword,
    descriptor: mailUpdateDeliveryBoxPassword,
  },

  mailUpdateMailAddressAddress: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressAddress,
      MittwaldApiClient.getInstance().mailUpdateMailAddressAddress
    ),

    request: MittwaldApiClient.getInstance().mailUpdateMailAddressAddress,
    descriptor: mailUpdateMailAddressAddress,
  },

  mailUpdateMailAddressAutoresponder: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressAutoresponder,
      MittwaldApiClient.getInstance().mailUpdateMailAddressAutoresponder
    ),

    request: MittwaldApiClient.getInstance().mailUpdateMailAddressAutoresponder,
    descriptor: mailUpdateMailAddressAutoresponder,
  },

  mailUpdateMailAddressCatchAll: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressCatchAll,
      MittwaldApiClient.getInstance().mailUpdateMailAddressCatchAll
    ),

    request: MittwaldApiClient.getInstance().mailUpdateMailAddressCatchAll,
    descriptor: mailUpdateMailAddressCatchAll,
  },

  mailUpdateMailAddressForwardAddresses: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressForwardAddresses,
      MittwaldApiClient.getInstance().mailUpdateMailAddressForwardAddresses
    ),

    request:
      MittwaldApiClient.getInstance().mailUpdateMailAddressForwardAddresses,
    descriptor: mailUpdateMailAddressForwardAddresses,
  },

  mailUpdateMailAddressPassword: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressPassword,
      MittwaldApiClient.getInstance().mailUpdateMailAddressPassword
    ),

    request: MittwaldApiClient.getInstance().mailUpdateMailAddressPassword,
    descriptor: mailUpdateMailAddressPassword,
  },

  mailUpdateMailAddressQuota: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressQuota,
      MittwaldApiClient.getInstance().mailUpdateMailAddressQuota
    ),

    request: MittwaldApiClient.getInstance().mailUpdateMailAddressQuota,
    descriptor: mailUpdateMailAddressQuota,
  },

  mailUpdateMailAddressSpamProtection: {
    getResource: createGetApiOperationResource(
      mailUpdateMailAddressSpamProtection,
      MittwaldApiClient.getInstance().mailUpdateMailAddressSpamProtection
    ),

    request:
      MittwaldApiClient.getInstance().mailUpdateMailAddressSpamProtection,
    descriptor: mailUpdateMailAddressSpamProtection,
  },

  appExecuteAction: {
    getResource: createGetApiOperationResource(
      appExecuteAction,
      MittwaldApiClient.getInstance().appExecuteAction
    ),

    request: MittwaldApiClient.getInstance().appExecuteAction,
    descriptor: appExecuteAction,
  },

  appGetAppinstallation: {
    getResource: createGetApiOperationResource(
      appGetAppinstallation,
      MittwaldApiClient.getInstance().appGetAppinstallation
    ),

    request: MittwaldApiClient.getInstance().appGetAppinstallation,
    descriptor: appGetAppinstallation,
  },

  appPatchAppinstallation: {
    getResource: createGetApiOperationResource(
      appPatchAppinstallation,
      MittwaldApiClient.getInstance().appPatchAppinstallation
    ),

    request: MittwaldApiClient.getInstance().appPatchAppinstallation,
    descriptor: appPatchAppinstallation,
  },

  appUninstallAppinstallation: {
    getResource: createGetApiOperationResource(
      appUninstallAppinstallation,
      MittwaldApiClient.getInstance().appUninstallAppinstallation
    ),

    request: MittwaldApiClient.getInstance().appUninstallAppinstallation,
    descriptor: appUninstallAppinstallation,
  },

  appGetMissingDependenciesForAppinstallation: {
    getResource: createGetApiOperationResource(
      appGetMissingDependenciesForAppinstallation,
      MittwaldApiClient.getInstance()
        .appGetMissingDependenciesForAppinstallation
    ),

    request:
      MittwaldApiClient.getInstance()
        .appGetMissingDependenciesForAppinstallation,
    descriptor: appGetMissingDependenciesForAppinstallation,
  },

  appGetSystemsoftware: {
    getResource: createGetApiOperationResource(
      appGetSystemsoftware,
      MittwaldApiClient.getInstance().appGetSystemsoftware
    ),

    request: MittwaldApiClient.getInstance().appGetSystemsoftware,
    descriptor: appGetSystemsoftware,
  },

  appGetSystemsoftwareversion: {
    getResource: createGetApiOperationResource(
      appGetSystemsoftwareversion,
      MittwaldApiClient.getInstance().appGetSystemsoftwareversion
    ),

    request: MittwaldApiClient.getInstance().appGetSystemsoftwareversion,
    descriptor: appGetSystemsoftwareversion,
  },

  appLinkDatabase: {
    getResource: createGetApiOperationResource(
      appLinkDatabase,
      MittwaldApiClient.getInstance().appLinkDatabase
    ),

    request: MittwaldApiClient.getInstance().appLinkDatabase,
    descriptor: appLinkDatabase,
  },

  appListAppinstallations: {
    getResource: createGetApiOperationResource(
      appListAppinstallations,
      MittwaldApiClient.getInstance().appListAppinstallations
    ),

    request: MittwaldApiClient.getInstance().appListAppinstallations,
    descriptor: appListAppinstallations,
  },

  appRequestAppinstallation: {
    getResource: createGetApiOperationResource(
      appRequestAppinstallation,
      MittwaldApiClient.getInstance().appRequestAppinstallation
    ),

    request: MittwaldApiClient.getInstance().appRequestAppinstallation,
    descriptor: appRequestAppinstallation,
  },

  appListSystemsoftwares: {
    getResource: createGetApiOperationResource(
      appListSystemsoftwares,
      MittwaldApiClient.getInstance().appListSystemsoftwares
    ),

    request: MittwaldApiClient.getInstance().appListSystemsoftwares,
    descriptor: appListSystemsoftwares,
  },

  appListSystemsoftwareversions: {
    getResource: createGetApiOperationResource(
      appListSystemsoftwareversions,
      MittwaldApiClient.getInstance().appListSystemsoftwareversions
    ),

    request: MittwaldApiClient.getInstance().appListSystemsoftwareversions,
    descriptor: appListSystemsoftwareversions,
  },

  appRetrieveStatus: {
    getResource: createGetApiOperationResource(
      appRetrieveStatus,
      MittwaldApiClient.getInstance().appRetrieveStatus
    ),

    request: MittwaldApiClient.getInstance().appRetrieveStatus,
    descriptor: appRetrieveStatus,
  },

  appUnlinkDatabase: {
    getResource: createGetApiOperationResource(
      appUnlinkDatabase,
      MittwaldApiClient.getInstance().appUnlinkDatabase
    ),

    request: MittwaldApiClient.getInstance().appUnlinkDatabase,
    descriptor: appUnlinkDatabase,
  },

  databaseDeleteMysqlDatabase: {
    getResource: createGetApiOperationResource(
      databaseDeleteMysqlDatabase,
      MittwaldApiClient.getInstance().databaseDeleteMysqlDatabase
    ),

    request: MittwaldApiClient.getInstance().databaseDeleteMysqlDatabase,
    descriptor: databaseDeleteMysqlDatabase,
  },

  databaseGetMysqlDatabase: {
    getResource: createGetApiOperationResource(
      databaseGetMysqlDatabase,
      MittwaldApiClient.getInstance().databaseGetMysqlDatabase
    ),

    request: MittwaldApiClient.getInstance().databaseGetMysqlDatabase,
    descriptor: databaseGetMysqlDatabase,
  },

  databaseDeleteMysqlUser: {
    getResource: createGetApiOperationResource(
      databaseDeleteMysqlUser,
      MittwaldApiClient.getInstance().databaseDeleteMysqlUser
    ),

    request: MittwaldApiClient.getInstance().databaseDeleteMysqlUser,
    descriptor: databaseDeleteMysqlUser,
  },

  databaseGetMysqlUser: {
    getResource: createGetApiOperationResource(
      databaseGetMysqlUser,
      MittwaldApiClient.getInstance().databaseGetMysqlUser
    ),

    request: MittwaldApiClient.getInstance().databaseGetMysqlUser,
    descriptor: databaseGetMysqlUser,
  },

  databaseUpdateMysqlUser: {
    getResource: createGetApiOperationResource(
      databaseUpdateMysqlUser,
      MittwaldApiClient.getInstance().databaseUpdateMysqlUser
    ),

    request: MittwaldApiClient.getInstance().databaseUpdateMysqlUser,
    descriptor: databaseUpdateMysqlUser,
  },

  databaseDeleteRedisDatabase: {
    getResource: createGetApiOperationResource(
      databaseDeleteRedisDatabase,
      MittwaldApiClient.getInstance().databaseDeleteRedisDatabase
    ),

    request: MittwaldApiClient.getInstance().databaseDeleteRedisDatabase,
    descriptor: databaseDeleteRedisDatabase,
  },

  databaseGetRedisDatabase: {
    getResource: createGetApiOperationResource(
      databaseGetRedisDatabase,
      MittwaldApiClient.getInstance().databaseGetRedisDatabase
    ),

    request: MittwaldApiClient.getInstance().databaseGetRedisDatabase,
    descriptor: databaseGetRedisDatabase,
  },

  databaseDisableMysqlUser: {
    getResource: createGetApiOperationResource(
      databaseDisableMysqlUser,
      MittwaldApiClient.getInstance().databaseDisableMysqlUser
    ),

    request: MittwaldApiClient.getInstance().databaseDisableMysqlUser,
    descriptor: databaseDisableMysqlUser,
  },

  databaseEnableMysqlUser: {
    getResource: createGetApiOperationResource(
      databaseEnableMysqlUser,
      MittwaldApiClient.getInstance().databaseEnableMysqlUser
    ),

    request: MittwaldApiClient.getInstance().databaseEnableMysqlUser,
    descriptor: databaseEnableMysqlUser,
  },

  databaseGetMysqlUserPhpMyAdminUrl: {
    getResource: createGetApiOperationResource(
      databaseGetMysqlUserPhpMyAdminUrl,
      MittwaldApiClient.getInstance().databaseGetMysqlUserPhpMyAdminUrl
    ),

    request: MittwaldApiClient.getInstance().databaseGetMysqlUserPhpMyAdminUrl,
    descriptor: databaseGetMysqlUserPhpMyAdminUrl,
  },

  databaseUpdateMysqlDatabaseDefaultCharset: {
    getResource: createGetApiOperationResource(
      databaseUpdateMysqlDatabaseDefaultCharset,
      MittwaldApiClient.getInstance().databaseUpdateMysqlDatabaseDefaultCharset
    ),

    request:
      MittwaldApiClient.getInstance().databaseUpdateMysqlDatabaseDefaultCharset,
    descriptor: databaseUpdateMysqlDatabaseDefaultCharset,
  },

  databaseUpdateMysqlDatabaseDescription: {
    getResource: createGetApiOperationResource(
      databaseUpdateMysqlDatabaseDescription,
      MittwaldApiClient.getInstance().databaseUpdateMysqlDatabaseDescription
    ),

    request:
      MittwaldApiClient.getInstance().databaseUpdateMysqlDatabaseDescription,
    descriptor: databaseUpdateMysqlDatabaseDescription,
  },

  databaseUpdateMysqlUserPassword: {
    getResource: createGetApiOperationResource(
      databaseUpdateMysqlUserPassword,
      MittwaldApiClient.getInstance().databaseUpdateMysqlUserPassword
    ),

    request: MittwaldApiClient.getInstance().databaseUpdateMysqlUserPassword,
    descriptor: databaseUpdateMysqlUserPassword,
  },

  databaseUpdateRedisDatabaseConfiguration: {
    getResource: createGetApiOperationResource(
      databaseUpdateRedisDatabaseConfiguration,
      MittwaldApiClient.getInstance().databaseUpdateRedisDatabaseConfiguration
    ),

    request:
      MittwaldApiClient.getInstance().databaseUpdateRedisDatabaseConfiguration,
    descriptor: databaseUpdateRedisDatabaseConfiguration,
  },

  databaseUpdateRedisDatabaseDescription: {
    getResource: createGetApiOperationResource(
      databaseUpdateRedisDatabaseDescription,
      MittwaldApiClient.getInstance().databaseUpdateRedisDatabaseDescription
    ),

    request:
      MittwaldApiClient.getInstance().databaseUpdateRedisDatabaseDescription,
    descriptor: databaseUpdateRedisDatabaseDescription,
  },

  fileGetFileMeta: {
    getResource: createGetApiOperationResource(
      fileGetFileMeta,
      MittwaldApiClient.getInstance().fileGetFileMeta
    ),

    request: MittwaldApiClient.getInstance().fileGetFileMeta,
    descriptor: fileGetFileMeta,
  },

  fileGetFile: {
    getResource: createGetApiOperationResource(
      fileGetFile,
      MittwaldApiClient.getInstance().fileGetFile
    ),

    request: MittwaldApiClient.getInstance().fileGetFile,
    descriptor: fileGetFile,
  },

  pageinsightsGetPerformanceData: {
    getResource: createGetApiOperationResource(
      pageinsightsGetPerformanceData,
      MittwaldApiClient.getInstance().pageinsightsGetPerformanceData
    ),

    request: MittwaldApiClient.getInstance().pageinsightsGetPerformanceData,
    descriptor: pageinsightsGetPerformanceData,
  },

  pageinsightsListPerformanceDataForProject: {
    getResource: createGetApiOperationResource(
      pageinsightsListPerformanceDataForProject,
      MittwaldApiClient.getInstance().pageinsightsListPerformanceDataForProject
    ),

    request:
      MittwaldApiClient.getInstance().pageinsightsListPerformanceDataForProject,
    descriptor: pageinsightsListPerformanceDataForProject,
  },

  projectFileSystemGetDirectories: {
    getResource: createGetApiOperationResource(
      projectFileSystemGetDirectories,
      MittwaldApiClient.getInstance().projectFileSystemGetDirectories
    ),

    request: MittwaldApiClient.getInstance().projectFileSystemGetDirectories,
    descriptor: projectFileSystemGetDirectories,
  },

  projectFileSystemGetDiskUsage: {
    getResource: createGetApiOperationResource(
      projectFileSystemGetDiskUsage,
      MittwaldApiClient.getInstance().projectFileSystemGetDiskUsage
    ),

    request: MittwaldApiClient.getInstance().projectFileSystemGetDiskUsage,
    descriptor: projectFileSystemGetDiskUsage,
  },

  projectFileSystemGetFileContent: {
    getResource: createGetApiOperationResource(
      projectFileSystemGetFileContent,
      MittwaldApiClient.getInstance().projectFileSystemGetFileContent
    ),

    request: MittwaldApiClient.getInstance().projectFileSystemGetFileContent,
    descriptor: projectFileSystemGetFileContent,
  },

  projectFileSystemListFiles: {
    getResource: createGetApiOperationResource(
      projectFileSystemListFiles,
      MittwaldApiClient.getInstance().projectFileSystemListFiles
    ),

    request: MittwaldApiClient.getInstance().projectFileSystemListFiles,
    descriptor: projectFileSystemListFiles,
  },

  projectUpdateProjectDescription: {
    getResource: createGetApiOperationResource(
      projectUpdateProjectDescription,
      MittwaldApiClient.getInstance().projectUpdateProjectDescription
    ),

    request: MittwaldApiClient.getInstance().projectUpdateProjectDescription,
    descriptor: projectUpdateProjectDescription,
  },

  fileGetFileUploadTokenRules: {
    getResource: createGetApiOperationResource(
      fileGetFileUploadTokenRules,
      MittwaldApiClient.getInstance().fileGetFileUploadTokenRules
    ),

    request: MittwaldApiClient.getInstance().fileGetFileUploadTokenRules,
    descriptor: fileGetFileUploadTokenRules,
  },

  fileGetFileUploadTypeRules: {
    getResource: createGetApiOperationResource(
      fileGetFileUploadTypeRules,
      MittwaldApiClient.getInstance().fileGetFileUploadTypeRules
    ),

    request: MittwaldApiClient.getInstance().fileGetFileUploadTypeRules,
    descriptor: fileGetFileUploadTypeRules,
  },

  conversationGetConversationMembers: {
    getResource: createGetApiOperationResource(
      conversationGetConversationMembers,
      MittwaldApiClient.getInstance().conversationGetConversationMembers
    ),

    request: MittwaldApiClient.getInstance().conversationGetConversationMembers,
    descriptor: conversationGetConversationMembers,
  },

  conversationGetFileAccessToken: {
    getResource: createGetApiOperationResource(
      conversationGetFileAccessToken,
      MittwaldApiClient.getInstance().conversationGetFileAccessToken
    ),

    request: MittwaldApiClient.getInstance().conversationGetFileAccessToken,
    descriptor: conversationGetFileAccessToken,
  },

  invoiceGetFileAccessToken: {
    getResource: createGetApiOperationResource(
      invoiceGetFileAccessToken,
      MittwaldApiClient.getInstance().invoiceGetFileAccessToken
    ),

    request: MittwaldApiClient.getInstance().invoiceGetFileAccessToken,
    descriptor: invoiceGetFileAccessToken,
  },

  pageinsightsGetStraceData: {
    getResource: createGetApiOperationResource(
      pageinsightsGetStraceData,
      MittwaldApiClient.getInstance().pageinsightsGetStraceData
    ),

    request: MittwaldApiClient.getInstance().pageinsightsGetStraceData,
    descriptor: pageinsightsGetStraceData,
  },

  pageinsightsScheduleStrace: {
    getResource: createGetApiOperationResource(
      pageinsightsScheduleStrace,
      MittwaldApiClient.getInstance().pageinsightsScheduleStrace
    ),

    request: MittwaldApiClient.getInstance().pageinsightsScheduleStrace,
    descriptor: pageinsightsScheduleStrace,
  },

  userAuthenticateWithAccessTokenRetrievalKey: {
    getResource: createGetApiOperationResource(
      userAuthenticateWithAccessTokenRetrievalKey,
      MittwaldApiClient.getInstance()
        .userAuthenticateWithAccessTokenRetrievalKey
    ),

    request:
      MittwaldApiClient.getInstance()
        .userAuthenticateWithAccessTokenRetrievalKey,
    descriptor: userAuthenticateWithAccessTokenRetrievalKey,
  },

  databaseCreateMysqlUser: {
    getResource: createGetApiOperationResource(
      databaseCreateMysqlUser,
      MittwaldApiClient.getInstance().databaseCreateMysqlUser
    ),

    request: MittwaldApiClient.getInstance().databaseCreateMysqlUser,
    descriptor: databaseCreateMysqlUser,
  },

  databaseListMysqlUsers: {
    getResource: createGetApiOperationResource(
      databaseListMysqlUsers,
      MittwaldApiClient.getInstance().databaseListMysqlUsers
    ),

    request: MittwaldApiClient.getInstance().databaseListMysqlUsers,
    descriptor: databaseListMysqlUsers,
  },

  ingressIngressVerifyOwnership: {
    getResource: createGetApiOperationResource(
      ingressIngressVerifyOwnership,
      MittwaldApiClient.getInstance().ingressIngressVerifyOwnership
    ),

    request: MittwaldApiClient.getInstance().ingressIngressVerifyOwnership,
    descriptor: ingressIngressVerifyOwnership,
  },

  mailUpdateProjectMailSetting: {
    getResource: createGetApiOperationResource(
      mailUpdateProjectMailSetting,
      MittwaldApiClient.getInstance().mailUpdateProjectMailSetting
    ),

    request: MittwaldApiClient.getInstance().mailUpdateProjectMailSetting,
    descriptor: mailUpdateProjectMailSetting,
  },

  customerAcceptCustomerInvite: {
    getResource: createGetApiOperationResource(
      customerAcceptCustomerInvite,
      MittwaldApiClient.getInstance().customerAcceptCustomerInvite
    ),

    request: MittwaldApiClient.getInstance().customerAcceptCustomerInvite,
    descriptor: customerAcceptCustomerInvite,
  },

  customerDeclineCustomerInvite: {
    getResource: createGetApiOperationResource(
      customerDeclineCustomerInvite,
      MittwaldApiClient.getInstance().customerDeclineCustomerInvite
    ),

    request: MittwaldApiClient.getInstance().customerDeclineCustomerInvite,
    descriptor: customerDeclineCustomerInvite,
  },

  customerDeleteCustomerInvite: {
    getResource: createGetApiOperationResource(
      customerDeleteCustomerInvite,
      MittwaldApiClient.getInstance().customerDeleteCustomerInvite
    ),

    request: MittwaldApiClient.getInstance().customerDeleteCustomerInvite,
    descriptor: customerDeleteCustomerInvite,
  },

  customerGetCustomerInvite: {
    getResource: createGetApiOperationResource(
      customerGetCustomerInvite,
      MittwaldApiClient.getInstance().customerGetCustomerInvite
    ),

    request: MittwaldApiClient.getInstance().customerGetCustomerInvite,
    descriptor: customerGetCustomerInvite,
  },

  customerDeleteCustomerMembership: {
    getResource: createGetApiOperationResource(
      customerDeleteCustomerMembership,
      MittwaldApiClient.getInstance().customerDeleteCustomerMembership
    ),

    request: MittwaldApiClient.getInstance().customerDeleteCustomerMembership,
    descriptor: customerDeleteCustomerMembership,
  },

  customerGetCustomerMembership: {
    getResource: createGetApiOperationResource(
      customerGetCustomerMembership,
      MittwaldApiClient.getInstance().customerGetCustomerMembership
    ),

    request: MittwaldApiClient.getInstance().customerGetCustomerMembership,
    descriptor: customerGetCustomerMembership,
  },

  customerUpdateCustomerMembership: {
    getResource: createGetApiOperationResource(
      customerUpdateCustomerMembership,
      MittwaldApiClient.getInstance().customerUpdateCustomerMembership
    ),

    request: MittwaldApiClient.getInstance().customerUpdateCustomerMembership,
    descriptor: customerUpdateCustomerMembership,
  },

  customerResendCustomerInviteMail: {
    getResource: createGetApiOperationResource(
      customerResendCustomerInviteMail,
      MittwaldApiClient.getInstance().customerResendCustomerInviteMail
    ),

    request: MittwaldApiClient.getInstance().customerResendCustomerInviteMail,
    descriptor: customerResendCustomerInviteMail,
  },

  projectAcceptProjectInvite: {
    getResource: createGetApiOperationResource(
      projectAcceptProjectInvite,
      MittwaldApiClient.getInstance().projectAcceptProjectInvite
    ),

    request: MittwaldApiClient.getInstance().projectAcceptProjectInvite,
    descriptor: projectAcceptProjectInvite,
  },

  projectDeclineProjectInvite: {
    getResource: createGetApiOperationResource(
      projectDeclineProjectInvite,
      MittwaldApiClient.getInstance().projectDeclineProjectInvite
    ),

    request: MittwaldApiClient.getInstance().projectDeclineProjectInvite,
    descriptor: projectDeclineProjectInvite,
  },

  projectDeleteProjectInvite: {
    getResource: createGetApiOperationResource(
      projectDeleteProjectInvite,
      MittwaldApiClient.getInstance().projectDeleteProjectInvite
    ),

    request: MittwaldApiClient.getInstance().projectDeleteProjectInvite,
    descriptor: projectDeleteProjectInvite,
  },

  projectGetProjectInvite: {
    getResource: createGetApiOperationResource(
      projectGetProjectInvite,
      MittwaldApiClient.getInstance().projectGetProjectInvite
    ),

    request: MittwaldApiClient.getInstance().projectGetProjectInvite,
    descriptor: projectGetProjectInvite,
  },

  projectDeleteProjectMembership: {
    getResource: createGetApiOperationResource(
      projectDeleteProjectMembership,
      MittwaldApiClient.getInstance().projectDeleteProjectMembership
    ),

    request: MittwaldApiClient.getInstance().projectDeleteProjectMembership,
    descriptor: projectDeleteProjectMembership,
  },

  projectGetProjectMembership: {
    getResource: createGetApiOperationResource(
      projectGetProjectMembership,
      MittwaldApiClient.getInstance().projectGetProjectMembership
    ),

    request: MittwaldApiClient.getInstance().projectGetProjectMembership,
    descriptor: projectGetProjectMembership,
  },

  projectUpdateProjectMembership: {
    getResource: createGetApiOperationResource(
      projectUpdateProjectMembership,
      MittwaldApiClient.getInstance().projectUpdateProjectMembership
    ),

    request: MittwaldApiClient.getInstance().projectUpdateProjectMembership,
    descriptor: projectUpdateProjectMembership,
  },

  projectResendProjectInviteMail: {
    getResource: createGetApiOperationResource(
      projectResendProjectInviteMail,
      MittwaldApiClient.getInstance().projectResendProjectInviteMail
    ),

    request: MittwaldApiClient.getInstance().projectResendProjectInviteMail,
    descriptor: projectResendProjectInviteMail,
  },

  appGetInstalledSystemsoftwareForAppinstallation: {
    getResource: createGetApiOperationResource(
      appGetInstalledSystemsoftwareForAppinstallation,
      MittwaldApiClient.getInstance()
        .appGetInstalledSystemsoftwareForAppinstallation
    ),

    request:
      MittwaldApiClient.getInstance()
        .appGetInstalledSystemsoftwareForAppinstallation,
    descriptor: appGetInstalledSystemsoftwareForAppinstallation,
  },

  invoiceDetail: {
    getResource: createGetApiOperationResource(
      invoiceDetail,
      MittwaldApiClient.getInstance().invoiceDetail
    ),

    request: MittwaldApiClient.getInstance().invoiceDetail,
    descriptor: invoiceDetail,
  },

  appRequestAppinstallationCopy: {
    getResource: createGetApiOperationResource(
      appRequestAppinstallationCopy,
      MittwaldApiClient.getInstance().appRequestAppinstallationCopy
    ),

    request: MittwaldApiClient.getInstance().appRequestAppinstallationCopy,
    descriptor: appRequestAppinstallationCopy,
  },

  appSetDatabaseUsers: {
    getResource: createGetApiOperationResource(
      appSetDatabaseUsers,
      MittwaldApiClient.getInstance().appSetDatabaseUsers
    ),

    request: MittwaldApiClient.getInstance().appSetDatabaseUsers,
    descriptor: appSetDatabaseUsers,
  },

  extensionAuthenticateInstance: {
    getResource: createGetApiOperationResource(
      extensionAuthenticateInstance,
      MittwaldApiClient.getInstance().extensionAuthenticateInstance
    ),

    request: MittwaldApiClient.getInstance().extensionAuthenticateInstance,
    descriptor: extensionAuthenticateInstance,
  },

  extensionConsentToExtensionScopes: {
    getResource: createGetApiOperationResource(
      extensionConsentToExtensionScopes,
      MittwaldApiClient.getInstance().extensionConsentToExtensionScopes
    ),

    request: MittwaldApiClient.getInstance().extensionConsentToExtensionScopes,
    descriptor: extensionConsentToExtensionScopes,
  },

  extensionCreateExtensionInstance: {
    getResource: createGetApiOperationResource(
      extensionCreateExtensionInstance,
      MittwaldApiClient.getInstance().extensionCreateExtensionInstance
    ),

    request: MittwaldApiClient.getInstance().extensionCreateExtensionInstance,
    descriptor: extensionCreateExtensionInstance,
  },

  extensionListExtensionInstances: {
    getResource: createGetApiOperationResource(
      extensionListExtensionInstances,
      MittwaldApiClient.getInstance().extensionListExtensionInstances
    ),

    request: MittwaldApiClient.getInstance().extensionListExtensionInstances,
    descriptor: extensionListExtensionInstances,
  },

  extensionDeleteExtensionInstance: {
    getResource: createGetApiOperationResource(
      extensionDeleteExtensionInstance,
      MittwaldApiClient.getInstance().extensionDeleteExtensionInstance
    ),

    request: MittwaldApiClient.getInstance().extensionDeleteExtensionInstance,
    descriptor: extensionDeleteExtensionInstance,
  },

  extensionGetExtensionInstance: {
    getResource: createGetApiOperationResource(
      extensionGetExtensionInstance,
      MittwaldApiClient.getInstance().extensionGetExtensionInstance
    ),

    request: MittwaldApiClient.getInstance().extensionGetExtensionInstance,
    descriptor: extensionGetExtensionInstance,
  },

  extensionDisableExtensionInstance: {
    getResource: createGetApiOperationResource(
      extensionDisableExtensionInstance,
      MittwaldApiClient.getInstance().extensionDisableExtensionInstance
    ),

    request: MittwaldApiClient.getInstance().extensionDisableExtensionInstance,
    descriptor: extensionDisableExtensionInstance,
  },

  extensionEnableExtensionInstance: {
    getResource: createGetApiOperationResource(
      extensionEnableExtensionInstance,
      MittwaldApiClient.getInstance().extensionEnableExtensionInstance
    ),

    request: MittwaldApiClient.getInstance().extensionEnableExtensionInstance,
    descriptor: extensionEnableExtensionInstance,
  },

  extensionGetContributor: {
    getResource: createGetApiOperationResource(
      extensionGetContributor,
      MittwaldApiClient.getInstance().extensionGetContributor
    ),

    request: MittwaldApiClient.getInstance().extensionGetContributor,
    descriptor: extensionGetContributor,
  },

  extensionGetExtension: {
    getResource: createGetApiOperationResource(
      extensionGetExtension,
      MittwaldApiClient.getInstance().extensionGetExtension
    ),

    request: MittwaldApiClient.getInstance().extensionGetExtension,
    descriptor: extensionGetExtension,
  },

  extensionListContributors: {
    getResource: createGetApiOperationResource(
      extensionListContributors,
      MittwaldApiClient.getInstance().extensionListContributors
    ),

    request: MittwaldApiClient.getInstance().extensionListContributors,
    descriptor: extensionListContributors,
  },

  extensionListExtensions: {
    getResource: createGetApiOperationResource(
      extensionListExtensions,
      MittwaldApiClient.getInstance().extensionListExtensions
    ),

    request: MittwaldApiClient.getInstance().extensionListExtensions,
    descriptor: extensionListExtensions,
  },

  userOauthGetAuthorization: {
    getResource: createGetApiOperationResource(
      userOauthGetAuthorization,
      MittwaldApiClient.getInstance().userOauthGetAuthorization
    ),

    request: MittwaldApiClient.getInstance().userOauthGetAuthorization,
    descriptor: userOauthGetAuthorization,
  },

  userOauthRetrieveAccessToken: {
    getResource: createGetApiOperationResource(
      userOauthRetrieveAccessToken,
      MittwaldApiClient.getInstance().userOauthRetrieveAccessToken
    ),

    request: MittwaldApiClient.getInstance().userOauthRetrieveAccessToken,
    descriptor: userOauthRetrieveAccessToken,
  },

  userVerifyPhoneNumber: {
    getResource: createGetApiOperationResource(
      userVerifyPhoneNumber,
      MittwaldApiClient.getInstance().userVerifyPhoneNumber
    ),

    request: MittwaldApiClient.getInstance().userVerifyPhoneNumber,
    descriptor: userVerifyPhoneNumber,
  },

  notificationsCountUnreadNotifications: {
    getResource: createGetApiOperationResource(
      notificationsCountUnreadNotifications,
      MittwaldApiClient.getInstance().notificationsCountUnreadNotifications
    ),

    request:
      MittwaldApiClient.getInstance().notificationsCountUnreadNotifications,
    descriptor: notificationsCountUnreadNotifications,
  },

  fileGetFileWithName: {
    getResource: createGetApiOperationResource(
      fileGetFileWithName,
      MittwaldApiClient.getInstance().fileGetFileWithName
    ),

    request: MittwaldApiClient.getInstance().fileGetFileWithName,
    descriptor: fileGetFileWithName,
  },

  domainCheckDomainTransferability: {
    getResource: createGetApiOperationResource(
      domainCheckDomainTransferability,
      MittwaldApiClient.getInstance().domainCheckDomainTransferability
    ),

    request: MittwaldApiClient.getInstance().domainCheckDomainTransferability,
    descriptor: domainCheckDomainTransferability,
  },

  appListAppinstallationsForUser: {
    getResource: createGetApiOperationResource(
      appListAppinstallationsForUser,
      MittwaldApiClient.getInstance().appListAppinstallationsForUser
    ),

    request: MittwaldApiClient.getInstance().appListAppinstallationsForUser,
    descriptor: appListAppinstallationsForUser,
  },

  domainGetLatestScreenshot: {
    getResource: createGetApiOperationResource(
      domainGetLatestScreenshot,
      MittwaldApiClient.getInstance().domainGetLatestScreenshot
    ),

    request: MittwaldApiClient.getInstance().domainGetLatestScreenshot,
    descriptor: domainGetLatestScreenshot,
  },

  extensionGetPublicKey: {
    getResource: createGetApiOperationResource(
      extensionGetPublicKey,
      MittwaldApiClient.getInstance().extensionGetPublicKey
    ),

    request: MittwaldApiClient.getInstance().extensionGetPublicKey,
    descriptor: extensionGetPublicKey,
  },

  notificationsReadAllNotifications: {
    getResource: createGetApiOperationResource(
      notificationsReadAllNotifications,
      MittwaldApiClient.getInstance().notificationsReadAllNotifications
    ),

    request: MittwaldApiClient.getInstance().notificationsReadAllNotifications,
    descriptor: notificationsReadAllNotifications,
  },

  notificationsReadNotification: {
    getResource: createGetApiOperationResource(
      notificationsReadNotification,
      MittwaldApiClient.getInstance().notificationsReadNotification
    ),

    request: MittwaldApiClient.getInstance().notificationsReadNotification,
    descriptor: notificationsReadNotification,
  },

  userGetPollStatus: {
    getResource: createGetApiOperationResource(
      userGetPollStatus,
      MittwaldApiClient.getInstance().userGetPollStatus
    ),

    request: MittwaldApiClient.getInstance().userGetPollStatus,
    descriptor: userGetPollStatus,
  },

  userPostPollStatus: {
    getResource: createGetApiOperationResource(
      userPostPollStatus,
      MittwaldApiClient.getInstance().userPostPollStatus
    ),

    request: MittwaldApiClient.getInstance().userPostPollStatus,
    descriptor: userPostPollStatus,
  },

  containerValidateContainerRegistryUri: {
    getResource: createGetApiOperationResource(
      containerValidateContainerRegistryUri,
      MittwaldApiClient.getInstance().containerValidateContainerRegistryUri
    ),

    request:
      MittwaldApiClient.getInstance().containerValidateContainerRegistryUri,
    descriptor: containerValidateContainerRegistryUri,
  },

  containerDeleteRegistry: {
    getResource: createGetApiOperationResource(
      containerDeleteRegistry,
      MittwaldApiClient.getInstance().containerDeleteRegistry
    ),

    request: MittwaldApiClient.getInstance().containerDeleteRegistry,
    descriptor: containerDeleteRegistry,
  },

  containerGetRegistry: {
    getResource: createGetApiOperationResource(
      containerGetRegistry,
      MittwaldApiClient.getInstance().containerGetRegistry
    ),

    request: MittwaldApiClient.getInstance().containerGetRegistry,
    descriptor: containerGetRegistry,
  },

  containerUpdateRegistry: {
    getResource: createGetApiOperationResource(
      containerUpdateRegistry,
      MittwaldApiClient.getInstance().containerUpdateRegistry
    ),

    request: MittwaldApiClient.getInstance().containerUpdateRegistry,
    descriptor: containerUpdateRegistry,
  },

  containerGetContainerImageConfig: {
    getResource: createGetApiOperationResource(
      containerGetContainerImageConfig,
      MittwaldApiClient.getInstance().containerGetContainerImageConfig
    ),

    request: MittwaldApiClient.getInstance().containerGetContainerImageConfig,
    descriptor: containerGetContainerImageConfig,
  },

  containerCreateRegistry: {
    getResource: createGetApiOperationResource(
      containerCreateRegistry,
      MittwaldApiClient.getInstance().containerCreateRegistry
    ),

    request: MittwaldApiClient.getInstance().containerCreateRegistry,
    descriptor: containerCreateRegistry,
  },

  containerListRegistries: {
    getResource: createGetApiOperationResource(
      containerListRegistries,
      MittwaldApiClient.getInstance().containerListRegistries
    ),

    request: MittwaldApiClient.getInstance().containerListRegistries,
    descriptor: containerListRegistries,
  },

  containerValidateRegistryCredentials: {
    getResource: createGetApiOperationResource(
      containerValidateRegistryCredentials,
      MittwaldApiClient.getInstance().containerValidateRegistryCredentials
    ),

    request:
      MittwaldApiClient.getInstance().containerValidateRegistryCredentials,
    descriptor: containerValidateRegistryCredentials,
  },

  containerDeleteVolume: {
    getResource: createGetApiOperationResource(
      containerDeleteVolume,
      MittwaldApiClient.getInstance().containerDeleteVolume
    ),

    request: MittwaldApiClient.getInstance().containerDeleteVolume,
    descriptor: containerDeleteVolume,
  },

  containerGetVolume: {
    getResource: createGetApiOperationResource(
      containerGetVolume,
      MittwaldApiClient.getInstance().containerGetVolume
    ),

    request: MittwaldApiClient.getInstance().containerGetVolume,
    descriptor: containerGetVolume,
  },

  containerGetServiceLogs: {
    getResource: createGetApiOperationResource(
      containerGetServiceLogs,
      MittwaldApiClient.getInstance().containerGetServiceLogs
    ),

    request: MittwaldApiClient.getInstance().containerGetServiceLogs,
    descriptor: containerGetServiceLogs,
  },

  containerGetService: {
    getResource: createGetApiOperationResource(
      containerGetService,
      MittwaldApiClient.getInstance().containerGetService
    ),

    request: MittwaldApiClient.getInstance().containerGetService,
    descriptor: containerGetService,
  },

  containerListServices: {
    getResource: createGetApiOperationResource(
      containerListServices,
      MittwaldApiClient.getInstance().containerListServices
    ),

    request: MittwaldApiClient.getInstance().containerListServices,
    descriptor: containerListServices,
  },

  containerListStacks: {
    getResource: createGetApiOperationResource(
      containerListStacks,
      MittwaldApiClient.getInstance().containerListStacks
    ),

    request: MittwaldApiClient.getInstance().containerListStacks,
    descriptor: containerListStacks,
  },

  containerListVolumes: {
    getResource: createGetApiOperationResource(
      containerListVolumes,
      MittwaldApiClient.getInstance().containerListVolumes
    ),

    request: MittwaldApiClient.getInstance().containerListVolumes,
    descriptor: containerListVolumes,
  },

  containerDeclareStack: {
    getResource: createGetApiOperationResource(
      containerDeclareStack,
      MittwaldApiClient.getInstance().containerDeclareStack
    ),

    request: MittwaldApiClient.getInstance().containerDeclareStack,
    descriptor: containerDeclareStack,
  },

  containerGetStack: {
    getResource: createGetApiOperationResource(
      containerGetStack,
      MittwaldApiClient.getInstance().containerGetStack
    ),

    request: MittwaldApiClient.getInstance().containerGetStack,
    descriptor: containerGetStack,
  },

  containerUpdateStack: {
    getResource: createGetApiOperationResource(
      containerUpdateStack,
      MittwaldApiClient.getInstance().containerUpdateStack
    ),

    request: MittwaldApiClient.getInstance().containerUpdateStack,
    descriptor: containerUpdateStack,
  },

  containerRecreateService: {
    getResource: createGetApiOperationResource(
      containerRecreateService,
      MittwaldApiClient.getInstance().containerRecreateService
    ),

    request: MittwaldApiClient.getInstance().containerRecreateService,
    descriptor: containerRecreateService,
  },

  containerRestartService: {
    getResource: createGetApiOperationResource(
      containerRestartService,
      MittwaldApiClient.getInstance().containerRestartService
    ),

    request: MittwaldApiClient.getInstance().containerRestartService,
    descriptor: containerRestartService,
  },

  containerStartService: {
    getResource: createGetApiOperationResource(
      containerStartService,
      MittwaldApiClient.getInstance().containerStartService
    ),

    request: MittwaldApiClient.getInstance().containerStartService,
    descriptor: containerStartService,
  },

  containerStopService: {
    getResource: createGetApiOperationResource(
      containerStopService,
      MittwaldApiClient.getInstance().containerStopService
    ),

    request: MittwaldApiClient.getInstance().containerStopService,
    descriptor: containerStopService,
  },

  extensionCreateRetrievalKey: {
    getResource: createGetApiOperationResource(
      extensionCreateRetrievalKey,
      MittwaldApiClient.getInstance().extensionCreateRetrievalKey
    ),

    request: MittwaldApiClient.getInstance().extensionCreateRetrievalKey,
    descriptor: extensionCreateRetrievalKey,
  },

  contributorRotateSecretForExtensionInstance: {
    getResource: createGetApiOperationResource(
      contributorRotateSecretForExtensionInstance,
      MittwaldApiClient.getInstance()
        .contributorRotateSecretForExtensionInstance
    ),

    request:
      MittwaldApiClient.getInstance()
        .contributorRotateSecretForExtensionInstance,
    descriptor: contributorRotateSecretForExtensionInstance,
  },

  domainSuggest: {
    getResource: createGetApiOperationResource(
      domainSuggest,
      MittwaldApiClient.getInstance().domainSuggest
    ),

    request: MittwaldApiClient.getInstance().domainSuggest,
    descriptor: domainSuggest,
  },

  appReplaceDatabase: {
    getResource: createGetApiOperationResource(
      appReplaceDatabase,
      MittwaldApiClient.getInstance().appReplaceDatabase
    ),

    request: MittwaldApiClient.getInstance().appReplaceDatabase,
    descriptor: appReplaceDatabase,
  },

  contractGetDetailOfContractByCertificate: {
    getResource: createGetApiOperationResource(
      contractGetDetailOfContractByCertificate,
      MittwaldApiClient.getInstance().contractGetDetailOfContractByCertificate
    ),

    request:
      MittwaldApiClient.getInstance().contractGetDetailOfContractByCertificate,
    descriptor: contractGetDetailOfContractByCertificate,
  },

  ingressListIngressesCompatibleWithCertificate: {
    getResource: createGetApiOperationResource(
      ingressListIngressesCompatibleWithCertificate,
      MittwaldApiClient.getInstance()
        .ingressListIngressesCompatibleWithCertificate
    ),

    request:
      MittwaldApiClient.getInstance()
        .ingressListIngressesCompatibleWithCertificate,
    descriptor: ingressListIngressesCompatibleWithCertificate,
  },

  sslCheckReplaceCertificate: {
    getResource: createGetApiOperationResource(
      sslCheckReplaceCertificate,
      MittwaldApiClient.getInstance().sslCheckReplaceCertificate
    ),

    request: MittwaldApiClient.getInstance().sslCheckReplaceCertificate,
    descriptor: sslCheckReplaceCertificate,
  },

  sslCreateCertificateRequest: {
    getResource: createGetApiOperationResource(
      sslCreateCertificateRequest,
      MittwaldApiClient.getInstance().sslCreateCertificateRequest
    ),

    request: MittwaldApiClient.getInstance().sslCreateCertificateRequest,
    descriptor: sslCreateCertificateRequest,
  },

  sslListCertificateRequests: {
    getResource: createGetApiOperationResource(
      sslListCertificateRequests,
      MittwaldApiClient.getInstance().sslListCertificateRequests
    ),

    request: MittwaldApiClient.getInstance().sslListCertificateRequests,
    descriptor: sslListCertificateRequests,
  },

  sslDeleteCertificateRequest: {
    getResource: createGetApiOperationResource(
      sslDeleteCertificateRequest,
      MittwaldApiClient.getInstance().sslDeleteCertificateRequest
    ),

    request: MittwaldApiClient.getInstance().sslDeleteCertificateRequest,
    descriptor: sslDeleteCertificateRequest,
  },

  sslDeleteCertificate: {
    getResource: createGetApiOperationResource(
      sslDeleteCertificate,
      MittwaldApiClient.getInstance().sslDeleteCertificate
    ),

    request: MittwaldApiClient.getInstance().sslDeleteCertificate,
    descriptor: sslDeleteCertificate,
  },

  sslGetCertificateRequest: {
    getResource: createGetApiOperationResource(
      sslGetCertificateRequest,
      MittwaldApiClient.getInstance().sslGetCertificateRequest
    ),

    request: MittwaldApiClient.getInstance().sslGetCertificateRequest,
    descriptor: sslGetCertificateRequest,
  },

  sslGetCertificate: {
    getResource: createGetApiOperationResource(
      sslGetCertificate,
      MittwaldApiClient.getInstance().sslGetCertificate
    ),

    request: MittwaldApiClient.getInstance().sslGetCertificate,
    descriptor: sslGetCertificate,
  },

  sslReplaceCertificate: {
    getResource: createGetApiOperationResource(
      sslReplaceCertificate,
      MittwaldApiClient.getInstance().sslReplaceCertificate
    ),

    request: MittwaldApiClient.getInstance().sslReplaceCertificate,
    descriptor: sslReplaceCertificate,
  },

  sslListCertificates: {
    getResource: createGetApiOperationResource(
      sslListCertificates,
      MittwaldApiClient.getInstance().sslListCertificates
    ),

    request: MittwaldApiClient.getInstance().sslListCertificates,
    descriptor: sslListCertificates,
  },

  sslSetCertificateRequestCertificate: {
    getResource: createGetApiOperationResource(
      sslSetCertificateRequestCertificate,
      MittwaldApiClient.getInstance().sslSetCertificateRequestCertificate
    ),

    request:
      MittwaldApiClient.getInstance().sslSetCertificateRequestCertificate,
    descriptor: sslSetCertificateRequestCertificate,
  },

  extensionDryRunWebhook: {
    getResource: createGetApiOperationResource(
      extensionDryRunWebhook,
      MittwaldApiClient.getInstance().extensionDryRunWebhook
    ),

    request: MittwaldApiClient.getInstance().extensionDryRunWebhook,
    descriptor: extensionDryRunWebhook,
  },

  storagespaceReplaceProjectNotificationThreshold: {
    getResource: createGetApiOperationResource(
      storagespaceReplaceProjectNotificationThreshold,
      MittwaldApiClient.getInstance()
        .storagespaceReplaceProjectNotificationThreshold
    ),

    request:
      MittwaldApiClient.getInstance()
        .storagespaceReplaceProjectNotificationThreshold,
    descriptor: storagespaceReplaceProjectNotificationThreshold,
  },

  storagespaceGetProjectStatistics: {
    getResource: createGetApiOperationResource(
      storagespaceGetProjectStatistics,
      MittwaldApiClient.getInstance().storagespaceGetProjectStatistics
    ),

    request: MittwaldApiClient.getInstance().storagespaceGetProjectStatistics,
    descriptor: storagespaceGetProjectStatistics,
  },

  storagespaceGetServerStatistics: {
    getResource: createGetApiOperationResource(
      storagespaceGetServerStatistics,
      MittwaldApiClient.getInstance().storagespaceGetServerStatistics
    ),

    request: MittwaldApiClient.getInstance().storagespaceGetServerStatistics,
    descriptor: storagespaceGetServerStatistics,
  },

  storagespaceReplaceServerNotificationThreshold: {
    getResource: createGetApiOperationResource(
      storagespaceReplaceServerNotificationThreshold,
      MittwaldApiClient.getInstance()
        .storagespaceReplaceServerNotificationThreshold
    ),

    request:
      MittwaldApiClient.getInstance()
        .storagespaceReplaceServerNotificationThreshold,
    descriptor: storagespaceReplaceServerNotificationThreshold,
  },

  cronjobAbortExecution: {
    getResource: createGetApiOperationResource(
      cronjobAbortExecution,
      MittwaldApiClient.getInstance().cronjobAbortExecution
    ),

    request: MittwaldApiClient.getInstance().cronjobAbortExecution,
    descriptor: cronjobAbortExecution,
  },

  extensionGetExtensionInstanceForCustomer: {
    getResource: createGetApiOperationResource(
      extensionGetExtensionInstanceForCustomer,
      MittwaldApiClient.getInstance().extensionGetExtensionInstanceForCustomer
    ),

    request:
      MittwaldApiClient.getInstance().extensionGetExtensionInstanceForCustomer,
    descriptor: extensionGetExtensionInstanceForCustomer,
  },

  extensionGetExtensionInstanceForProject: {
    getResource: createGetApiOperationResource(
      extensionGetExtensionInstanceForProject,
      MittwaldApiClient.getInstance().extensionGetExtensionInstanceForProject
    ),

    request:
      MittwaldApiClient.getInstance().extensionGetExtensionInstanceForProject,
    descriptor: extensionGetExtensionInstanceForProject,
  },

  extensionListOwnExtensions: {
    getResource: createGetApiOperationResource(
      extensionListOwnExtensions,
      MittwaldApiClient.getInstance().extensionListOwnExtensions
    ),

    request: MittwaldApiClient.getInstance().extensionListOwnExtensions,
    descriptor: extensionListOwnExtensions,
  },

  extensionRegisterExtension: {
    getResource: createGetApiOperationResource(
      extensionRegisterExtension,
      MittwaldApiClient.getInstance().extensionRegisterExtension
    ),

    request: MittwaldApiClient.getInstance().extensionRegisterExtension,
    descriptor: extensionRegisterExtension,
  },

  extensionDeleteExtension: {
    getResource: createGetApiOperationResource(
      extensionDeleteExtension,
      MittwaldApiClient.getInstance().extensionDeleteExtension
    ),

    request: MittwaldApiClient.getInstance().extensionDeleteExtension,
    descriptor: extensionDeleteExtension,
  },

  extensionGetOwnExtension: {
    getResource: createGetApiOperationResource(
      extensionGetOwnExtension,
      MittwaldApiClient.getInstance().extensionGetOwnExtension
    ),

    request: MittwaldApiClient.getInstance().extensionGetOwnExtension,
    descriptor: extensionGetOwnExtension,
  },

  extensionPatchExtension: {
    getResource: createGetApiOperationResource(
      extensionPatchExtension,
      MittwaldApiClient.getInstance().extensionPatchExtension
    ),

    request: MittwaldApiClient.getInstance().extensionPatchExtension,
    descriptor: extensionPatchExtension,
  },

  leadfyndrGetLead: {
    getResource: createGetApiOperationResource(
      leadfyndrGetLead,
      MittwaldApiClient.getInstance().leadfyndrGetLead
    ),

    request: MittwaldApiClient.getInstance().leadfyndrGetLead,
    descriptor: leadfyndrGetLead,
  },

  leadfyndrGetUnlockedLead: {
    getResource: createGetApiOperationResource(
      leadfyndrGetUnlockedLead,
      MittwaldApiClient.getInstance().leadfyndrGetUnlockedLead
    ),

    request: MittwaldApiClient.getInstance().leadfyndrGetUnlockedLead,
    descriptor: leadfyndrGetUnlockedLead,
  },

  leadfyndrUnlockLead: {
    getResource: createGetApiOperationResource(
      leadfyndrUnlockLead,
      MittwaldApiClient.getInstance().leadfyndrUnlockLead
    ),

    request: MittwaldApiClient.getInstance().leadfyndrUnlockLead,
    descriptor: leadfyndrUnlockLead,
  },

  leadfyndrListLeads: {
    getResource: createGetApiOperationResource(
      leadfyndrListLeads,
      MittwaldApiClient.getInstance().leadfyndrListLeads
    ),

    request: MittwaldApiClient.getInstance().leadfyndrListLeads,
    descriptor: leadfyndrListLeads,
  },

  leadfyndrListUnlockedLeads: {
    getResource: createGetApiOperationResource(
      leadfyndrListUnlockedLeads,
      MittwaldApiClient.getInstance().leadfyndrListUnlockedLeads
    ),

    request: MittwaldApiClient.getInstance().leadfyndrListUnlockedLeads,
    descriptor: leadfyndrListUnlockedLeads,
  },

  extensionGenerateSessionToken: {
    getResource: createGetApiOperationResource(
      extensionGenerateSessionToken,
      MittwaldApiClient.getInstance().extensionGenerateSessionToken
    ),

    request: MittwaldApiClient.getInstance().extensionGenerateSessionToken,
    descriptor: extensionGenerateSessionToken,
  },

  customerCreateRecommendationSuggestion: {
    getResource: createGetApiOperationResource(
      customerCreateRecommendationSuggestion,
      MittwaldApiClient.getInstance().customerCreateRecommendationSuggestion
    ),

    request:
      MittwaldApiClient.getInstance().customerCreateRecommendationSuggestion,
    descriptor: customerCreateRecommendationSuggestion,
  },

  customerCreateWallet: {
    getResource: createGetApiOperationResource(
      customerCreateWallet,
      MittwaldApiClient.getInstance().customerCreateWallet
    ),

    request: MittwaldApiClient.getInstance().customerCreateWallet,
    descriptor: customerCreateWallet,
  },

  customerGetWallet: {
    getResource: createGetApiOperationResource(
      customerGetWallet,
      MittwaldApiClient.getInstance().customerGetWallet
    ),

    request: MittwaldApiClient.getInstance().customerGetWallet,
    descriptor: customerGetWallet,
  },

  containerPullImageForService: {
    getResource: createGetApiOperationResource(
      containerPullImageForService,
      MittwaldApiClient.getInstance().containerPullImageForService
    ),

    request: MittwaldApiClient.getInstance().containerPullImageForService,
    descriptor: containerPullImageForService,
  },

  leadfyndrRemoveUnlockedLeadReservation: {
    getResource: createGetApiOperationResource(
      leadfyndrRemoveUnlockedLeadReservation,
      MittwaldApiClient.getInstance().leadfyndrRemoveUnlockedLeadReservation
    ),

    request:
      MittwaldApiClient.getInstance().leadfyndrRemoveUnlockedLeadReservation,
    descriptor: leadfyndrRemoveUnlockedLeadReservation,
  },

  leadfyndrReserveUnlockedLead: {
    getResource: createGetApiOperationResource(
      leadfyndrReserveUnlockedLead,
      MittwaldApiClient.getInstance().leadfyndrReserveUnlockedLead
    ),

    request: MittwaldApiClient.getInstance().leadfyndrReserveUnlockedLead,
    descriptor: leadfyndrReserveUnlockedLead,
  },

  extensionStartExtensionCheckout: {
    getResource: createGetApiOperationResource(
      extensionStartExtensionCheckout,
      MittwaldApiClient.getInstance().extensionStartExtensionCheckout
    ),

    request: MittwaldApiClient.getInstance().extensionStartExtensionCheckout,
    descriptor: extensionStartExtensionCheckout,
  },

  extensionCancelExtensionTermination: {
    getResource: createGetApiOperationResource(
      extensionCancelExtensionTermination,
      MittwaldApiClient.getInstance().extensionCancelExtensionTermination
    ),

    request:
      MittwaldApiClient.getInstance().extensionCancelExtensionTermination,
    descriptor: extensionCancelExtensionTermination,
  },

  extensionScheduleExtensionTermination: {
    getResource: createGetApiOperationResource(
      extensionScheduleExtensionTermination,
      MittwaldApiClient.getInstance().extensionScheduleExtensionTermination
    ),

    request:
      MittwaldApiClient.getInstance().extensionScheduleExtensionTermination,
    descriptor: extensionScheduleExtensionTermination,
  },

  contributorGetBillingInformation: {
    getResource: createGetApiOperationResource(
      contributorGetBillingInformation,
      MittwaldApiClient.getInstance().contributorGetBillingInformation
    ),

    request: MittwaldApiClient.getInstance().contributorGetBillingInformation,
    descriptor: contributorGetBillingInformation,
  },

  contributorGetLoginLink: {
    getResource: createGetApiOperationResource(
      contributorGetLoginLink,
      MittwaldApiClient.getInstance().contributorGetLoginLink
    ),

    request: MittwaldApiClient.getInstance().contributorGetLoginLink,
    descriptor: contributorGetLoginLink,
  },

  contributorListIncomingInvoices: {
    getResource: createGetApiOperationResource(
      contributorListIncomingInvoices,
      MittwaldApiClient.getInstance().contributorListIncomingInvoices
    ),

    request: MittwaldApiClient.getInstance().contributorListIncomingInvoices,
    descriptor: contributorListIncomingInvoices,
  },

  contributorListOnbehalfInvoices: {
    getResource: createGetApiOperationResource(
      contributorListOnbehalfInvoices,
      MittwaldApiClient.getInstance().contributorListOnbehalfInvoices
    ),

    request: MittwaldApiClient.getInstance().contributorListOnbehalfInvoices,
    descriptor: contributorListOnbehalfInvoices,
  },

  contributorReceiptGetFileAccessToken: {
    getResource: createGetApiOperationResource(
      contributorReceiptGetFileAccessToken,
      MittwaldApiClient.getInstance().contributorReceiptGetFileAccessToken
    ),

    request:
      MittwaldApiClient.getInstance().contributorReceiptGetFileAccessToken,
    descriptor: contributorReceiptGetFileAccessToken,
  },

  extensionChangeContext: {
    getResource: createGetApiOperationResource(
      extensionChangeContext,
      MittwaldApiClient.getInstance().extensionChangeContext
    ),

    request: MittwaldApiClient.getInstance().extensionChangeContext,
    descriptor: extensionChangeContext,
  },

  extensionCreateContributorOnboardingProcess: {
    getResource: createGetApiOperationResource(
      extensionCreateContributorOnboardingProcess,
      MittwaldApiClient.getInstance()
        .extensionCreateContributorOnboardingProcess
    ),

    request:
      MittwaldApiClient.getInstance()
        .extensionCreateContributorOnboardingProcess,
    descriptor: extensionCreateContributorOnboardingProcess,
  },

  extensionRemoveAsset: {
    getResource: createGetApiOperationResource(
      extensionRemoveAsset,
      MittwaldApiClient.getInstance().extensionRemoveAsset
    ),

    request: MittwaldApiClient.getInstance().extensionRemoveAsset,
    descriptor: extensionRemoveAsset,
  },

  extensionRemoveLogo: {
    getResource: createGetApiOperationResource(
      extensionRemoveLogo,
      MittwaldApiClient.getInstance().extensionRemoveLogo
    ),

    request: MittwaldApiClient.getInstance().extensionRemoveLogo,
    descriptor: extensionRemoveLogo,
  },

  extensionRequestLogoUpload: {
    getResource: createGetApiOperationResource(
      extensionRequestLogoUpload,
      MittwaldApiClient.getInstance().extensionRequestLogoUpload
    ),

    request: MittwaldApiClient.getInstance().extensionRequestLogoUpload,
    descriptor: extensionRequestLogoUpload,
  },

  extensionRequestAssetUpload: {
    getResource: createGetApiOperationResource(
      extensionRequestAssetUpload,
      MittwaldApiClient.getInstance().extensionRequestAssetUpload
    ),

    request: MittwaldApiClient.getInstance().extensionRequestAssetUpload,
    descriptor: extensionRequestAssetUpload,
  },

  extensionRequestExtensionVerification: {
    getResource: createGetApiOperationResource(
      extensionRequestExtensionVerification,
      MittwaldApiClient.getInstance().extensionRequestExtensionVerification
    ),

    request:
      MittwaldApiClient.getInstance().extensionRequestExtensionVerification,
    descriptor: extensionRequestExtensionVerification,
  },

  extensionSetExtensionPublishedState: {
    getResource: createGetApiOperationResource(
      extensionSetExtensionPublishedState,
      MittwaldApiClient.getInstance().extensionSetExtensionPublishedState
    ),

    request:
      MittwaldApiClient.getInstance().extensionSetExtensionPublishedState,
    descriptor: extensionSetExtensionPublishedState,
  },

  extensionGetExtensionInstanceContract: {
    getResource: createGetApiOperationResource(
      extensionGetExtensionInstanceContract,
      MittwaldApiClient.getInstance().extensionGetExtensionInstanceContract
    ),

    request:
      MittwaldApiClient.getInstance().extensionGetExtensionInstanceContract,
    descriptor: extensionGetExtensionInstanceContract,
  },

  extensionUpdateExtensionInstanceContract: {
    getResource: createGetApiOperationResource(
      extensionUpdateExtensionInstanceContract,
      MittwaldApiClient.getInstance().extensionUpdateExtensionInstanceContract
    ),

    request:
      MittwaldApiClient.getInstance().extensionUpdateExtensionInstanceContract,
    descriptor: extensionUpdateExtensionInstanceContract,
  },

  extensionUpdateExtensionPricing: {
    getResource: createGetApiOperationResource(
      extensionUpdateExtensionPricing,
      MittwaldApiClient.getInstance().extensionUpdateExtensionPricing
    ),

    request: MittwaldApiClient.getInstance().extensionUpdateExtensionPricing,
    descriptor: extensionUpdateExtensionPricing,
  },

  contributorGetCustomerBillingPortalLink: {
    getResource: createGetApiOperationResource(
      contributorGetCustomerBillingPortalLink,
      MittwaldApiClient.getInstance().contributorGetCustomerBillingPortalLink
    ),

    request:
      MittwaldApiClient.getInstance().contributorGetCustomerBillingPortalLink,
    descriptor: contributorGetCustomerBillingPortalLink,
  },

  marketplaceCustomerUpdatePaymentMethod: {
    getResource: createGetApiOperationResource(
      marketplaceCustomerUpdatePaymentMethod,
      MittwaldApiClient.getInstance().marketplaceCustomerUpdatePaymentMethod
    ),

    request:
      MittwaldApiClient.getInstance().marketplaceCustomerUpdatePaymentMethod,
    descriptor: marketplaceCustomerUpdatePaymentMethod,
  },

  marketplaceCustomerGetPaymentMethod: {
    getResource: createGetApiOperationResource(
      marketplaceCustomerGetPaymentMethod,
      MittwaldApiClient.getInstance().marketplaceCustomerGetPaymentMethod
    ),

    request:
      MittwaldApiClient.getInstance().marketplaceCustomerGetPaymentMethod,
    descriptor: marketplaceCustomerGetPaymentMethod,
  },

  extensionOrderExtension: {
    getResource: createGetApiOperationResource(
      extensionOrderExtension,
      MittwaldApiClient.getInstance().extensionOrderExtension
    ),

    request: MittwaldApiClient.getInstance().extensionOrderExtension,
    descriptor: extensionOrderExtension,
  },

  extensionGetCustomerExtensionInstanceOrders: {
    getResource: createGetApiOperationResource(
      extensionGetCustomerExtensionInstanceOrders,
      MittwaldApiClient.getInstance()
        .extensionGetCustomerExtensionInstanceOrders
    ),

    request:
      MittwaldApiClient.getInstance()
        .extensionGetCustomerExtensionInstanceOrders,
    descriptor: extensionGetCustomerExtensionInstanceOrders,
  },

  extensionGetProjectExtensionInstanceOrders: {
    getResource: createGetApiOperationResource(
      extensionGetProjectExtensionInstanceOrders,
      MittwaldApiClient.getInstance().extensionGetProjectExtensionInstanceOrders
    ),

    request:
      MittwaldApiClient.getInstance()
        .extensionGetProjectExtensionInstanceOrders,
    descriptor: extensionGetProjectExtensionInstanceOrders,
  },

  leadfyndrGetLeadFyndrProfileRequest: {
    getResource: createGetApiOperationResource(
      leadfyndrGetLeadFyndrProfileRequest,
      MittwaldApiClient.getInstance().leadfyndrGetLeadFyndrProfileRequest
    ),

    request:
      MittwaldApiClient.getInstance().leadfyndrGetLeadFyndrProfileRequest,
    descriptor: leadfyndrGetLeadFyndrProfileRequest,
  },

  leadfyndrCreateLeadFyndrAccessRequest: {
    getResource: createGetApiOperationResource(
      leadfyndrCreateLeadFyndrAccessRequest,
      MittwaldApiClient.getInstance().leadfyndrCreateLeadFyndrAccessRequest
    ),

    request:
      MittwaldApiClient.getInstance().leadfyndrCreateLeadFyndrAccessRequest,
    descriptor: leadfyndrCreateLeadFyndrAccessRequest,
  },

  leadfyndrGetLeadFyndrProfile: {
    getResource: createGetApiOperationResource(
      leadfyndrGetLeadFyndrProfile,
      MittwaldApiClient.getInstance().leadfyndrGetLeadFyndrProfile
    ),

    request: MittwaldApiClient.getInstance().leadfyndrGetLeadFyndrProfile,
    descriptor: leadfyndrGetLeadFyndrProfile,
  },

  leadfyndrGetLeadFyndrProfileTariffOptions: {
    getResource: createGetApiOperationResource(
      leadfyndrGetLeadFyndrProfileTariffOptions,
      MittwaldApiClient.getInstance().leadfyndrGetLeadFyndrProfileTariffOptions
    ),

    request:
      MittwaldApiClient.getInstance().leadfyndrGetLeadFyndrProfileTariffOptions,
    descriptor: leadfyndrGetLeadFyndrProfileTariffOptions,
  },
};
